// Offertes.js
// vOFF-164 - 12pt afstand tussen opeenvolgende losse tekstregels uit Projectbeheer in bewerken, voorbeeld en PDF.
// vOFF-163 - Aanhef krijgt dezelfde 12pt onderruimte als overige sjabloonblokken in voorbeeld en PDF.
// vOFF-162 - 12pt afstand na projecttekst vóór artikelkop; dubbele komma in automatische aanhef voorkomen.
// vOFF-161 - Basis v159; projectteksten tonen zonder selectie; uniforme ruimte voor eerste artikelkop.
// vOFF-159 - Handmatige paginaovergangen in PDF versterkt; tekstblokken en artikelregels mogen doorlopen; 12pt ruimte tussen tekstblokken.
// vOFF-158 - Projectonderdelen zonder Offertetekst weer toestaan; projectnaam als omschrijving.
// vOFF-157 - Subtotaal, Totaal en Voor akkoord op Calibri 11 pt in voorbeeld en PDF; overige functies ongewijzigd.
// vOFF-156 - Legacy FONT size=3 consequent als 11 pt normaliseren; overige opmaak en functies intact.
// vOFF-155 - Documentbasis Calibri 11 pt / 1,15 in PDF en scherm; bestaande specifieke opmaak behouden.
// vOFF-154 - Vaste documentvelden met een gedeelde 11pt-regel, ook bij PDF-rendering; overige documentopmaak behouden.
// vOFF-153 - Vaste documentvelden uniform 11pt in bewerken, voorbeeld en PDF.
// vOFF-149
// - Verplichte zichtbare omschrijving voor Artikel; lege HTML zoals <br> wordt afgekeurd bij handmatige invoer en projectovername.
// - Bulk-projectkeuze vooraf valideren; oudere lege artikelregels blokkeren Goedkeuren en Opdracht→Factuur vóór statuswijziging.
// - Kolomkoppen worden maximaal eenmaal weergegeven, ook na een verplaatste tekstregel.
// - Opdracht -> Factuur volgt de opgeslagen documentvolgorde van de regels, inclusief Tekst tussen Artikelen.
// - Financiele berekeningen, sjablonen en akkoordprocedures ongewijzigd.
// vOFF-147
// - Alleen Artikel/Tekst bij nieuwe en bewerkte regels; Projectbeheer-import met historische overige typen wordt Tekst.
// - Oude offerte-/opdrachtregels blijven intern intact en leesbaar; PDF, totalen en akkoordfuncties ongewijzigd.
// vOFF-146
// - Offertes/Opdrachten: negatieve artikelprijzen (kortingen) toestaan bij invoer, opslaan en voorlopige totalen; btw en factuurdoorvoer blijven correct.
// - Overige document- en e-mailfunctionaliteit ongewijzigd.
// vOFF-145
// - E-mail offerte/opdracht gebruikt vrije Referentie i.p.v. intern documentnummer in communicatiesjablonen; oude code {document_nummer} blijft als alias werken.
// - Offertenummer, PDF, verzending, prijscalculatie en documentinhoud ongewijzigd.
// vOFF-144
// - Overname Projectbeheer: bewust ingevoerde blanco beginregels van Offertetekst blijven behouden in Offerte/Opdracht en PDF.
// - Omschrijvingen behouden hun bestaande tekstwitruimte ook bij bewerken en opnieuw opslaan; compacte projectregelopmaak ongewijzigd.
// vOFF-143
// - Ctrl+V in opgemaakte offerte-/opdrachtteksten plakt uitsluitend schone tekst (Word/Outlook-opmaak verwijderd).
// - Bestaande tekst, PDF, paginaovergangen, berekeningen en overige invoer ongewijzigd.
// vOFF-142
// - Handmatige paginaovergang na ieder sjabloonblok of (project)offerteregel, ook met Ctrl+Enter.
// - Paginaovergang bewaard in document_order; PDF start volgend onderdeel op nieuwe pagina; bestaande offertegegevens ongewijzigd.
// vOFF-141
// - Handmatig ingevoerde lege beginregels in offerte-/opdrachttekst blijven bewaard na Opslaan en in PDF.
// - Projecttekstregels compacter (alinea-afstanden en regelhoogte), zonder wijzigingen aan Footer of berekeningen.
// vOFF-140
// - Bewerken: actiekolom verbreed zodat bedragen in Totaal voldoende afstand tot sleep-/bewerkknoppen hebben; PDF/Voorbeeld ongewijzigd.
// vOFF-139
// - Klantcontactgegevens optioneel onder adres via gedeelde bedrijfscode-instellingen briefpapier.
// - Offerte-/opdrachttabel zonder btw-kolom en kolomtitel Bedrag; btw blijft bij regels bewerkbaar en in totaalberekening.
// - Totalen direct aansluitend, lege footer/scheidingslijn aan documenteinde verwijderd.
// vOFF-138
// - Onderwerp uit offertesjabloon behoudt rich-text-opmaak in Bewerken, Voorbeeld en PDF.
// - Calibri 11 pt als standaard voor documenttekst en nieuwe editorinhoud; bestaande expliciete opmaak behouden.
// vOFF-137
// - FIX: Aanhef in Bewerken toont de relationele invulling; bij opmaak of bewerken blijft {aanhef} in de opgeslagen tekst behouden.
// - Zelf ingevoerde aanhef blijft gewoon als eigen tekst bewerkbaar; PDF/Voorbeeld en overige velden ongewijzigd.
// vOFF-136
// - FIX: veld Referentie gebruikt offers.reference, niet het unieke offer_number/invoice_number.
// - Oude referenties in offer_number blijven leesbaar; bestaande documentnummers worden niet veranderd.
// - Referentie wordt ook bij popup-opslag, statuswijziging en facturatie-overgang doorgegeven.
// vOFF-135
// - Aanhef uit Relaties ook bij afdrukken/PDF betrouwbaar vervangen (incl. automatische fallback).
// - Projecttekstregels zonder scheidingslijn; compacte alinea's gelijk in bewerken en voorbeeld.
// - Printen opent de door StaffIQ gegenereerde PDF (zonder browserkop/-voetteksten).
// - Rich-text: selectie behouden bij overstap van editor naar opmaakmenu.
// vOFF-134
// - Sjabloon {aanhef} (ook bij blanco) uit Relaties; spaties rond invulcode toegestaan.
// - Projectteksten en artikelregels compacter zonder onbedoelde marges/scheidingslijnen.
// - Popup boven/onder: AI, Voorbeeld, Opslaan, Opslaan/Sluiten, Annuleren; opslag blijft open tenzij Sluiten gekozen.
// vOFF-133
// - Eenheid direct wijzigbaar in Offerte: duidelijk invoerveld en focus bij potloodje/kolomklik.
// - Bij Projectonderdelen toevoegen altijd actuele lijst en detail (incl. Eenheid) ophalen; serveropslag controleren.
// - Ontbrekende Eenheid of verouderde server meldt dit expliciet, zonder te gokken of andere modules te wijzigen.
// vOFF-132
// - Eenheid per offerteregel opgeslagen/getoond; projecteenheid overgenomen, breedtes aangepast.
// - HTML-entiteiten en onbedoelde lege eerste regels hersteld; {aanhef} vult aanhef uit Relaties in het voorbeeld in.
// vOFF-131
// - Eigen briefpapier: Bewerken toont geen briefpapierachtergrond meer; het briefpapier is alleen zichtbaar in het echte PDF-Voorbeeld/afdruk.
// - Eigen briefpapier: afdrukinhoud begint 6 mm lager zodat klantgegevens en documentinhoud vrij onder de voorgedrukte kop starten.
// vOFF-130
// - Eigen briefpapier: Voorbeeld toont nu de echte server-gerenderde PDF; pagina-einden, briefpapier en afdrukweergave zijn daardoor gelijk.
// - Eigen briefpapier: actieknoppen in Bewerken zijn niet meer sticky en scrollen dus niet meer over de documentinhoud.
// vOFF-129
// - Eigen briefpapier: schermweergave terug op groot documentformaat zoals voorheen, met zichtbaar paginakader en actieknoppen op het document die bovenin zichtbaar blijven.
// - Eigen briefpapier: printopbouw hersteld met volledige A4-achtergrond en gereserveerde kop/voetzones per afdrukpagina.
// vOFF-128
// - Eigen briefpapier: bovenste actieknoppen blijven vast in beeld tijdens scrollen; schermweergave toont alleen de briefpapierkop en houdt de documenttekst daaronder vrij.
// - Eigen briefpapier: herhalende achtergrond in Bewerken/Voorbeeld verwijderd om tekst niet meer over kop- en voettekstlijnen te laten lopen; printopbouw blijft ongewijzigd.
// vOFF-127
// - Eigen briefpapier: schermweergave Offerte/Opdracht nu als echte A4-pagina; knoppen staan buiten het briefpapier en de inhoud blijft vrij van kop/voet.
// - Eigen briefpapier: printmarges reserveren de voorgedrukte kop en voet op iedere pagina.
// vOFF-126
// - Eigen briefpapier: Offerte/Opdracht gebruikt geupload A4-briefpapier als achtergrond; standaard logo/bedrijfsgegevens/voettekst worden dan niet dubbel afgedrukt.
// Sjabloonrubrieken met 'Tonen' uit Instellingen worden per offerte overgenomen en verborgen indien uitgeschakeld.
// - FIX: gekozen opmaak in een leeg tekstveld blijft actief tijdens het typen.
// - FIX tekstverwerker: in een leeg tekstveld kan vooraf opmaak worden gekozen; bij bestaande tekst blijft selectie verplicht.
// - Tekstverwerker gelijkgetrokken met Projectbeheer vPRJ-052: alleen geselecteerde tekst opmaken; gemengde/geen uniforme waarden tonen —; zonder selectie geen opmaakwijziging.
// - FIX v120: Een ander sjabloon kiezen is tijdelijk; pas Opslaan/Opslaan-Sluiten legt het nieuwe sjabloon en de sjabloonteksten vast. Annuleren herstelt de opgeslagen offerte.
// - FIX v119: Sluiten vanuit Voorbeeld/Voortgang offerte keert terug naar Opdracht (Offerte) in plaats van de popup af te sluiten
// - FIX v118: Zoeken bij Projectonderdelen doorzoekt alle niveaus, ook ingeklapte onderdelen
// - FIX v117: Projectonderdelen uit-/inklappen blijft werken tijdens Zoeken
// - Sleepfunctie verfijnd: één ↕-handvat voor regels en sjabloonblokken
// - Automatisch scrollen tijdens slepen bij boven- en onderrand van het offertevenster
// - Drop-positie boven/onder doelregel gecorrigeerd voor soepel verplaatsen
// - Sleepfunctie hersteld voor gezamenlijke documentvolgorde
// - Regels én sjabloonblokken kunnen nu worden gesleept en met pijlen verplaatst
// - Opmaakbalk bij artikel-/projectregels hersteld
// - Lettertype, grootte, regelafstand, vet, cursief en onderstrepen weer beschikbaar tijdens regelbewerking
// - FIX: bestaande renderOfferHeader-functie uit v109 hersteld
// - drie header-aanroepen weer gekoppeld aan renderOfferHeader
// - FIX: verkeerde functienaam renderOfferHeader gecorrigeerd naar bestaande renderHeader
// - gezamenlijke volgorde sjabloonblokken en offerteregels
// - beide soorten onderdelen kunnen met pijlen door elkaar worden verplaatst
// - FIX: Relaties in de keuzelijst bij Nieuwe Offerte/Opdracht staan alfabetisch op Zoeknaam
// - FIX: ook een nieuwe offerte zonder offerteregels kan nu automatisch als document worden opgeslagen
// - FIX: bullets en nummering uit sjablonen worden nu ook zichtbaar gerenderd in offerte en voorbeeld
// - Bullets en genummerde lijsten uit sjablonen blijven nu behouden in offerte, voorbeeld en PDF
// - Tijdens het bewerken van een offerte/opdracht kan nu direct worden geschakeld naar een schone Voorbeeldweergave en weer terug naar Bewerken
// - Opmaakbalk arceert nu Vet, Cursief en Onderstrepen wanneer deze opmaak actief is
// - Opmaakbalk toont nu het gekozen/actieve lettertype en de gekozen/actieve tekstgrootte
// - Opslaan maakt/bijwerkt nu automatisch de actuele Offerte/Opdracht-PDF in Documenten
// - Projectselectie in Offertes/Opdrachten werkt nu als Projectbeheer: standaard alleen hoofdniveau, met uitklappen per onderdeel
// - UI: label 'Datum' in de rechter invoerkolom gewijzigd in 'Offertedatum'
// - Opdrachten gebruiken nu de eigen MKB-opdrachtinstellingen voor documentkop, bedrijfsgegevens, intro, footer en communicatie
// - Projectselectie toont optioneel Offertetekst en/of Interne tekst onder geselecteerde onderdelen
// - Ter akkoord-knop wordt uitgegrijsd als relatie geen akkoord via WhatsApp/E-mail toestaat
// - WhatsApp opent op mobiel directer via de WhatsApp-app-link
// - E-mailmelding toont nu duidelijker het serverresultaat
// - Digitale akkoordmodule gekoppeld aan Offertes/Opdrachten
// - Knop "Ter akkoord" in voorbeeldpopup
// - Voorkeur WhatsApp/E-mail vanuit relatie wordt gebruikt
// - FIX: selectedInvoiceRow vóór gebruik geïnitialiseerd
// - Akkoordmelding wordt ook gewist bij Opslaan en Verwijderen
// - Offerteregels kunnen in de popup worden versleept/verplaatst
// - FIX: bij inclusief-btw-instelling wordt een handmatig ingevoerd bedrag als inclusief btw verwerkt
// - FIX: opdrachten blijven bewerkbaar tot omzetting naar factuur; verwijderen blijft beperkt tot offertes
// - DOSSIER: openen met organisation_id filter vanuit Relaties.
//
// Layout + UX afgestemd op Organisaties/Contactpersonen/Notities:
// - Links: zoek + knoppen
// - Midden: overzicht (met kolomfilters per kolom)
// - Rechts: details geselecteerde offerte
//
// Belangrijk:
// - Voor adres op offerte: correspondentieadres van de organisatie (ophalen via /api/organisations/:id)
//
// Verwachtte API's (server.js):
// - GET    /api/offers?q=...
// - GET    /api/offers/:id
// - POST   /api/offers
// - PUT    /api/offers/:id
// - DELETE /api/offers/:id
// - GET    /api/organisations
// - GET    /api/organisations/:id
// - GET    /api/contacts?organisation_id=...

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useVoiceCommands from "../components/useVoiceCommands";
import HelpButton from "../components/HelpButton";

// ===== OFFERTEREGELS POPUP =====
function makeEmptyOfferLine() {
  return {
    line_type: "Artikel",
    qty: "",
    unit: "",
    description: "",
    price: "",
    vat: "21",
  };
}

const buildUrl = (u) =>
  u.startsWith("http") ? u : `${u.startsWith("/") ? u : `/${u}`}`;

// ---------------- helpers ----------------
function getParam(name) {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) || "";
  } catch {
    return "";
  }
}

function norm(s) {
  return String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[，、]/g, ",")
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[;:!?]/g, "")
    .replace(/\s+/g, " ");
}

function safeTrim(s) {
  return String(s || "").trim();
}

// Referentie is vrije klanttekst. Historische invoer stond abusievelijk in offer_number.
function offerReferenceValue(row) {
  return safeTrim(row?.reference || row?.invoice_number || row?.offer_number || "");
}

function isEmptyWord(t) {
  const x = norm(t);
  return x === "geen" || x === "blanco" || x === "leeg" || x === "null";
}

async function tryFetchJson(urls, options = {}) {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  const tenant =
    sessionStorage.getItem("tenant") ||
    localStorage.getItem("tenant") ||
    "demo";

  let parsedUser = {};
  try {
    parsedUser = JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );
  } catch {}

  const role = parsedUser?.role || "user";

  const companyCodeIds =
    sessionStorage.getItem("staffiq_company_code_ids") ||
    localStorage.getItem("staffiq_company_code_ids") ||
    "";

  let lastErr;
  for (const url of urls) {
    try {
      const headers = {
        ...(options.headers || {}),
        Authorization: token ? `Bearer ${token}` : undefined,
        "x-tenant": tenant,
        "x-role": role,
        "x-staffiq-user-id": parsedUser?.id || undefined,
        "x-staffiq-user-email": parsedUser?.email || undefined,
        "x-staffiq-user-name": parsedUser?.display_name || parsedUser?.name || undefined,
        "x-company-code-ids": companyCodeIds || undefined,
      };

      Object.keys(headers).forEach(
        (k) => headers[k] === undefined && delete headers[k]
      );

      const res = await fetch(buildUrl(url), { ...options, headers });
      if (!res.ok) {
        const msg = await res.text().catch(() => "");
        throw new Error(`${res.status} ${res.statusText}${msg ? ` - ${msg}` : ""}`);
      }
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) return await res.json();
      return await res.text();
    } catch (e) {
      lastErr = e;
    }
  }
  throw lastErr || new Error("Failed to fetch");
}

// vOFF-130: binary fetch voor de echte PDF-voorbeeldweergave.
async function fetchPdfBlob(url, options = {}) {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  const tenant =
    sessionStorage.getItem("tenant") ||
    localStorage.getItem("tenant") ||
    "demo";

  let parsedUser = {};
  try {
    parsedUser = JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );
  } catch {}

  const companyCodeIds =
    sessionStorage.getItem("staffiq_company_code_ids") ||
    localStorage.getItem("staffiq_company_code_ids") ||
    "";

  const headers = {
    ...(options.headers || {}),
    Authorization: token ? `Bearer ${token}` : undefined,
    "x-tenant": tenant,
    "x-role": parsedUser?.role || "user",
    "x-staffiq-user-id": parsedUser?.id || undefined,
    "x-staffiq-user-email": parsedUser?.email || undefined,
    "x-staffiq-user-name": parsedUser?.display_name || parsedUser?.name || undefined,
    "x-company-code-ids": companyCodeIds || undefined,
  };

  Object.keys(headers).forEach(
    (key) => headers[key] === undefined && delete headers[key]
  );

  const response = await fetch(buildUrl(url), { ...options, headers });
  if (!response.ok) {
    const message = await response.text().catch(() => "");
    throw new Error(
      `${response.status} ${response.statusText}${message ? ` - ${message}` : ""}`
    );
  }

  return await response.blob();
}

function normalizePhoneForCommunication(raw, defaultCountryCode = "+31") {
  let s = String(raw || "").trim();

  if (!s || s === "-") return "";

  s = s
    .replace(/[^\d+]/g, "")
    .replace(/^00/, "+");

  if (!s) return "";

  if (s.startsWith("+")) return s;

  if (s.startsWith("0")) {
    return `${defaultCountryCode}${s.slice(1)}`;
  }

  if (s.startsWith("31")) {
    return `+${s}`;
  }

  return `${defaultCountryCode}${s}`;
}

async function loadCommunicationSettingsSafe() {
  try {
    const data = await tryFetchJson(["/api/communication-settings"]);

    return {
      email_enabled: data?.email_enabled !== false,
      whatsapp_enabled: data?.whatsapp_enabled !== false,
      sms_enabled: data?.sms_enabled === true,
      default_country_code: data?.default_country_code || "+31",
      default_sms_text: data?.default_sms_text || "",
      default_whatsapp_text: data?.default_whatsapp_text || "",
    };
  } catch {
    return {
      email_enabled: true,
      whatsapp_enabled: true,
      sms_enabled: false,
      default_country_code: "+31",
      default_sms_text: "",
      default_whatsapp_text: "",
    };
  }
}

function stopGridClick(e) {
  try {
    e.preventDefault();
    e.stopPropagation();
  } catch {}
}

function askCommunicationChoice(raw) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");

    overlay.style.position = "fixed";
    overlay.style.left = "0";
    overlay.style.top = "0";
    overlay.style.right = "0";
    overlay.style.bottom = "0";
    overlay.style.background = "rgba(0,0,0,0.35)";
    overlay.style.zIndex = "999999";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "18px";
    overlay.style.boxSizing = "border-box";

    const box = document.createElement("div");

    box.style.width = "min(520px, 100%)";
    box.style.background = "#fff";
    box.style.borderRadius = "12px";
    box.style.boxShadow = "0 18px 50px rgba(0,0,0,0.35)";
    box.style.padding = "18px";
    box.style.boxSizing = "border-box";
    box.style.fontFamily = "Arial, Helvetica, sans-serif";
    box.style.color = "#111";

    const title = document.createElement("div");
    title.style.fontWeight = "700";
    title.style.fontSize = "18px";
    title.style.marginBottom = "12px";
    title.textContent = `Wat wil je doen met ${raw}?`;

    const help = document.createElement("div");
    help.style.fontSize = "16px";
    help.style.lineHeight = "1.8";
    help.style.marginBottom = "12px";
    help.innerHTML = "1 = Bellen<br/>2 = SMS<br/>3 = WhatsApp";

    const input = document.createElement("input");
    input.type = "text";
    input.value = "3";
    input.inputMode = "numeric";
    input.autocomplete = "off";
    input.style.width = "100%";
    input.style.fontSize = "20px";
    input.style.padding = "10px 12px";
    input.style.border = "2px solid #1f4e79";
    input.style.borderRadius = "8px";
    input.style.boxSizing = "border-box";
    input.style.marginBottom = "14px";

    const buttons = document.createElement("div");
    buttons.style.display = "flex";
    buttons.style.gap = "10px";
    buttons.style.justifyContent = "flex-end";

    const okButton = document.createElement("button");
    okButton.type = "button";
    okButton.textContent = "OK";
    okButton.style.padding = "10px 18px";
    okButton.style.border = "none";
    okButton.style.borderRadius = "8px";
    okButton.style.background = "#1f4e79";
    okButton.style.color = "#fff";
    okButton.style.fontSize = "16px";
    okButton.style.cursor = "pointer";

    const cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.textContent = "Annuleren";
    cancelButton.style.padding = "10px 18px";
    cancelButton.style.border = "1px solid #d0d0d0";
    cancelButton.style.borderRadius = "8px";
    cancelButton.style.background = "#fff";
    cancelButton.style.color = "#111";
    cancelButton.style.fontSize = "16px";
    cancelButton.style.cursor = "pointer";

    let done = false;

    function cleanup(value) {
      if (done) return;
      done = true;

      try {
        document.body.removeChild(overlay);
      } catch {}

      resolve(value);
    }

    okButton.onclick = () => cleanup(input.value);
    cancelButton.onclick = () => cleanup(null);

    input.onkeydown = (ev) => {
      if (ev.key === "Enter") {
        ev.preventDefault();
        cleanup(input.value);
      }

      if (ev.key === "Escape") {
        ev.preventDefault();
        cleanup(null);
      }
    };

    overlay.onclick = (ev) => {
      if (ev.target === overlay) {
        cleanup(null);
      }
    };

    buttons.appendChild(cancelButton);
    buttons.appendChild(okButton);

    box.appendChild(title);
    box.appendChild(help);
    box.appendChild(input);
    box.appendChild(buttons);

    overlay.appendChild(box);
    document.body.appendChild(overlay);

    setTimeout(() => {
      try {
        input.focus();
        input.select();
      } catch {}
    }, 80);
  });
}

async function handleEmailGridClick(e, email) {
  stopGridClick(e);

  const mail = String(email || "").trim();

  if (!mail || mail === "-") return;

  const settings = await loadCommunicationSettingsSafe();

  if (settings.email_enabled === false) {
    alert("E-mail is niet actief in Communicatie-instellingen.");
    return;
  }

  window.location.href = `mailto:${encodeURIComponent(mail)}`;
}

function handlePhoneGridClick(e, phone) {
  stopGridClick(e);

  const tel = String(phone || "").trim();

  if (!tel || tel === "-") return;

  window.location.href = `tel:${tel}`;
}

async function handleMobileGridClick(e, mobile) {
  stopGridClick(e);

  const raw = String(mobile || "").trim();

  if (!raw || raw === "-") return;

  const settings = await loadCommunicationSettingsSafe();
  const normalized = normalizePhoneForCommunication(raw, settings.default_country_code || "+31");

  if (!normalized) return;

  const choice = await askCommunicationChoice(raw);

  const c = String(choice || "").trim().toLowerCase();

  if (!c) return;

  if (c === "1" || c === "bellen" || c === "bel") {
    window.location.href = `tel:${raw}`;
    return;
  }

  if (c === "2" || c === "sms") {
    if (settings.sms_enabled !== true) {
      alert("SMS is niet actief in Communicatie-instellingen.");
      return;
    }

    const text = window.prompt(
      `SMS naar ${raw}`,
      settings.default_sms_text || ""
    );

    if (text === null) return;

    const message = String(text || "").trim();

    if (!message) {
      alert("SMS tekst ontbreekt.");
      return;
    }

    try {
      await tryFetchJson(["/api/communications/sms"], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: raw,
          text: message,
        }),
      });

      alert(`SMS verstuurd naar ${raw}`);
    } catch (err) {
      alert(err?.message || "SMS verzenden mislukt.");
    }

    return;
  }

  if (c === "3" || c === "whatsapp" || c === "app") {
    if (settings.whatsapp_enabled === false) {
      alert("WhatsApp is niet actief in Communicatie-instellingen.");
      return;
    }

    const whatsappNumber = normalized.replace(/[^\d]/g, "");
    const text = String(settings.default_whatsapp_text || "").trim();
    const suffix = text ? `?text=${encodeURIComponent(text)}` : "";

    window.open(`https://wa.me/${whatsappNumber}${suffix}`, "_blank", "noopener,noreferrer");
  }
}

function upsertById(arr, item) {
  const id = item?.id;
  if (id === null || id === undefined) return arr;
  const idx = arr.findIndex((x) => String(x.id) === String(id));
  if (idx === -1) return [item, ...arr];
  const copy = arr.slice();
  copy[idx] = { ...copy[idx], ...item };
  return copy;
}

function removeById(arr, id) {
  return arr.filter((x) => String(x.id) !== String(id));
}

function euro(n) {
  const x = Number(n || 0);
  if (!Number.isFinite(x)) return "€ 0,00";
  try {
    return x.toLocaleString("nl-NL", { style: "currency", currency: "EUR" });
  } catch {
    return `€ ${x.toFixed(2)}`;
  }
}

function isoDate(s) {
  const t = String(s || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(t) ? t : "";
}

function formatNlDate(s) {
  const iso = isoDate(s);
  if (!iso) return "";
  const [yyyy, mm, dd] = iso.split("-");
  return `${dd}-${mm}-${yyyy}`;
}

function addDaysIso(iso, days) {
  const base = isoDate(iso);
  const n = Number(days || 0);
  if (!base || !Number.isFinite(n)) return "";

  const [y, m, d] = base.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + Math.trunc(n));

  const yy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");

  return `${yy}-${mm}-${dd}`;
}

function normalizeSpokenOfferNumber(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (!s) return "";

  const map = {
    nul: "0",
    null: "0",
    zero: "0",
    een: "1",
    "één": "1",
    twee: "2",
    drie: "3",
    vier: "4",
    vijf: "5",
    zes: "6",
    zeven: "7",
    acht: "8",
    negen: "9",
  };

  const parts = s
    .replace(/-/g, " ")
    .replace(/\./g, " ")
    .replace(/,/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean);

  if (!parts.length) return "";

  let out = "";
  let ok = true;

  for (const p of parts) {
    if (/^\d+$/.test(p)) {
      out += p;
    } else if (map[p]) {
      out += map[p];
    } else {
      ok = false;
      break;
    }
  }

  if (!ok) {
    out = s.replace(/[^\d]/g, "");
  }

  if (!out) return "";

  return out.padStart(4, "0");
}

function parseDutchDateToISO(raw) {
  const s0 = safeTrim(raw);
  if (!s0) return "";

  const digits = s0.replace(/[^\d]/g, "");

  if (digits.length === 8) {
    const dd = parseInt(digits.slice(0, 2), 10);
    const mm = parseInt(digits.slice(2, 4), 10);
    const yyyy = parseInt(digits.slice(4, 8), 10);
    if (yyyy >= 1900 && yyyy <= 2100 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
      const d = new Date(`${iso}T00:00:00`);
      if (!Number.isNaN(d.getTime())) return iso;
    }
  }

  if (digits.length === 6) {
    const dd = parseInt(digits.slice(0, 2), 10);
    const mm = parseInt(digits.slice(2, 4), 10);
    const yy = parseInt(digits.slice(4, 6), 10);
    const yyyy = 2000 + yy;
    if (yyyy >= 1900 && yyyy <= 2100 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
      const d = new Date(`${iso}T00:00:00`);
      if (!Number.isNaN(d.getTime())) return iso;
    }
  }

  const s = norm(s0).replace(/[\.\,]/g, " ");
  const tokens = s.split(" ").filter(Boolean);

  const monthMap = {
    jan: 1,
    januari: 1,
    feb: 2,
    februari: 2,
    mrt: 3,
    maart: 3,
    apr: 4,
    april: 4,
    mei: 5,
    jun: 6,
    juni: 6,
    jul: 7,
    juli: 7,
    aug: 8,
    augustus: 8,
    sep: 9,
    sept: 9,
    september: 9,
    okt: 10,
    oktober: 10,
    nov: 11,
    november: 11,
    dec: 12,
    december: 12,
  };

  const splitMore = [];
  for (const t of tokens) {
    const parts = t.split(/[-/]/g).filter(Boolean);
    splitMore.push(...parts);
  }
  const tt = splitMore.filter(Boolean);

  if (tt.length >= 2) {
    const d1 = parseInt(tt[0], 10);
    const mWord = tt[1];
    const m1 = monthMap[mWord];

    if (Number.isFinite(d1) && m1) {
      let y1 = null;
      if (tt.length >= 3) {
        const yTry = parseInt(tt[2], 10);
        if (Number.isFinite(yTry)) y1 = yTry;
      }
      if (!y1) y1 = new Date().getFullYear();
      if (y1 < 100) y1 = 2000 + y1;

      if (y1 >= 1900 && y1 <= 2100 && d1 >= 1 && d1 <= 31) {
        const iso = `${String(y1).padStart(4, "0")}-${String(m1).padStart(2, "0")}-${String(d1).padStart(2, "0")}`;
        const d = new Date(`${iso}T00:00:00`);
        if (!Number.isNaN(d.getTime())) return iso;
      }
    }
  }

  if (tt.length >= 3) {
    const dd = parseInt(tt[0], 10);
    const mm = parseInt(tt[1], 10);
    let yyyy = parseInt(tt[2], 10);

    if (Number.isFinite(yyyy) && yyyy < 100) yyyy = 2000 + yyyy;

    if (yyyy >= 1900 && yyyy <= 2100 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
      const d = new Date(`${iso}T00:00:00`);
      if (!Number.isNaN(d.getTime())) return iso;
    }
  }

  return "";
}

function speechDigitsPreserveZeros(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (!s) return "";

  const map = {
    "nul": "0",
    "null": "0",
    "zero": "0",
    "een": "1",
    "één": "1",
    "twee": "2",
    "drie": "3",
    "vier": "4",
    "vijf": "5",
    "zes": "6",
    "zeven": "7",
    "acht": "8",
    "negen": "9",
  };

  const cleaned = s
    .replace(/-/g, " ")
    .replace(/\./g, " ")
    .replace(/,/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const parts = cleaned.split(" ").filter(Boolean);
  if (!parts.length) return "";

  let out = "";
  let allKnown = true;

  for (const p of parts) {
    if (/^\d+$/.test(p)) {
      out += p;
    } else if (map[p]) {
      out += map[p];
    } else {
      allKnown = false;
      break;
    }
  }

  if (allKnown && out) return out;

  // fallback: alleen cijfers uit de tekst halen
  const digits = cleaned.replace(/[^\d]/g, "");
  return digits;
}

function decimal2OrEmptyString(s) {
  const raw = String(s || "").trim();
  if (!raw) return "";
  const cleaned = raw.replace(/,/g, ".").replace(/[^\d.]/g, "");
  const parts = cleaned.split(".");
  const a = parts[0] || "";
  const b = (parts[1] || "").slice(0, 2);
  if (parts.length === 1) return a;
  return `${a}.${b}`;
}

function punctToChar(t) {
  const x = norm(t);
  if (x === "punt") return ".";
  if (x === "komma") return ",";
  if (x === "dubbele punt" || x === "dubbelpunt") return ":";
  if (x === "puntkomma") return ";";
  if (x === "vraagteken") return "?";
  if (x === "uitroepteken") return "!";
  if (x === "nieuwe regel" || x === "enter") return "\n";
  return null;
}

function normalizeDbStatus(status) {
  const s = String(status || "").trim().toUpperCase();

  if (!s) return "OFFERTE";

  if (s === "DRAFT" || s === "CONCEPT" || s === "OFFERTE") return "OFFERTE";
  if (s === "OPDRACHT") return "OPDRACHT";
  if (s === "FACTUUR") return "FACTUUR";

  return "OFFERTE";
}

function statusLabel(status) {
  const s = normalizeDbStatus(status);

  switch (s) {
    case "OFFERTE":
      return "Offerte";
    case "OPDRACHT":
      return "Opdracht";
    case "FACTUUR":
      return "Factuur";
    default:
      return "Offerte";
  }
}

function boolPaidLabel(openAmount) {
  return openAmount <= 0.00001 ? "betaald" : "open";
}

function normalizeVatRate(v) {
  const s = String(v ?? "").toLowerCase().trim();

  if (["hoog", "high", "21", "21%", "h"].includes(s)) return "hoog";
  if (["laag", "low", "9", "9%", "l"].includes(s)) return "laag";
  if (["0", "0%", "nul", "zero"].includes(s)) return "0";
  if (["verlegd", "reverse", "btw verlegd"].includes(s)) return "verlegd";

  const n = Number(s.replace(",", ".").replace("%", ""));
  if (Number.isFinite(n)) {
    if (n === 21 || n === 0.21) return "hoog";
    if (n === 9 || n === 0.09) return "laag";
    if (n === 0) return "0";
  }

  return "hoog";
}

function vatPercentForRate(rate) {
  const r = normalizeVatRate(rate);
  if (r === "hoog") return 21;
  if (r === "laag") return 9;
  return 0;
}

function displayedPriceFromNetPrice(price, rate, includeVat) {
  const value = numberFromAny(price, 0);
  const pct = vatPercentForRate(rate);
  return includeVat && pct ? value * (1 + pct / 100) : value;
}

function netPriceFromDisplayedPrice(price, rate, includeVat) {
  const value = numberFromAny(price, 0);
  const pct = vatPercentForRate(rate);
  return includeVat && pct ? value / (1 + pct / 100) : value;
}

function vatLabelForRate(rate) {
  const r = normalizeVatRate(rate);
  if (r === "hoog") return "21% btw";
  if (r === "laag") return "9% btw";
  if (r === "0") return "0% btw";
  if (r === "verlegd") return "Btw verlegd";
  return "21% btw";
}

function pickOrgDefaultVatRate(org) {
  if (!org) return "hoog";

  const raw =
    org.vat_rate ??
    org.default_vat_rate ??
    org.default_vat_type ??
    org.vat_rate_default ??
    org.vat_type ??
    org.btw_type ??
    org.btw_soort ??
    org.invoice_vat_rate ??
    "hoog";

  return normalizeVatRate(raw);
}

function pickOrgVatNumber(org) {
  if (!org) return "";
  return (
    org.vat_number ||
    org.vat_no ||
    org.btw_number ||
    org.btw_nummer ||
    org.tax_number ||
    ""
  );
}

function pickOrgGrekeningPercent(org) {
  if (!org) return 0;
  const raw =
    org.g_account_percentage ??
    org.grekening_percentage ??
    org.g_rekening_percentage ??
    org.g_percentage ??
    org.g_account_percent ??
    0;

  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.max(0, Math.min(100, n));
}

function numberFromAny(raw, fallback = 0) {
  if (raw === null || raw === undefined || raw === "") return fallback;

  if (typeof raw === "number") {
    return Number.isFinite(raw) ? raw : fallback;
  }

  let s = String(raw).trim();
  if (!s) return fallback;

  s = s.replace(/[^0-9,.-]/g, "");

  // Nederlands: 1.234,56 => 1234.56
  if (s.includes(",") && s.includes(".")) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (s.includes(",")) {
    s = s.replace(",", ".");
  }

  const n = Number(s);
  return Number.isFinite(n) ? n : fallback;
}

function lineQty(line) {
  return numberFromAny(
    line?.quantity ??
    line?.qty ??
    line?.aantal ??
    line?.amount_qty ??
    line?.line_qty ??
    0
  );
}

function lineUnitLabel(line) {
  return String(line?.unit ?? line?.eenheid ?? "").trim();
}

function cleanLegacyOfferText(raw = "") {
  return String(raw || "")
    .replace(/&(?:amp;)+nbsp;|&nbsp;|&#160;|&#x[aA]0;/gi, " ")
    .replace(/\u00a0/g, " ");
}

// vOFF-149: controleer artikelomschrijvingen op zichtbare tekst,
// niet op aanwezige HTML-tags (<br>, <p><br></p> of spaties).
function hasVisibleOfferDescription(raw) {
  return !!richTextPlainText(cleanLegacyOfferText(raw));
}

function missingProjectArticleOfferTexts(rows) {
  return (Array.isArray(rows) ? rows : [])
    .filter((r) => editableOfferLineType(lineTypeOf(r)) === "Artikel" && !hasVisibleOfferDescription(r.offer_text))
    .map((r) => String(r.full_code || r.code || r.name || r.id || "onbekend projectartikel"));
}

function projectDescriptionText(raw = "") {
  // vOFF-144: de witruimte is onderdeel van de door de gebruiker in Projectbeheer
  // opgemaakte tekst. Vooral <br>, <p><br></p> en <div><br></div> aan het begin
  // mogen bij overname niet verdwijnen (ook niet na opnieuw opslaan).
  const text = cleanLegacyOfferText(raw);
  if (!text.trim()) return "";
  return isRichTextHtml(text) ? normalizeRichTextHtml(text) : text;
}

function lineUnitPrice(line) {
  return numberFromAny(
    line?.unit_price ??
    line?.price ??
    line?.unitPrice ??
    line?.unitprice ??
    line?.prijs ??
    line?.bedrag ??
    line?.amount ??
    0
  );
}

function lineVatRate(line) {
  return normalizeVatRate(line?.vat_rate ?? line?.vat ?? line?.btw ?? "hoog");
}

function lineDescription(line) {
  // vOFF-144: niet trimmen bij weergeven of bij een latere bewerking.
  const text = cleanLegacyOfferText(line?.description ?? line?.omschrijving ?? line?.name ?? "");
  return text.trim() ? text : "";
}

const OFFER_LINE_TYPES = ["Artikel", "Tekst"];

function normalizeOfferLineType(raw) {
  const s = String(raw || "")
    .toLowerCase()
    .trim();

  if (s === "artikel" || s === "article" || s === "regel" || s === "item") return "Artikel";
  if (s === "tekst" || s === "text") return "Tekst";
  if (s === "kop" || s === "header" || s === "heading") return "Kop";
  if (s === "subtotaal" || s === "subtotal") return "Subtotaal";
  if (s === "totaal" || s === "total") return "Totaal";

  return "Artikel";
}

// Oude regeltypen blijven herkenbaar voor bestaande documenten, maar zijn niet meer kiesbaar.
function editableOfferLineType(raw) {
  return normalizeOfferLineType(raw) === "Artikel" ? "Artikel" : "Tekst";
}

function backendOfferLineType(displayType) {
  const type = normalizeOfferLineType(displayType);

  if (type === "Artikel") return "item";
  if (type === "Tekst") return "text";
  if (type === "Kop") return "header";
  if (type === "Subtotaal") return "subtotal";
  if (type === "Totaal") return "total";

  return "item";
}

function lineTypeOf(line) {
  return normalizeOfferLineType(
    line?.lineType ??
    line?.type ??
    line?.regeltype ??
    line?.line_type ??
    "Artikel"
  );
}

function isAmountLine(line) {
  return lineTypeOf(line) === "Artikel";
}

function lineTotalExVat(line) {
  if (!isAmountLine(line)) return 0;

  const qty = lineQty(line);
  const unit = lineUnitPrice(line);

  if (!Number.isFinite(qty) || !Number.isFinite(unit)) return 0;

  return qty * unit;
}

function subtotalUntilLine(lines, targetIndex) {
  const arr = Array.isArray(lines) ? lines : [];
  const max = Number.isFinite(Number(targetIndex))
    ? Math.min(arr.length - 1, Number(targetIndex))
    : arr.length - 1;

  let subtotal = 0;

  for (let i = 0; i <= max; i += 1) {
    subtotal += lineTotalExVat(arr[i]);
  }

  return subtotal;
}

function calcOfferTotalsUntilLine(lines, targetIndex) {
  const arr = Array.isArray(lines) ? lines : [];
  const max = Number.isFinite(Number(targetIndex))
    ? Math.min(arr.length - 1, Number(targetIndex))
    : arr.length - 1;

  if (max < 0) {
    return calcOfferTotals([]);
  }

  return calcOfferTotals(arr.slice(0, max + 1));
}

function needsFixedOfferTextLayout(text) {
  const value = String(text || "");
  return /	| {2,}|□|☐|→|\|/.test(value);
}

function fixedOfferTextStyle(text) {
  // vOFF-038: geen apart monospace-lettertype meer gebruiken.
  // We bewaren spaties en regeleinden met whiteSpace: "pre-wrap",
  // maar houden overal hetzelfde offertelettertype aan.
  return {
    tabSize: 4,
  };
}

function calcOfferTotals(lines) {
  const vatMap = new Map();
  let subtotal = 0;

  const cleanLines = (Array.isArray(lines) ? lines : []).filter((ln) => {
    return isAmountLine(ln) && lineQty(ln) > 0 && lineDescription(ln);
  });

  cleanLines.forEach((ln) => {
    const qty = lineQty(ln);
    const unit = lineUnitPrice(ln);
    const rate = lineVatRate(ln);
    const base = qty * unit;
    const pct = vatPercentForRate(rate);
    const vatAmount = base * (pct / 100);

    subtotal += base;

    if (!vatMap.has(rate)) {
      vatMap.set(rate, {
        rate,
        label: vatLabelForRate(rate),
        percent: pct,
        base: 0,
        vat: 0,
      });
    }

    const row = vatMap.get(rate);
    row.base += base;
    row.vat += vatAmount;
  });

  const vatRows = Array.from(vatMap.values());
  const vatTotal = vatRows.reduce((sum, row) => sum + row.vat, 0);
  const total = subtotal + vatTotal;

  const hasNormalVat = vatRows.some((x) => x.rate === "hoog" || x.rate === "laag");
  const allVerlegd = vatRows.length > 0 && vatRows.every((x) => x.rate === "verlegd");
  const allZero = vatRows.length > 0 && vatRows.every((x) => x.rate === "0");

  return {
    subtotal,
    vatRows,
    vatTotal,
    vat_total: vatTotal,
    total,
    hasNormalVat,
    allVerlegd,
    allZero,
    hideVatColumnOnInvoice: true, // Alleen presentatie: btw blijft per artikel bewerkbaar en in totalen.
  };
}

function splitMultiline(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter(Boolean);
}


const RICH_TEXT_ALLOWED_FONTS = [
  "Calibri",
  "Arial",
  "Verdana",
  "Times New Roman",
];

function escapeRichTextHtml(value = "") {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function normalizeRichTextHtml(value = "") {
  const raw = String(value || "")
    // Oude editorcodes voor spaties mogen niet als tekst zichtbaar worden.
    .replace(/&(?:amp;)+nbsp;|&nbsp;|&#160;|&#x[aA]0;/gi, " ")
    .replace(/\u00a0/g, " ");
  // Niet trimStart(): een gebruiker mag bewust een lege eerste regel invoeren.
  if (!raw.trim()) return "";

  const looksLikeHtml = /<\/?(?:b|strong|i|em|u|br|div|p|span|font|ul|ol|li)\b/i.test(raw);
  if (!looksLikeHtml) {
    return escapeRichTextHtml(raw).replace(/\r?\n/g, "<br>");
  }

  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return raw;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${raw}</div>`, "text/html");
  const root = doc.body.firstElementChild;

  const allowedTags = new Set([
    "B", "STRONG", "I", "EM", "U", "BR", "DIV", "P", "SPAN", "FONT", "UL", "OL", "LI", "UL", "OL", "LI",
  ]);

  function cleanNode(node) {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.COMMENT_NODE) {
        child.remove();
        return;
      }

      if (child.nodeType !== Node.ELEMENT_NODE) return;

      if (!allowedTags.has(child.tagName)) {
        child.replaceWith(...child.childNodes);
        return;
      }

      // Legacy HTML <font size="3"> is browserstandaard circa 12 pt,
      // terwijl de StaffIQ-toolbar dit als 11 pt aanduidt.
      // Zet uitsluitend deze oude FONT-tag om; expliciete CSS-opmaak blijft behouden.
      if (child.tagName === "FONT") {
        const legacyFace = String(child.getAttribute("face") || "").replace(/["']/g, "").trim();
        const legacySize = String(child.getAttribute("size") || "").trim();
        const legacySizePt = {
          "1": "8pt", "2": "10pt", "3": "11pt", "4": "14pt",
          "5": "18pt", "6": "24pt", "7": "36pt",
        }[legacySize] || "";
        const span = doc.createElement("span");
        if (RICH_TEXT_ALLOWED_FONTS.includes(legacyFace)) span.style.fontFamily = legacyFace;
        if (legacySizePt) span.style.fontSize = legacySizePt;
        while (child.firstChild) span.appendChild(child.firstChild);
        child.replaceWith(span);
        cleanNode(span);
        return;
      }

      [...child.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();

        if (child.tagName === "FONT" && (name === "face" || name === "size")) {
          if (name === "face" && !RICH_TEXT_ALLOWED_FONTS.includes(attr.value)) {
            child.removeAttribute(attr.name);
          }
          if (name === "size" && !/^[1-7]$/.test(attr.value)) {
            child.removeAttribute(attr.name);
          }
          return;
        }

        if (["SPAN", "DIV", "P", "LI"].includes(child.tagName) && name === "style") {
          const safeRules = String(attr.value || "")
            .split(";")
            .map((rule) => rule.trim())
            .filter(Boolean)
            .filter((rule) => {
              const lower = rule.toLowerCase();
              return (
                lower.startsWith("font-family:") ||
                lower.startsWith("font-size:") ||
                lower.startsWith("font-weight:") ||
                lower.startsWith("font-style:") ||
                lower.startsWith("text-decoration:") ||
                lower.startsWith("line-height:")
              );
            })
            .join("; ");

          if (safeRules) child.setAttribute("style", safeRules);
          else child.removeAttribute("style");
          return;
        }

        child.removeAttribute(attr.name);
      });

      cleanNode(child);
    });
  }

  cleanNode(root);
  // vOFF-144: beginregels uit Projectbeheer, Sjablonen en de eigen editor
  // bewust bewaren; de bestaande HTML-opmaak wordt verder ongewijzigd gefilterd.
  return root.innerHTML;
}

function isRichTextHtml(value = "") {
  return /<\/?(?:b|strong|i|em|u|br|div|p|span|font|ul|ol|li)\b/i.test(
    String(value || "")
  );
}

function richTextPlainText(value = "") {
  const html = normalizeRichTextHtml(value);

  if (typeof document === "undefined") {
    return String(html || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;
  return String(div.innerText || div.textContent || "").trim();
}

function RichTextToolbar({ editorRef, disabled = false, compact = false, onContentChange = null, toolbarInteractionRef = null }) {
  const [activeFont, setActiveFont] = useState("");
  const [activeSize, setActiveSize] = useState("");
  const [activeLineHeight, setActiveLineHeight] = useState("");
  const [activeBold, setActiveBold] = useState(false);
  const [activeItalic, setActiveItalic] = useState(false);
  const [activeUnderline, setActiveUnderline] = useState(false);
  const [hasSelection, setHasSelection] = useState(false);
  const [editorIsEmpty, setEditorIsEmpty] = useState(false);
  const [pendingFont, setPendingFont] = useState("Calibri");
  const [pendingSize, setPendingSize] = useState("3");
  const [pendingLineHeight, setPendingLineHeight] = useState("1.15");
  const [pendingBold, setPendingBold] = useState(false);
  const [pendingItalic, setPendingItalic] = useState(false);
  const [pendingUnderline, setPendingUnderline] = useState(false);
  const savedRangeRef = useRef(null);

  function selectionIsInsideEditor(range) {
    const editor = editorRef?.current;
    if (!editor || !range) return false;

    const node = range.commonAncestorContainer;
    const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    return !!element && (element === editor || editor.contains(element));
  }

  function selectionHasText(range) {
    return !!range && !range.collapsed && String(range.toString() || "").length > 0;
  }

  function rememberEditorSelection() {
    try {
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);
      if (selectionIsInsideEditor(range)) {
        savedRangeRef.current = range.cloneRange();
      }
    } catch {}
  }

  function restoreEditorSelection() {
    try {
      const range = savedRangeRef.current;
      if (!range) return;

      const selection = window.getSelection();
      if (!selection) return;

      selection.removeAllRanges();
      selection.addRange(range);
    } catch {}
  }

  function normalizeActiveFont(raw) {
    const value = String(raw || "")
      .replace(/["']/g, "")
      .trim()
      .toLowerCase();

    if (!value) return "";

    return (
      RICH_TEXT_ALLOWED_FONTS.find((font) => {
        const wanted = font.toLowerCase();
        return value === wanted || value.startsWith(`${wanted},`) || value.includes(wanted);
      }) || ""
    );
  }

  function fontSizeToCommandValue(raw) {
    const px = parseFloat(String(raw || ""));
    if (!Number.isFinite(px)) return "";
    if (px <= 13.6) return "2";   // ca. 10 pt
    if (px <= 16.6) return "3";   // ca. 11 pt
    if (px <= 21.5) return "4";   // ca. 14 pt
    return "5";                   // ca. 18 pt
  }

  function normalizeLineHeight(raw, element) {
    let value = parseFloat(String(raw || ""));
    if (!Number.isFinite(value) || value <= 0) return "";

    // getComputedStyle geeft line-height vaak in pixels terug.
    if (value > 4) {
      const fontSize = parseFloat(window.getComputedStyle(element).fontSize || "");
      if (Number.isFinite(fontSize) && fontSize > 0) value /= fontSize;
    }

    const allowed = [1, 1.15, 1.5, 2];
    let best = allowed[0];
    let diff = Math.abs(value - best);
    for (const candidate of allowed.slice(1)) {
      const d = Math.abs(value - candidate);
      if (d < diff) {
        best = candidate;
        diff = d;
      }
    }
    return diff <= 0.18 ? String(best) : "";
  }

  function collectSelectionElements(range) {
    const editor = editorRef?.current;
    if (!editor || !range || !selectionIsInsideEditor(range)) return [];

    const elements = new Set();

    const addElement = (node) => {
      const el = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
      if (el && (el === editor || editor.contains(el))) elements.add(el);
    };

    addElement(range.startContainer);
    addElement(range.endContainer);

    const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      try {
        if (range.intersectsNode(node)) addElement(node);
      } catch {}
    }

    return [...elements];
  }

  function commonValue(values) {
    const clean = values.filter((v) => v !== null && v !== undefined && v !== "");
    if (!clean.length) return "";
    const first = String(clean[0]);
    return clean.every((v) => String(v) === first) ? first : "";
  }

  function updateActiveFormatting() {
    // Het native selectmenu kan de browserselectie tijdelijk laten instorten.
    // Tijdens een toolbar-actie daarom de eerder geselecteerde tekst bewaren.
    if (toolbarInteractionRef?.current) return;
    try {
      const editor = editorRef?.current;
      const selection = window.getSelection();
      if (!editor || !selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);
      if (!selectionIsInsideEditor(range)) return;

      savedRangeRef.current = range.cloneRange();
      const selected = selectionHasText(range);
      const empty = String(editor.innerText || editor.textContent || "").replace(/\u200B/g, "").trim() === "";
      setHasSelection(selected);
      setEditorIsEmpty(empty);

      // Zonder selectie: alleen tonen wat voor het HELE blok gelijk is.
      // Met selectie: alleen tonen wat binnen de SELECTIE gelijk is.
      let elements = [];
      if (selected) {
        elements = collectSelectionElements(range);
      } else {
        const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (String(node.nodeValue || "").length > 0) {
            const el = node.parentElement || editor;
            elements.push(el);
          }
        }
        if (!elements.length) elements = [editor];
      }

      const fonts = elements.map((el) =>
        normalizeActiveFont(window.getComputedStyle(el).fontFamily)
      );
      const sizes = elements.map((el) =>
        fontSizeToCommandValue(window.getComputedStyle(el).fontSize)
      );
      const lines = elements.map((el) =>
        normalizeLineHeight(window.getComputedStyle(el).lineHeight, el)
      );

      if (!empty) {
        setActiveFont(commonValue(fonts));
        setActiveSize(commonValue(sizes));
        setActiveLineHeight(commonValue(lines));
      }

      if (selected) {
        setActiveBold(document.queryCommandState("bold") === true);
        setActiveItalic(document.queryCommandState("italic") === true);
        setActiveUnderline(document.queryCommandState("underline") === true);
      } else {
        setActiveBold(false);
        setActiveItalic(false);
        setActiveUnderline(false);
      }
    } catch {}
  }

  useEffect(() => {
    const handleSelectionChange = () => updateActiveFormatting();

    document.addEventListener("selectionchange", handleSelectionChange);
    const timer = setTimeout(handleSelectionChange, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("selectionchange", handleSelectionChange);
    };
  }, [editorRef]);

  function getSelectedRangeForChange() {
    restoreEditorSelection();

    const editor = editorRef?.current;
    const selection = window.getSelection();
    if (!editor || !selection || selection.rangeCount === 0) return null;

    const range = selection.getRangeAt(0);
    if (!selectionIsInsideEditor(range)) return null;

    // Bestaande tekst: alleen een echte selectie mag worden gewijzigd.
    if (selectionHasText(range)) return range;

    // Leeg tekstveld: de cursor mag wel de opmaak voor nieuw te typen tekst bepalen.
    const empty = String(editor.innerText || editor.textContent || "").replace(/\u200B/g, "").trim() === "";
    if (range.collapsed && empty) return range;

    return null;
  }

  function prepareEmptyEditorTypingFormat(next = {}) {
    const editor = editorRef?.current;
    if (!editor || disabled) return false;

    const empty = String(editor.innerText || editor.textContent || "").replace(/\u200B/g, "").trim() === "";
    if (!empty) return false;

    const font = next.font ?? pendingFont ?? "Calibri";
    const size = next.size ?? pendingSize ?? "3";
    const lineHeight = next.lineHeight ?? pendingLineHeight ?? "1.15";
    const bold = next.bold ?? pendingBold;
    const italic = next.italic ?? pendingItalic;
    const underline = next.underline ?? pendingUnderline;

    setPendingFont(font);
    setPendingSize(size);
    setPendingLineHeight(lineHeight);
    setPendingBold(!!bold);
    setPendingItalic(!!italic);
    setPendingUnderline(!!underline);

    const sizePx = { "2": "13.333px", "3": "14.667px", "4": "18.667px", "5": "24px" }[String(size)] || "14.667px";

    editor.innerHTML = "";
    const span = document.createElement("span");
    span.style.fontFamily = font;
    span.style.fontSize = sizePx;
    span.style.lineHeight = lineHeight;
    span.style.fontWeight = bold ? "700" : "400";
    span.style.fontStyle = italic ? "italic" : "normal";
    span.style.textDecoration = underline ? "underline" : "none";

    const textNode = document.createTextNode("\u200B");
    span.appendChild(textNode);
    editor.appendChild(span);

    const range = document.createRange();
    range.setStart(textNode, 1);
    range.collapse(true);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    savedRangeRef.current = range.cloneRange();

    editor.focus();
    setEditorIsEmpty(true);
    setHasSelection(false);
    setActiveFont(font);
    setActiveSize(String(size));
    setActiveLineHeight(String(lineHeight));

    return true;
  }

  function applyLineHeight(value) {
    if (disabled) return;

    try {
      const range = getSelectedRangeForChange();
      if (!range) return;

      const editor = editorRef?.current;

      // In een leeg veld geldt de gekozen regelhoogte voor de tekst die hierna wordt getypt.
      if (range.collapsed && editorIsEmpty) {
        prepareEmptyEditorTypingFormat({ lineHeight: value });
        return;
      }

      const touched = new Set();

      const addBlock = (node) => {
        let el = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
        while (el && el !== editor) {
          if (["DIV", "P", "LI"].includes(el.tagName)) {
            touched.add(el);
            return;
          }
          el = el.parentElement;
        }
      };

      addBlock(range.startContainer);
      addBlock(range.endContainer);

      const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        try {
          if (range.intersectsNode(node)) addBlock(node);
        } catch {}
      }

      // Geen blok-element aanwezig: omwikkel uitsluitend de selectie.
      if (!touched.size) {
        const span = document.createElement("span");
        span.style.lineHeight = value;
        try {
          range.surroundContents(span);
        } catch {
          const fragment = range.extractContents();
          span.appendChild(fragment);
          range.insertNode(span);
        }
      } else {
        touched.forEach((el) => {
          el.style.lineHeight = value;
        });
      }

      setActiveLineHeight(String(value || ""));
      if (editor && typeof onContentChange === "function") {
        onContentChange(normalizeRichTextHtml(editor.innerHTML));
      }

      rememberEditorSelection();
      setTimeout(updateActiveFormatting, 0);
    } catch {}
  }

  function exec(command, value = null) {
    if (disabled) return;

    try {
      const range = getSelectedRangeForChange();
      if (!range) return;

      if (range.collapsed && editorIsEmpty) {
        if (command === "fontName") {
          prepareEmptyEditorTypingFormat({ font: value });
          return;
        }
        if (command === "fontSize") {
          prepareEmptyEditorTypingFormat({ size: value });
          return;
        }
        if (command === "bold") {
          prepareEmptyEditorTypingFormat({ bold: !pendingBold });
          return;
        }
        if (command === "italic") {
          prepareEmptyEditorTypingFormat({ italic: !pendingItalic });
          return;
        }
        if (command === "underline") {
          prepareEmptyEditorTypingFormat({ underline: !pendingUnderline });
          return;
        }
      }

      editorRef?.current?.focus?.();
      restoreEditorSelection();
      document.execCommand(command, false, value);

      const editor = editorRef?.current;
      if (editor && typeof onContentChange === "function") {
        onContentChange(normalizeRichTextHtml(editor.innerHTML));
      }

      rememberEditorSelection();
      setTimeout(updateActiveFormatting, 0);
    } catch {}
  }

  const canFormat = hasSelection || editorIsEmpty;
  const selectionDisabled = disabled || !canFormat;

  const buttonStyle = {
    minWidth: 32,
    height: 30,
    padding: "0 8px",
    border: "1px solid #cfd8e3",
    borderRadius: 5,
    background: "#fff",
    cursor: selectionDisabled ? "not-allowed" : "pointer",
    opacity: selectionDisabled ? 0.5 : 1,
    fontSize: 13,
    fontWeight: 700,
  };

  return (
    <div
      className="rich-text-toolbar"
      style={{
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: compact ? 5 : 7,
      }}
    >
      <select
        value={editorIsEmpty ? pendingFont : activeFont}
        disabled={selectionDisabled}
        onPointerDown={() => { rememberEditorSelection(); if (toolbarInteractionRef) toolbarInteractionRef.current = true; }}
        onMouseDown={(e) => {
          e.stopPropagation();
          rememberEditorSelection();
          if (toolbarInteractionRef) toolbarInteractionRef.current = true;
        }}
        onBlur={() => { if (toolbarInteractionRef) toolbarInteractionRef.current = false; }}
        onChange={(e) => {
          const value = e.target.value;
          if (value) exec("fontName", value);
        }}
        style={{
          height: 30,
          minWidth: 120,
          border: "1px solid #cfd8e3",
          borderRadius: 5,
          background: "#fff",
        }}
        title={hasSelection ? "Lettertype van selectie" : editorIsEmpty ? "Lettertype voor nieuwe tekst" : "Selecteer eerst tekst om het lettertype te wijzigen"}
      >
        <option value="">—</option>
        {RICH_TEXT_ALLOWED_FONTS.map((font) => (
          <option key={font} value={font}>{font}</option>
        ))}
      </select>

      <select
        value={editorIsEmpty ? pendingSize : activeSize}
        disabled={selectionDisabled}
        onPointerDown={() => { rememberEditorSelection(); if (toolbarInteractionRef) toolbarInteractionRef.current = true; }}
        onMouseDown={(e) => {
          e.stopPropagation();
          rememberEditorSelection();
          if (toolbarInteractionRef) toolbarInteractionRef.current = true;
        }}
        onBlur={() => { if (toolbarInteractionRef) toolbarInteractionRef.current = false; }}
        onChange={(e) => {
          const value = e.target.value;
          if (value) exec("fontSize", value);
        }}
        style={{
          height: 30,
          minWidth: 100,
          border: "1px solid #cfd8e3",
          borderRadius: 5,
          background: "#fff",
        }}
        title={hasSelection ? "Tekstgrootte van selectie" : editorIsEmpty ? "Tekstgrootte voor nieuwe tekst" : "Selecteer eerst tekst om de tekstgrootte te wijzigen"}
      >
        <option value="">—</option>
        <option value="2">10</option>
        <option value="3">11</option>
        <option value="4">14</option>
        <option value="5">18</option>
      </select>

      <select
        value={editorIsEmpty ? pendingLineHeight : activeLineHeight}
        disabled={selectionDisabled}
        onPointerDown={() => { rememberEditorSelection(); if (toolbarInteractionRef) toolbarInteractionRef.current = true; }}
        onMouseDown={(e) => { e.stopPropagation(); rememberEditorSelection(); if (toolbarInteractionRef) toolbarInteractionRef.current = true; }}
        onBlur={() => { if (toolbarInteractionRef) toolbarInteractionRef.current = false; }}
        onChange={(e) => {
          const value = e.target.value;
          if (value) applyLineHeight(value);
        }}
        style={{ height: 30, minWidth: 125, border: "1px solid #cfd8e3", borderRadius: 5, background: "#fff" }}
        title={hasSelection ? "Regelhoogte van selectie" : editorIsEmpty ? "Regelhoogte voor nieuwe tekst" : "Selecteer eerst tekst om de regelhoogte te wijzigen"}
      >
        <option value="">—</option>
        <option value="1">Regel 1,0</option>
        <option value="1.15">Regel 1,15</option>
        <option value="1.5">Regel 1,5</option>
        <option value="2">Regel 2,0</option>
      </select>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{
          ...buttonStyle,
          background: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "#dbeafe" : "#fff",
          borderColor: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "#2f7dd1" : "#cfd8e3",
          color: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "#0b4f7a" : "#111",
          boxShadow: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "inset 0 0 0 1px #2f7dd1" : "none",
        }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("bold"); }}
        title={hasSelection ? (activeBold ? "Vet is actief" : "Vet") : "Selecteer eerst tekst"}
        aria-pressed={(hasSelection && activeBold) || (editorIsEmpty && pendingBold)}
      >
        B
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{
          ...buttonStyle,
          fontStyle: "italic",
          background: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "#dbeafe" : "#fff",
          borderColor: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "#2f7dd1" : "#cfd8e3",
          color: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "#0b4f7a" : "#111",
          boxShadow: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "inset 0 0 0 1px #2f7dd1" : "none",
        }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("italic"); }}
        title={hasSelection ? (activeItalic ? "Cursief is actief" : "Cursief") : "Selecteer eerst tekst"}
        aria-pressed={(hasSelection && activeItalic) || (editorIsEmpty && pendingItalic)}
      >
        I
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{
          ...buttonStyle,
          textDecoration: "underline",
          background: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "#dbeafe" : "#fff",
          borderColor: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "#2f7dd1" : "#cfd8e3",
          color: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "#0b4f7a" : "#111",
          boxShadow: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "inset 0 0 0 1px #2f7dd1" : "none",
        }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("underline"); }}
        title={hasSelection ? (activeUnderline ? "Onderstrepen is actief" : "Onderstrepen") : "Selecteer eerst tekst"}
        aria-pressed={(hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline)}
      >
        U
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{ ...buttonStyle, minWidth: 42 }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("insertUnorderedList"); }}
        title={hasSelection ? "Opsomming met bullets" : "Selecteer eerst tekst"}
      >
        •
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{ ...buttonStyle, minWidth: 42 }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("insertOrderedList"); }}
        title={hasSelection ? "Genummerde lijst" : "Selecteer eerst tekst"}
      >
        1.
      </button>
    </div>
  );
}

// vWORD-PASTE: plak uit Word/Outlook uitsluitend klembordtekst, zonder verborgen Office-opmaak.
// Behoud zichtbare tekst, tabs en alle bewuste nieuwe/lege regels.
function cleanWordClipboardText(value = "") {
  return String(value || "")
    .replace(/\r\n?/g, "\n")
    .replace(/[\u0085\u2028\u2029]/g, "\n")
    .replace(/[\u00a0\u2000-\u200a\u202f\u205f\u3000]/g, " ")
    // Onzichtbare afbreek-/richtings-/nulbreedtetekens uit Word verwijderen.
    .replace(/[\u00ad\u034f\u061c\u180e\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff]/g, "")
    .replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f-\u009f]/g, "");
}

// Houd tekst tegen de bovenrand; standaard <p>-marges geven anders een schijnbare lege regel.
const STAFFIQ_RICH_TEXT_TOP_CSS = `.staffiq-offer-fixed-text, .staffiq-offer-fixed-text *, .staffiq-offer-date-text, .staffiq-offer-date-text * { font-family: Calibri, Carlito, Arial, sans-serif !important; font-size: 11pt !important; line-height: 1.15 !important; }
.staffiq-rich-text-surface > :first-child { margin-top: 0 !important; }
 .staffiq-rich-text-surface > :last-child { margin-bottom: 0 !important; }
 .staffiq-offer-project-text p, .staffiq-offer-line-description p { margin-top: 0 !important; margin-bottom: 0 !important; }
 .staffiq-offer-project-text > :first-child, .staffiq-offer-line-description > :first-child { margin-top: 0 !important; }
 .staffiq-offer-project-text > :last-child, .staffiq-offer-line-description > :last-child { margin-bottom: 0 !important; }
 .staffiq-rich-text-surface p { margin-top: 0 !important; margin-bottom: 0 !important; }
 .staffiq-rich-text-surface > div { margin-top: 0 !important; margin-bottom: 0 !important; }
 .staffiq-offer-project-text hr, .staffiq-offer-line-description hr { display: none !important; }
 /* Projectregels blijven dicht bij elkaar; een zelf ingevoerde lege alinea blijft één echte regel. */
 .staffiq-offer-project-row .staffiq-offer-line-description p,
 .staffiq-offer-project-row .staffiq-offer-line-description div,
 .staffiq-offer-project-row .staffiq-offer-line-description ul,
 .staffiq-offer-project-row .staffiq-offer-line-description ol { margin-top: 0 !important; margin-bottom: 0 !important; }
 .staffiq-offer-project-row .staffiq-offer-line-description > :first-child { margin-top: 0 !important; }
 .staffiq-offer-project-row .staffiq-offer-line-description > :last-child { margin-bottom: 0 !important; }`;
function RichTextEditor({
  value,
  onChange,
  disabled = false,
  minHeight = 110,
  placeholder = "",
  toolbarVisible = true,
  onActivate = null,
  externalEditorRef = null,
  onPageBreakShortcut = null,
}) {
  const internalEditorRef = useRef(null);
  const editorRef = externalEditorRef || internalEditorRef;
  const toolbarInteractionRef = useRef(false);

  useEffect(() => {
    if (!editorRef.current) return;

    // Tijdens typen beheert contentEditable zelf de DOM en cursor.
    // Niet opnieuw vullen zolang dit veld actief is.
    if (document.activeElement === editorRef.current) return;

    const normalized = normalizeRichTextHtml(value);
    if (editorRef.current.innerHTML !== normalized) {
      editorRef.current.innerHTML = normalized;
    }
  }, [value]);

  return (
    <div>
      <style>{STAFFIQ_RICH_TEXT_TOP_CSS}</style>
      {toolbarVisible && (
        <RichTextToolbar editorRef={editorRef} disabled={disabled} onContentChange={onChange} toolbarInteractionRef={toolbarInteractionRef} />
      )}
      <div
        ref={editorRef}
        className="staffiq-rich-text-surface"
        contentEditable={!disabled}
        suppressContentEditableWarning
        spellCheck
        data-placeholder={placeholder}
        onPaste={(e) => {
          if (disabled) return;
          // Alleen platte tekst uit het klembord; geen Word-HTML of meegekomen fonts.
          e.preventDefault();
          const pasted = cleanWordClipboardText(e.clipboardData?.getData("text/plain") || "");
          if (!pasted) return;

          const editor = e.currentTarget;
          editor.focus();
          // Cursor/selectie en StaffIQ-opmaak behouden, inclusief blanco regels.
          const done = document.execCommand("insertText", false, pasted);
          if (!done) {
            document.execCommand("insertHTML", false, escapeRichTextHtml(pasted).replace(/\n/g, "<br>"));
          }
          onChange(editor.innerHTML);
        }}
        onKeyDown={(e) => {
          if ((e.ctrlKey || e.metaKey) && e.key === "Enter" && typeof onPageBreakShortcut === "function") {
            e.preventDefault();
            e.stopPropagation();
            onPageBreakShortcut();
          }
        }}
        onMouseDown={() => onActivate?.()}
        onFocus={() => onActivate?.()}
        onInput={(e) => {
          const el = e.currentTarget;

          // Zero-width marker alleen verwijderen zodra echte tekst aanwezig is.
          if (String(el.innerText || el.textContent || "").replace(/\u200B/g, "").length > 0) {
            const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              if (node.nodeValue?.includes("\u200B")) {
                node.nodeValue = node.nodeValue.replace(/\u200B/g, "");
              }
            }
          }

          // Tijdens invoer browser-HTML rechtstreeks bewaren.
          // Normaliseren pas bij verlaten van het veld.
          onChange(el.innerHTML);
        }}
        onBlur={(e) => {
          // vPRJ-060 / vOFF-135: kies je boven dit tekstveld een lettertype,
          // dan mag normaliseren de geselecteerde DOM-nodes niet vervangen.
          // Anders verwijst de opgeslagen tekstselectie naar oude nodes.
          const nextFocus = e.relatedTarget;
          const toolbar = nextFocus?.closest?.(".rich-text-toolbar");
          if (toolbarInteractionRef.current || (toolbar && toolbar.parentElement === e.currentTarget.parentElement)) return;
          const cleaned = normalizeRichTextHtml(e.currentTarget.innerHTML).replace(/\u200B/g, "");
          if (e.currentTarget.innerHTML !== cleaned) {
            e.currentTarget.innerHTML = cleaned;
          }
          onChange(cleaned);
        }}
        style={{
          minHeight,
          padding: "9px 10px",
          border: "1px solid #d9d9d9",
          borderRadius: 5,
          background: disabled ? "#f7f7f7" : "#fff",
          boxSizing: "border-box",
          fontFamily: "Calibri, Carlito, Arial, sans-serif",
          fontSize: "11pt",
          lineHeight: 1.15,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          cursor: disabled ? "not-allowed" : "text",
        }}
      />
    </div>
  );
}


// ---------------- component ----------------
const emptyForm = {
  id: null,
  organisation_id: "",
  contact_id: "",
  template_id: "",
  invoice_number: "",
  reference: "",
  series_code: "",
  invoice_date: "",
  due_date: "",
  order_date: "",
  planned_delivery_date: "",
  status: "DRAFT",
  delivery_status: "NOT_DELIVERED",
  notes: "",

  document_subject: "",
  document_show_subject: true,
  document_salutation: "",
  document_show_salutation: true,
  document_intro_text: "",
  document_show_intro_text: true,
  document_body_text: "",
  document_show_body_text: true,
  document_conditions_text: "",
  document_show_conditions_text: true,
  document_payment_text: "",
  document_show_payment_text: true,
  document_planning_text: "",
  document_show_planning_text: true,
  document_remark_text: "",
  document_show_remark_text: true,
  document_warranty_text: "",
  document_show_warranty_text: true,
  document_closing_text: "",
  document_show_closing_text: true,
  document_show_agreement_block: false,
  document_agreement_text: "",
  document_texts_initialized: false,
  document_order: [],

  subtotal: 0,
  vat_total: 0,
  total: 0,

  created_at: "",
  updated_at: "",
};

function todayLocalIso() {
  return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
}

export default function Offertes() {
  const navigate = useNavigate();
  const rawUser =
    sessionStorage.getItem("user") ||
    localStorage.getItem("user") ||
    "";

  let role = "user";

  try {
    role = JSON.parse(rawUser || "{}")?.role || "user";
  } catch {}

  const isReadonly = String(role || "").toLowerCase() === "readonly";

  const VERSION = "vOFF-164";

  // data
  const [items, setItems] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [invoiceSettings, setInvoiceSettings] = useState({});
  const [offerDocumentSettings, setOfferDocumentSettings] = useState({});
  const [orderDocumentSettings, setOrderDocumentSettings] = useState({});
  const [letterheadSettings, setLetterheadSettings] = useState({});
  const [orderSettings, setOrderSettings] = useState({ use_work_orders: false });
  const [generalSettings, setGeneralSettings] = useState({ offer_prices_include_vat: false });
  const [offerTemplates, setOfferTemplates] = useState([]);
  const [projectItems, setProjectItems] = useState([]);
  const [projectItemsLoading, setProjectItemsLoading] = useState(false);
  const [newLineMode, setNewLineMode] = useState("");
  const [projectSearch, setProjectSearch] = useState("");
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);
  const [excludedProjectIds, setExcludedProjectIds] = useState([]);
  const [selectedProjectLineId, setSelectedProjectLineId] = useState("__manual__");
  const [includeChildProjects, setIncludeChildProjects] = useState(false);
  const [showProjectOfferText, setShowProjectOfferText] = useState(false);
  const [showProjectInternalText, setShowProjectInternalText] = useState(false);
  const [expandedProjectIds, setExpandedProjectIds] = useState(() => new Set());
  function formatMoney(val) {
    return Number(val || 0).toLocaleString("nl-NL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  // selectie + form
  const [selectedId, setSelectedId] = useState(null);
  const [form, setForm] = useState(emptyForm);

// Lock logica:
// - OFFERTE mag bewerkt worden
// - OPDRACHT mag bewerkt worden tot deze naar FACTUUR is omgezet
// - FACTUUR is geblokkeerd; wijzigingen lopen daarna via Facturen
const currentStatus = normalizeDbStatus(form?.status || "OFFERTE");
const isLocked = currentStatus === "FACTUUR";

  // Admin mag alles
  const isAdmin = role.toLowerCase() === "admin";

  // Eindresultaat: readonly als:
  // - readonly user
  // - OF offerte niet meer DRAFT en geen admin
  const isFormDisabled = isReadonly || (isLocked && !isAdmin);

  // org detail (voor correspondentieadres)
  const [orgDetail, setOrgDetail] = useState(null);

  // payments
  const [payments, setPayments] = useState([]);
  const [lines, setLines] = useState([]);
  const [lineDraft, setLineDraft] = useState({
    line_type: "Artikel",
    quantity: 1,
    description: "",
    unit: "",
    unit_price: "",
    vat_rate: "hoog",
  });

  const qtyInputRef = useRef(null);
  const unitInputRef = useRef(null);
  const lineDescRef = useRef(null);
  const linePriceRef = useRef(null);
  const lineVatRef = useRef(null);
  const [editingLineId, setEditingLineId] = useState(null);
  const [draggingOfferLineId, setDraggingOfferLineId] = useState(null);
  const [dragOverOfferLineId, setDragOverOfferLineId] = useState(null);
  const [payDraft, setPayDraft] = useState({
    paid_on: new Date().toLocaleDateString("en-CA"),
    amount: "",
    notes: "",
  });

  const [payError, setPayError] = useState(null);

  // cursor index
  const [listIndex, setListIndex] = useState(-1);

  // ui status
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [flash, setFlash] = useState("");
  const [lineError, setLineError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [sendingApproval, setSendingApproval] = useState(false);
  const [lastApprovalInfo, setLastApprovalInfo] = useState(null);
  const [activeDocumentEditorKey, setActiveDocumentEditorKey] = useState("");

  // AI popup
  const [aiOpen, setAiOpen] = useState(false);
  const [aiBusy, setAiBusy] = useState(false);
  const [aiText, setAiText] = useState("");
  const [aiSource, setAiSource] = useState("page"); // page | popup
  const aiTextRef = useRef(null);

  // vFCT-PTT-05: helper om de lijst opnieuw te laden (gebruik door knop 'Vernieuw' en voice)
  function loadList() {
    setReloadKey((k) => k + 1);
  }

  const [speechInfo, setSpeechInfo] = useState("");
  const [hideVoiceError, setHideVoiceError] = useState(false);
  const prevVoiceErrorRef = useRef("");
  const [pendingSpeechSearch, setPendingSpeechSearch] = useState(false);

  // zoek + filters
  const [q, setQ] = useState(getParam("q"));
  const [organisationFilterId, setOrganisationFilterId] = useState(getParam("organisation_id"));

  // dropdown filters (grid)
  const EMPTY_VAL = "__EMPTY__";
  const [zoeknaamFilter, setZoeknaamFilter] = useState("");
  const [contactFilter, setContactFilter] = useState("");
  const [invoiceNrFilter, setInvoiceNrFilter] = useState("");
  const [invoiceDateFilter, setInvoiceDateFilter] = useState("");
  const [totaalFilter, setTotaalFilter] = useState("");
  const [telFilter, setTelFilter] = useState("");
  const [mobFilter, setMobFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [companyCodeFilter, setCompanyCodeFilter] = useState("");
  const [paidFilter, setPaidFilter] = useState("");
  const [mode, setMode] = useState("search");
  const isFormLocked = mode !== "form";
  const [sort, setSort] = useState({ key: "invoice_date", dir: "desc" }); // standaard nieuw->oud
  const [showLinesPopup, setShowLinesPopup] = useState(false);
  const [popupLines, setPopupLines] = useState([]);
 const [popupMode, setPopupMode] = useState("edit");
const [silentDocumentPreview, setSilentDocumentPreview] = useState(false);
  // vOFF-130: eigen briefpapier gebruikt een echte PDF als Voorbeeld.
  const [letterheadPdfPreviewUrl, setLetterheadPdfPreviewUrl] = useState("");
  const [letterheadPdfPreviewBusy, setLetterheadPdfPreviewBusy] = useState(false);
  const [letterheadPdfPreviewError, setLetterheadPdfPreviewError] = useState("");
  const [popupWindow, setPopupWindow] = useState({
    x: 80,
    y: 50,
    width: 1180,
    height: 780,
  });

  const popupDragRef = useRef({
    dragging: false,
    startMouseX: 0,
    startMouseY: 0,
    startX: 0,
    startY: 0,
  });

useEffect(() => {
    if (!showLinesPopup) return;

    focusFirstPopupField();

    const w = Math.min(window.innerWidth - 80, 1180);
    const h = Math.min(window.innerHeight - 80, 780);
    const x = Math.max(20, Math.round((window.innerWidth - w) / 2));
    const y = Math.max(20, Math.round((window.innerHeight - h) / 2));

    setPopupWindow({ x, y, width: w, height: h });
  }, [showLinesPopup]);

  useEffect(() => {
    function onMouseMove(e) {
      if (!popupDragRef.current.dragging) return;

      const dx = e.clientX - popupDragRef.current.startMouseX;
      const dy = e.clientY - popupDragRef.current.startMouseY;

      setPopupWindow((prev) => {
        const nextX = popupDragRef.current.startX + dx;
        const nextY = popupDragRef.current.startY + dy;

        const maxX = Math.max(20, window.innerWidth - prev.width - 20);
        const maxY = Math.max(20, window.innerHeight - prev.height - 20);

        return {
          ...prev,
          x: Math.min(Math.max(20, nextX), maxX),
          y: Math.min(Math.max(20, nextY), maxY),
        };
      });
    }

    function onMouseUp() {
      popupDragRef.current.dragging = false;
    }

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, []);

  function startPopupDrag(e) {
    popupDragRef.current = {
      dragging: true,
      startMouseX: e.clientX,
      startMouseY: e.clientY,
      startX: popupWindow.x,
      startY: popupWindow.y,
    };
  }

  useEffect(() => {
    return () => {
      if (letterheadPdfPreviewUrl) {
        try { URL.revokeObjectURL(letterheadPdfPreviewUrl); } catch {}
      }
    };
  }, [letterheadPdfPreviewUrl]);

  // refs
  const searchRef = useRef(null);
  const rowRefs = useRef([]);
  const midScrollRef = useRef(null);
  const rightScrollRef = useRef(null);
  const popupPrintRef = useRef(null);
  const letterheadPdfPreviewFrameRef = useRef(null);
  const offerPopupScrollRef = useRef(null);
  const documentTextSelectionRef = useRef(null);
  const documentTextDraftRef = useRef({});
  // vOFF-120: bewaart de laatst geladen/opgeslagen offerte.
  // Een sjabloonwissel blijft hierdoor tijdelijk totdat echt wordt opgeslagen.
  const savedOfferSnapshotRef = useRef(null);

  // right form refs (focus order)
  const orgRef = useRef(null);
  const contactRef = useRef(null);
  const invNumRef = useRef(null);
  const invDateRef = useRef(null);
  const statusRef = useRef(null);
  const payDateRef = useRef(null);
  const payAmtRef = useRef(null);
  const payNotesRef = useRef(null);

  const focusOrderRefs = useMemo(
    () => [
      orgRef,
      contactRef,
      invNumRef,
      invDateRef,
      payDateRef,
      payAmtRef,
      payNotesRef,
      statusRef,
    ],
    []
  );

  const [focusedKey, setFocusedKey] = useState("");

  function formHasId() {
    return form.id !== null && form.id !== undefined && String(form.id).length > 0;
  }

  // ---------- LOAD ORGS ----------
  useEffect(() => {
    let cancelled = false;

    async function loadInvoiceSettings() {
      try {
        const data = await tryFetchJson(["/api/invoice-settings"]);
        if (!cancelled) {
          setInvoiceSettings(data && typeof data === "object" ? data : {});
        }
      } catch {
        if (!cancelled) {
          setInvoiceSettings({});
        }
      }
    }

    loadInvoiceSettings();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function loadMkbDocumentSettings() {
      const selectedOrg = orgs.find(
        (x) => String(x.id || "") === String(form.organisation_id || "")
      );
      const companyCodeId =
        orgDetail?.company_code_id ||
        selectedOrg?.company_code_id ||
        items.find((x) => String(x.id || "") === String(form.id || ""))?.company_code_id ||
        "";

      const qs = companyCodeId
        ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
        : "";

      try {
        const offerData = await tryFetchJson([
          `/api/company-section-settings/mkb_offers${qs}`,
        ]);
        if (!cancelled) setOfferDocumentSettings(offerData?.settings || {});
      } catch {
        if (!cancelled) setOfferDocumentSettings({});
      }

      try {
        const orderData = await tryFetchJson([
          `/api/company-section-settings/mkb_orders${qs}`,
        ]);
        if (!cancelled) setOrderDocumentSettings(orderData?.settings || {});
      } catch {
        if (!cancelled) setOrderDocumentSettings({});
      }

      try {
        const letterheadData = await tryFetchJson([
          `/api/company-section-settings/mkb_letterhead${qs}`,
        ]);
        if (!cancelled) setLetterheadSettings(letterheadData?.settings || {});
      } catch {
        if (!cancelled) setLetterheadSettings({});
      }
    }

    loadMkbDocumentSettings();
    return () => { cancelled = true; };
  }, [form.id, form.organisation_id, orgDetail?.company_code_id, orgs, items]);

  useEffect(() => {
    let cancelled = false;
    async function loadGeneralSettings() {
      try { const data = await tryFetchJson(["/api/general-settings"]); if (!cancelled) setGeneralSettings({ offer_prices_include_vat: data?.offer_prices_include_vat === true }); }
      catch { if (!cancelled) setGeneralSettings({ offer_prices_include_vat: false }); }
    }
    loadGeneralSettings();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function loadOrderSettings() {
      try {
        const data = await tryFetchJson(["/api/order-settings"]);
        if (!cancelled) {
          setOrderSettings({
            use_work_orders: data?.use_work_orders === true,
          });
        }
      } catch {
        if (!cancelled) {
          setOrderSettings({ use_work_orders: false });
        }
      }
    }

    loadOrderSettings();

    return () => {
      cancelled = true;
    };
  }, []);

useEffect(() => {
    let cancelled = false;

    async function loadOfferTemplates() {
      try {
        const companyCodeId =
          orgDetail?.company_code_id ||
          selectedOrgFromList?.company_code_id ||
          items.find((x) => String(x.id || "") === String(form.id || ""))?.company_code_id ||
          "";
        const suffix = companyCodeId ? `&company_code_id=${encodeURIComponent(companyCodeId)}` : "";
        const data = await tryFetchJson([`/api/offer-templates?active=1${suffix}`, "/api/offer-templates?active=1"]);
        if (!cancelled) setOfferTemplates(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setOfferTemplates([]);
      }
    }

    loadOfferTemplates();

    return () => {
      cancelled = true;
    };
  }, [form.id, form.organisation_id, orgDetail?.company_code_id, orgs, items]);

useEffect(() => {
    let cancelled = false;

    async function loadProjectItems() {
      try {
        const data = await tryFetchJson(["/api/projectmanagement"]);
        if (!cancelled) setProjectItems(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setProjectItems([]);
      }
    }

    loadProjectItems();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function loadOrgs() {
      try {
        const orgData = await tryFetchJson(["/api/organisations?q=", "/api/organisations"]);
        if (!cancelled) setOrgs(Array.isArray(orgData) ? orgData : []);
      } catch {
        if (!cancelled) setOrgs([]);
      }
    }

    loadOrgs();
    return () => {
      cancelled = true;
    };
  }, []);

function pickOrgName(o) {
    return o?.name || o?.naam || o?.bedrijfsnaam || "";
  }

  function pickOrgSearchName(o) {
    return (
      o?.search_name ||
      o?.zoeknaam ||
      o?.zoek_naam ||
      o?.organisation_search_name ||
      o?.organisatie_zoeknaam ||
      pickOrgName(o)
    );
  }

  const sortedOrgs = useMemo(
    () =>
      (Array.isArray(orgs) ? orgs : [])
        .slice()
        .sort((a, b) =>
          safeTrim(pickOrgSearchName(a)).localeCompare(
            safeTrim(pickOrgSearchName(b)),
            "nl",
            { sensitivity: "base", numeric: true }
          )
        ),
    [orgs]
  );

  function isPrivateRelation(o) {
    const entityType = String(
      o?.relation_entity_type ||
      o?.relation_type ||
      o?.entity_type ||
      ""
    )
      .toLowerCase()
      .trim();

    return (
      entityType === "private" ||
      entityType === "particulier" ||
      entityType === "person" ||
      entityType === "persoon"
    );
  }

  function pickOrgSearchNameFromRow(it) {
    const org =
      orgs.find((o) => String(o.id) === String(it?.organisation_id || "")) ||
      null;

    return (
      pickOrgSearchName(org) ||
      it?.organisation_search_name ||
      it?.organisation_zoeknaam ||
      it?.search_name ||
      it?.organisation_name ||
      ""
    );
  }

  function pickCompanyCodeName(row) {
    return (
      row?.company_code_name ||
      row?.bedrijfscode_naam ||
      row?.bedrijfscode ||
      row?.company_code ||
      ""
    );
  }

  function pickCompanyCodeNameFromOrganisation(org) {
    return (
      org?.company_code_name ||
      org?.bedrijfscode_naam ||
      org?.bedrijfscode ||
      org?.company_code ||
      ""
    );
  }

  function pickContactFullName(c) {
    const fn = c?.first_name || c?.voornaam || "";
    const tv = c?.name_prefix || c?.tussenvoegsels || c?.tussenvoegsel || "";
    const ln = c?.last_name || c?.achternaam || "";
    const merged = [fn, tv, ln].map(safeTrim).filter(Boolean).join(" ");
    const full = safeTrim(c?.full_name || c?.naam || "");
    return merged || full || "";
  }

  function pickContactNameFromRow(it) {
    const fn = safeTrim(it?.contact_first_name || "");
    const tv = safeTrim(it?.contact_name_prefix || "");
    const ln = safeTrim(it?.contact_last_name || "");
    const merged = [fn, tv, ln].filter(Boolean).join(" ").trim();
    return merged || safeTrim(it?.contact_name || "");
  }

// ---------- LOAD CONTACTS (voor gekozen relatie) ----------
  // Bij Particulieren is Contactpersoon niet van toepassing.
  useEffect(() => {
    let cancelled = false;

    async function loadContacts() {
      try {
        const selectedRelation = orgs.find(
          (o) => String(o.id) === String(form?.organisation_id || "")
        );

        const isPrivate = isPrivateRelation(selectedRelation);

        if (!form?.organisation_id || isPrivate) {
          if (!cancelled) setContacts([]);
          return;
        }

        const data = await tryFetchJson([
          `/api/contacts?organisation_id=${encodeURIComponent(form.organisation_id)}`
        ]);

        if (!cancelled) setContacts(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setContacts([]);
      }
    }

    loadContacts();
    return () => {
      cancelled = true;
    };
  }, [form?.organisation_id, orgs]);

  // ---------- LOAD INVOICES ----------
  const serverQuery = useMemo(() => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    return p.toString();
  }, [q]);

  useEffect(() => {
    let cancelled = false;

    async function loadItems() {
      setLoading(true);
      setError(null);

      try {
const data = await tryFetchJson(
          [`/api/offers?${serverQuery}`, "/api/offers"]
        );

        if (cancelled) return;

        const arr = Array.isArray(data) ? data : [];

        // 🔥 HIER ZAT HET PROBLEEM
        setItems(arr);

      } catch (e) {
        if (!cancelled) setError(e?.message || String(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadItems();

    return () => {
      cancelled = true;
    };
  }, [serverQuery, reloadKey]);

  // ---------- GRID OPTIONS ----------
const zoeknaamOptions = useMemo(() => {
    const set = new Set(
      items
        .map((x) => safeTrim(pickOrgSearchNameFromRow(x)))
        .filter(Boolean)
    );

    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items, orgs]);

  const contactOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(pickContactNameFromRow(x))).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const invoiceNrOptions = useMemo(() => {
    const set = new Set(items.map((x) => offerReferenceValue(x)).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const invoiceDateOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(isoDate(x.invoice_date) || "")).filter(Boolean));
    // nieuw->oud
    return Array.from(set).sort((a, b) => (a === b ? 0 : a < b ? 1 : -1));
  }, [items]);

  const totaalOptions = [...new Set(items.map(x => x.total))];

  const telOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_phone || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const mobOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_mobile || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const emailOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_email || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const cityOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_city || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const countryOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_country || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const companyCodeOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(pickCompanyCodeName(x))).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

const statusOptions = [
  "Offerte",
  "Opdracht",
  "Factuur",
];

const statusSelectOptions = [
  { value: "OFFERTE", label: "Offerte" },
  { value: "OPDRACHT", label: "Opdracht" },
  { value: "FACTUUR", label: "Factuur" },
];

  // paidFilter opties zijn (alle/open/betaald); wordt client-side berekend op basis van payments.
  // In grid tonen we status "open/betaald" op basis van payments in detail; voor grid gebruiken we server.status als indicatie.
  const paidOptions = ["open", "betaald"];

  // ---------- FILTER + SORT ----------
  const filteredItems = useMemo(() => {
    const qq = norm(q);
    const arr = items.slice();

    const byQ = (it) => {
      if (!qq) return true;
      const hay = norm(
        [
          it.organisation_name || "",
          pickContactNameFromRow(it),
          offerReferenceValue(it),
          isoDate(it.invoice_date),
          it.org_city || "",
          it.org_country || "",
          it.status || "",
          pickCompanyCodeName(it),
        ].join(" ")
      );
      return hay.includes(qq);
    };

    const byCol = (it) => {
      const orgName = safeTrim(pickOrgSearchNameFromRow(it));
      const contactName = safeTrim(pickContactNameFromRow(it));
      const invNr = offerReferenceValue(it);
      const invDt = safeTrim(isoDate(it.invoice_date) || "");
      const tel = safeTrim(it.org_phone || "");
      const mob = safeTrim(it.org_mobile || "");
      const email = safeTrim(it.org_email || "");
      const city = safeTrim(it.org_city || "");
      const ctry = safeTrim(it.org_country || "");
      const companyCodeName = safeTrim(pickCompanyCodeName(it));
      const st = statusLabel(it.status);

      const match = (val, filt) => {
        if (!filt) return true;
        if (filt === EMPTY_VAL) return !safeTrim(val);
        return String(val) === String(filt);
      };

      if (!match(orgName, zoeknaamFilter)) return false;
      if (!match(contactName, contactFilter)) return false;
      if (!match(invNr, invoiceNrFilter)) return false;
      if (!match(invDt, invoiceDateFilter)) return false;
      if (!match(it.total, totaalFilter)) return false;
      if (!match(tel, telFilter)) return false;
      if (!match(mob, mobFilter)) return false;
      if (!match(email, emailFilter)) return false;
      if (!match(city, cityFilter)) return false;
      if (!match(ctry, countryFilter)) return false;
      if (!match(st, statusFilter)) return false;
      if (!match(companyCodeName, companyCodeFilter)) return false;

      // paidFilter: op grid-niveau hebben we geen payments per offerte geladen.
      // We gebruiken simpele heuristiek: status=gefactureerd => open/betaald onbekend (laat leeg), tenzij user filtert -> dan laten we alles door.
      if (!paidFilter) return true;
      // Als je wilt filteren op betaald/open: we laten dit nu nog "alle" (anders gaan we offerte-per-offerte payments ophalen: te zwaar).
      // Je kunt betaald/open wél rechts zien zodra je een offerte selecteert.
      return true;
    };

    return arr.filter((it) => {
      if (
        organisationFilterId &&
        String(it.organisation_id || "") !== String(organisationFilterId)
      ) {
        return false;
      }

      return byQ(it) && byCol(it);
    });
}, [
    items,
    orgs,
    q,
    zoeknaamFilter,
    contactFilter,
    invoiceNrFilter,
    invoiceDateFilter,
    totaalFilter,
    telFilter,
    mobFilter,
    emailFilter,
    cityFilter,
    countryFilter,
    statusFilter,
    companyCodeFilter,
    paidFilter,
    organisationFilterId,
  ]);

const sortedItems = useMemo(() => {
    const copy = filteredItems.slice();
    const dirMul = sort.dir === "desc" ? -1 : 1;

    const cmpText = (a, b) => {
      const aa = norm(a);
      const bb = norm(b);
      if (aa === bb) return 0;
      return aa < bb ? -1 : 1;
    };

    const cmpDate = (a, b) => {
      const aa = isoDate(a) || "";
      const bb = isoDate(b) || "";
      if (aa === bb) return 0;
      return aa < bb ? -1 : 1;
    };

    const customSort = (a, b) => {
      if (sort.key === "invoice_date") return dirMul * cmpDate(a.invoice_date, b.invoice_date);
      if (sort.key === "invoice_number") return dirMul * cmpText(offerReferenceValue(a), offerReferenceValue(b));
      if (sort.key === "org") return dirMul * cmpText(pickOrgSearchNameFromRow(a), pickOrgSearchNameFromRow(b));
      if (sort.key === "contact") return dirMul * cmpText(pickContactNameFromRow(a), pickContactNameFromRow(b));
      if (sort.key === "totaal") return dirMul * ((Number(a.total || 0)) - (Number(b.total || 0)));
      if (sort.key === "city") return dirMul * cmpText(a.org_city || "", b.org_city || "");
      if (sort.key === "country") return dirMul * cmpText(a.org_country || "", b.org_country || "");
      if (sort.key === "status") return dirMul * cmpText(statusLabel(a.status), statusLabel(b.status));
      if (sort.key === "company_code") return dirMul * cmpText(pickCompanyCodeName(a), pickCompanyCodeName(b));
      return dirMul * cmpDate(a.invoice_date, b.invoice_date);
    };

    copy.sort(customSort);
    return copy;
  }, [filteredItems, sort, orgs]);

    useEffect(() => {
    if (loading || !items.length) return;

    let reopenId = "";

    try {
      reopenId = sessionStorage.getItem("staffiq_reopen_offer_id") || "";
    } catch {}

    if (!reopenId) return;

    const row = items.find((item) => String(item.id) === String(reopenId));
    if (!row) return;

    try {
      sessionStorage.removeItem("staffiq_reopen_offer_id");
    } catch {}

    const rowIndex = sortedItems.findIndex(
      (item) => String(item.id) === String(reopenId)
    );

    if (rowIndex >= 0) {
      setListIndex(rowIndex);
    }

    loadItemFromRow(row);
  }, [loading, items, sortedItems]);

const gridCount = Math.min(sortedItems.length, 9999);

  // ---------- LIST NAV HELPERS ----------
  function scrollMidTop() {
    try {
      if (midScrollRef.current) midScrollRef.current.scrollTop = 0;
    } catch { }
  }

  function scrollRightTop() {
    try {
      if (rightScrollRef.current) rightScrollRef.current.scrollTop = 0;
    } catch { }
  }

  function scrollRowIntoView(idx) {
    try {
      const el = rowRefs.current?.[idx];
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ block: "nearest" });
      }
    } catch { }
  }

  function clampIndex(idx, len) {
    const L = Number(len || 0);
    if (L <= 0) return -1;
    let x = Number.isFinite(idx) ? idx : 0;
    if (x < 0) x = 0;
    if (x > L - 1) x = L - 1;
    return x;
  }

  function ensureCursorExists() {
    const L = sortedItems.length;
    if (L <= 0) return -1;
    const idx = listIndex < 0 ? 0 : clampIndex(listIndex, L);
    if (idx !== listIndex) setListIndex(idx);
    return idx;
  }

  function moveCursor(delta) {
    setListIndex((prev) => {
      const L = sortedItems.length;
      if (L <= 0) return -1;
      const start = prev < 0 ? 0 : prev;
      const next = clampIndex(start + delta, L);
      setTimeout(() => scrollRowIntoView(next), 0);
      return next;
    });
  }



  function getFocusableElements() {
    const els = focusOrderRefs.map((r) => r?.current).filter(Boolean);
    return els.filter((el) => {
      try {
        if (el.disabled) return false;
        const rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      } catch {
        return false;
      }
    });
  }

function focusFirstRightField() {
    setTimeout(() => {
      try {
        scrollRightTop();
        orgRef.current?.focus?.();
      } catch { }
    }, 0);
  }

  function focusFirstRightFieldMobile() {
    setTimeout(() => {
      try {
        const panel = rightScrollRef.current;
        if (!panel) return;

        panel.scrollTop = 0;
        panel.scrollIntoView?.({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } catch {}
    }, 120);
  }

  function focusNextField(dir = +1) {
    const els = getFocusableElements();
    if (!els.length) return;

    const active = document.activeElement;
    let idx = els.findIndex((el) => el === active);
    if (idx === -1) idx = dir > 0 ? -1 : els.length;

    let next = idx + dir;
    if (next < 0) next = 0;
    if (next > els.length - 1) next = els.length - 1;

    const el = els[next];
    if (!el) return;

    try {
      el.focus?.();
      el.scrollIntoView?.({ block: "nearest" });
    } catch { }
  }

  // ---------- RIGHT PANEL LOADERS ----------
  async function loadOrgDetail(organisation_id) {
    const oid = safeTrim(organisation_id);
    if (!oid) return setOrgDetail(null);
    try {
      const det = await tryFetchJson([`/api/organisations/${encodeURIComponent(oid)}`]);
      setOrgDetail(det && typeof det === "object" ? det : null);
    } catch {
      setOrgDetail(null);
    }
  }

const selectedOrgFromList = useMemo(() => {
    const oid = String(form.organisation_id || "");
    if (!oid) return null;
    return orgs.find((o) => String(o.id || "") === oid) || null;
  }, [orgs, form.organisation_id]);

  const selectedRelationIsPrivate = isPrivateRelation(selectedOrgFromList);

  useEffect(() => {
    if (!selectedRelationIsPrivate) return;
    if (!form.contact_id) return;

    setForm((prev) => ({
      ...prev,
      contact_id: "",
    }));
  }, [selectedRelationIsPrivate, form.contact_id]);

  const currentInvoiceEmail = useMemo(() => {
    const selectedRow = items.find((x) => String(x.id || "") === String(form.id || ""));
    return safeTrim(
      orgDetail?.email ||
      selectedOrgFromList?.email ||
      selectedRow?.org_email ||
      ""
    );
  }, [orgDetail, selectedOrgFromList, items, form.id]);

  const currentInvoiceDigital = useMemo(() => {
    const selectedRow = items.find((x) => String(x.id || "") === String(form.id || ""));
    const raw =
      orgDetail?.receives_invoices_digital ??
      orgDetail?.digital_invoices ??
      orgDetail?.invoice_digital ??
      selectedOrgFromList?.receives_invoices_digital ??
      selectedOrgFromList?.digital_invoices ??
      selectedOrgFromList?.invoice_digital ??
      selectedRow?.receives_invoices_digital ??
      selectedRow?.digital_invoices ??
      selectedRow?.invoice_digital ??
      false;

    return raw === true || raw === 1 || raw === "1" || raw === "true" || raw === "ja";
  }, [orgDetail, selectedOrgFromList, items, form.id]);

async function loadPayments(invoiceId) {
  setPayments([]);
  return [];
}

function loadItemFromRowSync(it) {
  const selected = String(it?.id || "");

  setSelectedId(selected);

  const f = {
    ...emptyForm,
    id: selected,
    organisation_id: it?.organisation_id ? String(it.organisation_id) : "",
    contact_id: it?.contact_id ? String(it.contact_id) : "",
    template_id: it?.template_id ? String(it.template_id) : "",
    invoice_number: it?.invoice_number || "",
    reference: offerReferenceValue(it),
    series_code: it?.series_code || "",
    invoice_date: isoDate(it?.invoice_date) || "",
    due_date: isoDate(it?.due_date) || "",
    order_date: isoDate(it?.order_date) || "",
    planned_delivery_date: isoDate(it?.planned_delivery_date) || "",
    status: normalizeDbStatus(it?.status || "DRAFT"),
    delivery_status: String(it?.delivery_status || "NOT_DELIVERED").toUpperCase() === "DELIVERED"
      ? "DELIVERED"
      : "NOT_DELIVERED",
    notes: it?.notes || "",

    document_subject: it?.document_subject || "",
    document_show_subject: it?.document_show_subject !== false,
    document_salutation: it?.document_salutation || "",
    document_show_salutation: it?.document_show_salutation !== false,
    document_intro_text: it?.document_intro_text || "",
    document_show_intro_text: it?.document_show_intro_text !== false,
    document_body_text: it?.document_body_text || "",
    document_show_body_text: it?.document_show_body_text !== false,
    document_conditions_text: it?.document_conditions_text || "",
    document_show_conditions_text: it?.document_show_conditions_text !== false,
    document_payment_text: it?.document_payment_text || "",
    document_show_payment_text: it?.document_show_payment_text !== false,
    document_planning_text: it?.document_planning_text || "",
    document_show_planning_text: it?.document_show_planning_text !== false,
    document_remark_text: it?.document_remark_text || "",
    document_show_remark_text: it?.document_show_remark_text !== false,
    document_warranty_text: it?.document_warranty_text || "",
    document_show_warranty_text: it?.document_show_warranty_text !== false,
    document_closing_text: it?.document_closing_text || "",
    document_show_closing_text: it?.document_show_closing_text !== false,
    document_show_agreement_block: it?.document_show_agreement_block === true,
    document_agreement_text: it?.document_agreement_text || "",
    document_texts_initialized: it?.document_texts_initialized === true,
    document_order: Array.isArray(it?.document_order) ? it.document_order : [],

    subtotal: Number(it?.subtotal || 0),
    vat_total: Number(it?.vat_total || 0),
    total: Number(it?.total || 0),
    created_at: it?.created_at || "",
    updated_at: it?.updated_at || "",
  };

  setForm(f);
  savedOfferSnapshotRef.current = { ...f };
  setPayError(null);
  setSaveError(null);
  setFlash("");
}

async function loadItemFromRow(it) {
  const selected = String(it?.id || "");

  setLastApprovalInfo(null);
  setSelectedId(selected);
  loadItemFromRowSync(it);

  if (window.innerWidth <= 768) {
    focusFirstRightFieldMobile();
  }

  try {
    const det = await tryFetchJson([`/api/offers/${encodeURIComponent(selected)}`]);

    if (det && typeof det === "object") {
      const offerObj = det.offer ? det.offer : det;

      loadItemFromRowSync({
        ...it,
        ...offerObj,
        id: selected,
      });

      const loadedLines =
        Array.isArray(det.lines) ? det.lines :
        Array.isArray(det.items) ? det.items :
        Array.isArray(offerObj.lines) ? offerObj.lines :
        Array.isArray(offerObj.items) ? offerObj.items :
        [];

      setLines(loadedLines);
    } else {
      setLines([]);
    }
  } catch {
    setLines([]);
  }

  await loadOrgDetail(it?.organisation_id);

  setMode("form");

  if (window.innerWidth <= 768) {
    focusFirstRightFieldMobile();
  } else {
    setTimeout(() => {
      try {
        scrollRightTop();
        orgRef.current?.focus?.();
      } catch {}
    }, 0);
  }
}

  // ---------- ACTIES ----------
  function resetRightPanelEmpty() {
    setSelectedId(null);
    setForm(emptyForm);
    setOrgDetail(null);

    setPayments([]);
    setLines([]);
    setNewLineMode("");
    setProjectSearch("");
    setSelectedProjectIds([]);
    setExcludedProjectIds([]);
    setIncludeChildProjects(false);
    setShowProjectOfferText(false);
    setShowProjectInternalText(false);
    setExpandedProjectIds(new Set());
    setLineDraft({
      line_type: "Artikel",
      quantity: 1,
      description: "",
      unit: "",
      unit_price: "",
      vat_rate: "hoog",
    });

    setPayDraft({
      paid_on: new Date().toLocaleDateString("en-CA"),
      amount: "",
      notes: "",
    });

    setPayError(null);
    setSaveError(null);
    setLineError(null);
    setFlash("");
  }

  function resetAllGridFilters() {
    setZoeknaamFilter("");
    setContactFilter("");
    setInvoiceNrFilter("");
    setInvoiceDateFilter("");
    setTelFilter("");
    setMobFilter("");
    setCityFilter("");
    setCountryFilter("");
    setStatusFilter("");
    setCompanyCodeFilter("");
    setPaidFilter("");
  }

function vernieuwList() {
    setQ("");
    setOrganisationFilterId("");
    resetAllGridFilters();
    resetRightPanelEmpty();
    setLastApprovalInfo(null);
    setListIndex(-1);

    setHideVoiceError(true);
    setSort({ key: "invoice_date", dir: "desc" });
    setReloadKey((k) => k + 1);

    setMode("search");
    if (window.innerWidth > 768) {
      setTimeout(() => {
        try {
          searchRef.current?.focus?.();
        } catch {}
      }, 0);
    }

    setFlash("Vernieuwd ✅");
    setTimeout(() => setFlash(""), 800);
    setTimeout(() => scrollMidTop(), 0);
  }

  function newItem() {
    resetRightPanelEmpty();

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const todayIso = `${yyyy}-${mm}-${dd}`;

    const newForm = {
      ...emptyForm,
      organisation_id: "",
      contact_id: "",
      invoice_number: "",
      reference: "",
      status: "DRAFT",
      delivery_status: "NOT_DELIVERED",
      invoice_date: todayIso,
      due_date: addDaysIso(todayIso, Number(effectiveOfferSettings.validity_days || 14)),
      order_date: "",
      planned_delivery_date: "",
    };

    setForm(newForm);
    setMode("form");
    setListIndex(-1);
    setHideVoiceError(true);

    setTimeout(() => {
      try {
        scrollRightTop();
        orgRef.current?.focus?.();
      } catch { }
    }, 0);
  }

async function finalizeInvoice() {
  setSaveError(null);

  const currentStatus = normalizeDbStatus(form.status || "OFFERTE");

  if (currentStatus !== "OFFERTE") {
    setSaveError("Alleen offertes kunnen worden goedgekeurd.");
    return;
  }

  if (!formHasId()) {
    setSaveError(`Sla de ${getApprovalDocumentType() === "order" ? "opdracht" : "offerte"} eerst op.`);
    return;
  }

  if (!safeTrim(form.organisation_id)) {
    setSaveError("Kies eerst een organisatie.");
    return;
  }

  if (!safeTrim(form.invoice_date)) {
    setSaveError("Offertedatum is verplicht.");
    return;
  }

  // Reeds opgeslagen oudere artikelregels kunnen nog <br> bevatten.
  // Houd de offerte bewerkbaar totdat die regels zijn gecorrigeerd.
  const invalidArticleIndex = (Array.isArray(lines) ? lines : [])
    .findIndex((ln) => isAmountLine(ln) && !hasVisibleOfferDescription(lineDescription(ln)));
  if (invalidArticleIndex >= 0) {
    setSaveError(`Artikelregel ${invalidArticleIndex + 1} heeft geen omschrijving. Vul die eerst in voordat je de offerte goedkeurt.`);
    return;
  }

  const ok = window.confirm("Weet je zeker dat je deze offerte wilt goedkeuren?");
  if (!ok) return;

  try {
setSilentDocumentPreview(true);
setPopupMode("preview");
setShowLinesPopup(true);

// eerst React laten renderen
await new Promise((resolve) => requestAnimationFrame(resolve));
await new Promise((resolve) => requestAnimationFrame(resolve));

await saveOfferDocumentFromPreview(form.id, "offer");

setShowLinesPopup(false);
setSilentDocumentPreview(false);

    const compatibleOrderTemplate =
      (offerTemplates || []).find(
        (tpl) =>
          tpl?.active !== false &&
          ["order", "both"].includes(String(tpl?.template_type || "").toLowerCase())
      ) || null;

    const orderIntroText =
      safeTrim(orderDocumentSettings.intro_text) ||
      safeTrim(orderDocumentSettings.offer_text) ||
      effectiveDocumentTexts.document_intro_text ||
      "";

    const finalForm = {
      ...form,
      status: "OPDRACHT",
      template_id: compatibleOrderTemplate?.id
        ? String(compatibleOrderTemplate.id)
        : form.template_id,
      document_subject:
        compatibleOrderTemplate?.subject ||
        form.document_subject ||
        "bevestiging opdracht",
      ...documentVisibilityPayload(
        compatibleOrderTemplate ? templateTexts(compatibleOrderTemplate) : effectiveDocumentTexts
      ),
      document_salutation:
        compatibleOrderTemplate?.salutation ||
        effectiveDocumentTexts.document_salutation ||
        "",
      document_intro_text:
        compatibleOrderTemplate?.intro_text ||
        orderIntroText,
      document_body_text:
        compatibleOrderTemplate?.body_text ||
        effectiveDocumentTexts.document_body_text ||
        "",
      document_conditions_text:
        compatibleOrderTemplate?.conditions_text ||
        effectiveDocumentTexts.document_conditions_text ||
        "",
      document_payment_text:
        compatibleOrderTemplate?.payment_text ||
        effectiveDocumentTexts.document_payment_text ||
        "",
      document_planning_text:
        compatibleOrderTemplate?.planning_text ||
        effectiveDocumentTexts.document_planning_text ||
        "",
      document_remark_text:
        compatibleOrderTemplate?.remark_text ||
        effectiveDocumentTexts.document_remark_text ||
        "",
      document_warranty_text:
        compatibleOrderTemplate?.warranty_text ||
        effectiveDocumentTexts.document_warranty_text ||
        "",
      document_closing_text:
        compatibleOrderTemplate?.closing_text ||
        effectiveDocumentTexts.document_closing_text ||
        "",
      document_show_agreement_block:
        compatibleOrderTemplate
          ? compatibleOrderTemplate.show_agreement_block === true
          : effectiveDocumentTexts.document_show_agreement_block === true,
      document_agreement_text:
        compatibleOrderTemplate?.agreement_text ||
        effectiveDocumentTexts.document_agreement_text ||
        "",
      document_texts_initialized: true,
    };

    const payload = {
      organisation_id: finalForm.organisation_id ? Number(finalForm.organisation_id) : null,
      contact_id: finalForm.contact_id ? Number(finalForm.contact_id) : null,
      template_id: finalForm.template_id ? Number(finalForm.template_id) : null,
      invoice_date: finalForm.invoice_date || null,
      due_date: finalForm.due_date || null,
      order_date: finalForm.order_date || null,
      planned_delivery_date: finalForm.planned_delivery_date || null,
      invoice_number: finalForm.invoice_number || null,
      reference: offerReferenceValue(finalForm),
      status: "OPDRACHT",
      delivery_status: form.delivery_status || "NOT_DELIVERED",
      series_code: finalForm.series_code || null,
      notes: finalForm.notes || "",

      document_subject: finalForm.document_subject || "",
      ...documentVisibilityPayload(finalForm),
      document_salutation: finalForm.document_salutation || "",
      document_intro_text: finalForm.document_intro_text || "",
      document_body_text: finalForm.document_body_text || "",
      document_conditions_text: finalForm.document_conditions_text || "",
      document_payment_text: finalForm.document_payment_text || "",
      document_planning_text: finalForm.document_planning_text || "",
      document_remark_text: finalForm.document_remark_text || "",
      document_warranty_text: finalForm.document_warranty_text || "",
      document_closing_text: finalForm.document_closing_text || "",
      document_show_agreement_block: finalForm.document_show_agreement_block === true,
      document_agreement_text: finalForm.document_agreement_text || "",
      document_texts_initialized: true,

      subtotal: invoiceTotals.subtotal || 0,
      vat_total: invoiceTotals.vatTotal || 0,
      total: invoiceTotals.total || 0,
    };

    const saved = await tryFetchJson([`/api/offers/${finalForm.id}`], {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (saved && typeof saved === "object") {
      setItems((prev) => upsertById(prev, saved));
      setForm((prev) => ({
        ...prev,
        ...finalForm,
        ...saved,
        status: "OPDRACHT",
      }));
    }

    await refreshSelectedInvoice();

    setFlash("Offerte goedgekeurd en opgeslagen bij documenten ✅");
    setTimeout(() => setFlash(""), 1200);
  } catch (e) {
    setShowLinesPopup(false);
    setSilentDocumentPreview(false);
    setSaveError(e?.message || String(e));
  }
}

function buildOfferPrintHtml() {
  const el = popupPrintRef.current;
  if (!el) return "";

  // Niet vertrouwen op de tijdelijke bewerk-/voorbeeldstand van React.
  // Ook als de afdruk direct uit Bewerken komt, nooit letterlijke {aanhef} printen.
  const printableDocumentContent = fillOfferTokens(el.innerHTML);

  const letterheadImageHtml = useOwnLetterhead
    ? `<img class="staffiq-letterhead-background" src="${letterheadBackgroundDataUrl}" alt="" />`
    : "";

  return `
    <html>
      <head>
        <title>${normalizeDbStatus(form.status || "OFFERTE") === "OFFERTE" ? "Offerte" : "Opdrachtbevestiging"}</title>
        <style>
          @page {
            size: A4;
            margin: ${useOwnLetterhead ? "0" : "18mm 12mm 12mm 12mm"};
          }

          @page:first {
            size: A4;
            margin: ${useOwnLetterhead ? "0" : "12mm"};
          }

          html, body {
            margin: 0;
            padding: 0;
            background: #fff;
            font-family: Calibri, Carlito, Arial, sans-serif;
            color: #222;
          }

          body {
            font-size: 11pt;
            line-height: 1.15;
          }

          .staffiq-offer-fixed-text, .staffiq-offer-fixed-text *, .staffiq-offer-date-text, .staffiq-offer-date-text * { font-family: Calibri, Carlito, Arial, sans-serif !important; font-size: 11pt !important; line-height: 1.15 !important; }
          .staffiq-offer-agreement, .staffiq-offer-agreement * { font-family: Calibri, Carlito, Arial, sans-serif !important; font-size: 11pt !important; }
          .staffiq-letterhead-background {
            position: fixed;
            left: 0;
            top: 0;
            width: 210mm;
            height: 297mm;
            object-fit: fill;
            z-index: 0;
            pointer-events: none;
          }

          .letterhead-page-table {
            width: 210mm;
            border-collapse: collapse;
            border-spacing: 0;
            table-layout: fixed;
          }

          .letterhead-page-table td {
            padding: 0 !important;
            border: 0 !important;
          }

          .letterhead-header-space { height: 48mm; }
          .letterhead-footer-space { height: 42mm; }

          .print-wrap {
            position: relative;
            z-index: 1;
            width: 186mm;
            max-width: 186mm;
            margin: 0 auto;
            box-sizing: border-box;
          }

          ${useOwnLetterhead ? ".offer-document-header { margin-top: 0 !important; }" : ""}

          /* vOFF-142: afdrukbare paginaovergang tussen twee opgeslagen documentonderdelen.
             De PDF-renderer (Chromium) behandelt dit als een echte nieuwe A4-pagina. */
          .staffiq-print-page-break {
            display: block !important;
            break-after: page !important;
            page-break-after: always !important;
            break-before: auto !important;
            page-break-before: auto !important;
            height: 0 !important;
            min-height: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            border: 0 !important;
            overflow: hidden !important;
          }
          .staffiq-print-page-break-label { display: none !important; }
          /* Geen onbedoelde verplaatsing van complete project- of artikelblokken. */
          .staffiq-offer-project-text, .staffiq-offer-line-description,
          .staffiq-offer-project-row, .staffiq-offer-article-row,
          .staffiq-rich-text-surface, .print-wrap {
            break-inside: auto !important;
            page-break-inside: auto !important;
          }
          /* Handmatige markeringen moeten ook binnen het briefpapier-tabelmodel werken. */
          .letterhead-page-table tbody, .letterhead-page-table tbody tr,
          .letterhead-page-table tbody td { break-inside: auto !important; page-break-inside: auto !important; }

          /* Projectteksten ook in de PDF compact tonen; geen standaard alinea-witruimte. */
          .staffiq-offer-project-row { line-height: 1.15 !important; padding-top: 1px !important; padding-bottom: 1px !important; }
          .staffiq-offer-project-row .staffiq-offer-line-description p,
          .staffiq-offer-project-row .staffiq-offer-line-description div,
          .staffiq-offer-project-row .staffiq-offer-line-description ul,
          .staffiq-offer-project-row .staffiq-offer-line-description ol { margin-top: 0 !important; margin-bottom: 0 !important; }

          button,
          .offer-top-actions,
          .offer-bottom-actions,
          .offer-edit-label,
          .offer-edit-toolbar,
          .rich-text-toolbar {
            display: none !important;
          }

          [contenteditable="true"] {
            outline: none !important;
            box-shadow: none !important;
            background: transparent !important;
          }

          .offer-total-footer-block,
          .offer-totals-block,
          .offer-footer-block {
            break-inside: auto !important;
            page-break-inside: auto !important;
            break-before: auto !important;
            page-break-before: auto !important;
            break-after: auto !important;
            page-break-after: auto !important;
          }

          .offer-total-footer-block *,
          .offer-totals-block *,
          .offer-footer-block * {
            break-inside: auto !important;
            page-break-inside: auto !important;
          }

          input, textarea, select {
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            background: transparent !important;
            appearance: none !important;
            -webkit-appearance: none !important;
            color: #222 !important;
          }

          ::-webkit-scrollbar {
            display: none;
          }
        </style>
      </head>
      <body>
        ${letterheadImageHtml}
        ${useOwnLetterhead ? `
          <table class="letterhead-page-table">
            <thead>
              <tr><td><div class="letterhead-header-space"></div></td></tr>
            </thead>
            <tbody>
              <tr><td><div class="print-wrap">${printableDocumentContent}</div></td></tr>
            </tbody>
            <tfoot>
              <tr><td><div class="letterhead-footer-space"></div></td></tr>
            </tfoot>
          </table>
        ` : `
          <div class="print-wrap">
            ${printableDocumentContent}
          </div>
        `}
      </body>
    </html>
  `;
}

async function waitForOfferPreviewHtml() {
  for (let i = 0; i < 50; i += 1) {

    // popup moet echt bestaan
    if (!popupPrintRef.current) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      continue;
    }

    const html = buildOfferPrintHtml();

    // Een nieuwe offerte kan nog géén offerteregels hebben.
    // Daarom niet meer eisen dat "Aantal" en "Omschrijving" in de HTML staan.
    // Zodra de afdruk-HTML zelf volledig is opgebouwd, mag het document
    // worden opgeslagen.
    if (
      html &&
      html.length > 1500 &&
      /<html[\s>]/i.test(html) &&
      /<body[\s>]/i.test(html)
    ) {
      return html;
    }

    await new Promise((resolve) => setTimeout(resolve, 100));
  }

  return "";
}

async function saveOfferDocumentFromPreview(offerId, kind = "offer") {
  if (!offerId) return;

  const html = await waitForOfferPreviewHtml();

  if (!html) {
    throw new Error("Offerte/opdracht voorbeeld niet gevonden voor documentopslag.");
  }

  await tryFetchJson(
    [`/api/offers/${encodeURIComponent(offerId)}/save-document-html`],
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html, kind }),
    }
  );
}

async function saveCurrentOfferDocumentAfterSave(offerId, { keepPopupOpen = false } = {}) {
  if (!offerId) return;

  const id = String(offerId);
  const det = await tryFetchJson([`/api/offers/${encodeURIComponent(id)}`]);
  const offerObj = det?.offer ? det.offer : det;

  if (!offerObj || typeof offerObj !== "object") {
    throw new Error("Opgeslagen offerte/opdracht kon niet opnieuw worden geladen voor documentopslag.");
  }

  const loadedLines =
    Array.isArray(det?.lines) ? det.lines :
    Array.isArray(det?.items) ? det.items :
    Array.isArray(offerObj?.lines) ? offerObj.lines :
    Array.isArray(offerObj?.items) ? offerObj.items :
    [];

  setSelectedId(id);
  setForm((prev) => ({
    ...prev,
    ...offerObj,
    id,
    organisation_id: offerObj?.organisation_id
      ? String(offerObj.organisation_id)
      : prev.organisation_id,
    contact_id: offerObj?.contact_id
      ? String(offerObj.contact_id)
      : prev.contact_id,
    status: normalizeDbStatus(offerObj?.status || prev.status || "OFFERTE"),
  }));
  setLines(loadedLines);

  await loadOrgDetail(offerObj?.organisation_id || form.organisation_id);

  setSilentDocumentPreview(true);
  setPopupMode("preview");
  setShowLinesPopup(true);

  try {
    // React eerst de zojuist opgeslagen gegevens en regels laten renderen.
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const kind =
      normalizeDbStatus(offerObj?.status || "OFFERTE") === "OPDRACHT"
        ? "order"
        : "offer";

    await saveOfferDocumentFromPreview(id, kind);
  } finally {
    setShowLinesPopup(keepPopupOpen);
    setSilentDocumentPreview(false);
    if (keepPopupOpen) setPopupMode("edit");
  }
}

async function printOfferPopup() {
  // vOFF-135: Chrome plakt datum, Offerte en about:blank op een HTML-afdruk.
  // Render daarom eerst de al bestaande StaffIQ-PDF, zonder browserkop/voettekst.
  const pdfWindow = window.open("", "_blank");
  if (!pdfWindow) {
    setLineError("Pop-up geblokkeerd. Sta pop-ups toe of druk af via het PDF-voorbeeld.");
    return;
  }

  try {
    pdfWindow.document.title = "Offerte wordt voorbereid...";
    pdfWindow.document.body.textContent = "Afdrukklare PDF wordt gemaakt...";
    const html = buildOfferPrintHtml();
    if (!html) throw new Error("Offertevoorbeeld ontbreekt.");
    const blob = await fetchPdfBlob("/api/offers/preview-pdf-html", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html }),
    });
    const pdfUrl = URL.createObjectURL(blob);
    pdfWindow.location.replace(pdfUrl);
    // Het PDF-venster heeft een eigen printknop; dit voorkomt browserkop/-voetregels.
  } catch (err) {
    try { pdfWindow.close(); } catch {}
    setLineError(err?.message || "Afdrukklare PDF kon niet worden gemaakt.");
  }
}


function boolFromAny(value) {
  return value === true || value === 1 || value === "1" || value === "true" || value === "ja" || value === "j";
}

function getApprovalDocumentType() {
  const status = normalizeDbStatus(form.status || "OFFERTE");
  return status === "OPDRACHT" || status === "FACTUUR" ? "order" : "offer";
}

function getApprovalDocumentLabel() {
  return getApprovalDocumentType() === "order" ? "Opdracht" : "Offerte";
}

function getRelationApprovalPreference() {
  const org = activeOrg || selectedOrgFromList || selectedInvoiceRow || {};
  const mobile = safeTrim(org.mobile || org.org_mobile || selectedInvoiceRow?.org_mobile || "");
  const email = safeTrim(org.email || org.org_email || currentInvoiceEmail || "");

  const whatsappAllowed = boolFromAny(org.correspondence_whatsapp) && !!mobile;
  const emailAllowed = boolFromAny(org.correspondence_email) && !!email;

  if (whatsappAllowed) {
    return {
      primary: "whatsapp",
      fallback: emailAllowed ? "email" : "",
      mobile,
      email,
      whatsappAllowed,
      emailAllowed,
    };
  }

  if (emailAllowed) {
    return {
      primary: "email",
      fallback: "",
      mobile,
      email,
      whatsappAllowed,
      emailAllowed,
    };
  }

  return {
    primary: "",
    fallback: "",
    mobile,
    email,
    whatsappAllowed,
    emailAllowed,
  };
}

function openApprovalUrl(url) {
  const u = safeTrim(url);
  if (!u) return;
  window.open(u, "_blank", "noopener,noreferrer");
  setLastApprovalInfo(null);
}

function isMobileDeviceForWhatsapp() {
  try {
    return /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent || "");
  } catch {
    return false;
  }
}

function whatsappAppUrlFromWebUrl(webUrl) {
  const raw = safeTrim(webUrl);
  if (!raw) return "";

  try {
    const parsed = new URL(raw);
    const host = String(parsed.hostname || "").toLowerCase();

    if (!host.includes("wa.me") && !host.includes("whatsapp.com")) {
      return raw;
    }

    let phone = "";

    if (host.includes("wa.me")) {
      phone = parsed.pathname.replace(/^\/+/, "").split("/")[0] || "";
    } else {
      phone = parsed.searchParams.get("phone") || "";
    }

    const text = parsed.searchParams.get("text") || "";
    const params = new URLSearchParams();

    if (phone) params.set("phone", phone.replace(/[^\d]/g, ""));
    if (text) params.set("text", text);

    const query = params.toString();
    return `whatsapp://send${query ? `?${query}` : ""}`;
  } catch {
    return raw;
  }
}

function bestWhatsappOpenUrl(webUrl) {
  const raw = safeTrim(webUrl);
  if (!raw) return "";

  if (isMobileDeviceForWhatsapp()) {
    return whatsappAppUrlFromWebUrl(raw);
  }

  return raw;
}

function openWhatsAppSmart(webUrl) {
  const raw = safeTrim(webUrl);
  if (!raw) return;

  const target = bestWhatsappOpenUrl(raw);

  if (isMobileDeviceForWhatsapp()) {
    try {
      window.location.href = target;
      return;
    } catch {}
  }

  window.open(target, "_blank", "noopener,noreferrer");
}

function escapeAttr(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function writeWhatsappReadyPage(whatsappWindow, webUrl) {
  if (!whatsappWindow || whatsappWindow.closed) return false;

  const raw = safeTrim(webUrl);
  if (!raw) return false;

  const appUrl = bestWhatsappOpenUrl(raw);
  const fallbackUrl = raw;

  try {
    whatsappWindow.document.open();
    whatsappWindow.document.write(`
      <html>
        <head>
          <title>WhatsApp openen</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </head>
        <body style="font-family: Calibri, Carlito, Arial, sans-serif; padding: 24px; line-height: 1.45; color: #111;">
          <h2>WhatsApp staat klaar</h2>
          <p>
            Tik op de groene knop hieronder om het bericht in WhatsApp te openen.
            Daarna moet je het bericht zelf nog verzenden.
          </p>

          <p style="margin: 24px 0;">
            <a
              href="${escapeAttr(appUrl)}"
              style="display:inline-block;background:#25D366;color:#111;text-decoration:none;padding:14px 18px;border-radius:8px;font-weight:700;"
            >
              Open WhatsApp
            </a>
          </p>

          <p style="font-size:13px;color:#555;">
            Werkt de groene knop niet? Probeer dan deze koppeling:<br />
            <a href="${escapeAttr(fallbackUrl)}" style="word-break:break-all;">Open via WhatsApp-web</a>
          </p>
        </body>
      </html>
    `);
    whatsappWindow.document.close();

    // We proberen de app alsnog automatisch te openen. Sommige mobiele browsers staan dit
    // na een async actie niet toe; daarom blijft de handmatige knop zichtbaar als fallback.
    if (isMobileDeviceForWhatsapp()) {
      setTimeout(() => {
        try {
          whatsappWindow.location.href = appUrl;
        } catch {}
      }, 250);
    } else {
      try {
        whatsappWindow.location.href = fallbackUrl;
      } catch {}
    }

    return true;
  } catch {
    return false;
  }
}

function chooseApprovalChannel(pref, docLabel) {
  if (pref.whatsappAllowed && pref.emailAllowed) {
    const choice = window.prompt(
      `${docLabel} ${form.invoice_number || form.id} ter akkoord aanbieden.

Kies verzendwijze:
1 = WhatsApp
2 = E-mail
3 = WhatsApp + E-mail`,
      "1"
    );

    const c = String(choice || "").trim().toLowerCase();
    if (!c) return "";
    if (c === "1" || c === "w" || c === "wa" || c === "whatsapp") return "whatsapp";
    if (c === "2" || c === "e" || c === "email" || c === "e-mail" || c === "mail") return "email";
    if (c === "3" || c === "beide" || c === "allebei" || c === "whatsapp + email" || c === "whatsapp + e-mail") return "both";

    alert("Ongeldige keuze. Gebruik 1, 2 of 3.");
    return "";
  }

  if (pref.whatsappAllowed) return "whatsapp";
  if (pref.emailAllowed) return "email";
  return "";
}

function approvalChannelLabel(channel) {
  if (channel === "both") return "WhatsApp + E-mail";
  if (channel === "whatsapp") return "WhatsApp";
  if (channel === "email") return "E-mail";
  return "";
}

async function sendApprovalEmail(approvalId) {
  if (!approvalId) throw new Error("Akkoordverzoek-id ontbreekt.");

  return await tryFetchJson(
    [`/api/document-approvals/${encodeURIComponent(approvalId)}/send-email`],
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    }
  );
}

async function createApprovalRequest(channel) {
  const docType = getApprovalDocumentType();
  const docLabel = getApprovalDocumentLabel();

  const approvalText = safeTrim(effectiveOfferSettings.approval_text)
    ? safeTrim(effectiveOfferSettings.approval_text)
    : `Ik verklaar bevoegd te zijn om namens ${recipientName || "de relatie"} akkoord te geven op deze ${docLabel.toLowerCase()} ${form.invoice_number || form.id || ""}.`;

  return await tryFetchJson(["/api/document-approvals"], {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      document_type: docType,
      document_id: Number(form.id),
      channel,
      approval_text: approvalText,
      remarks: "",
    }),
  });
}

async function sendOfferForApproval() {
  setSaveError(null);
  setLastApprovalInfo(null);

  if (!formHasId()) {
    setSaveError("Sla de offerte/opdracht eerst op.");
    return;
  }

  const pref = getRelationApprovalPreference();

  if (!pref.whatsappAllowed && !pref.emailAllowed) {
    setSaveError("Bij deze relatie staat geen akkoord via WhatsApp of E-mail aangevinkt. De huidige procedure blijft van toepassing.");
    return;
  }

  if (!popupPrintRef.current) {
    setSaveError("Open eerst het voorbeeld van de offerte/opdracht.");
    return;
  }

  const docLabel = getApprovalDocumentLabel();
  const chosenChannel = chooseApprovalChannel(pref, docLabel);

  if (!chosenChannel) return;

  if (!(pref.whatsappAllowed && pref.emailAllowed)) {
    const ok = window.confirm(
      `${docLabel} ${form.invoice_number || form.id} ter akkoord aanbieden via ${approvalChannelLabel(chosenChannel)}?`
    );

    if (!ok) return;
  }

  // Belangrijk:
  // Browsers blokkeren vaak window.open na een async actie.
  // Daarom openen we het WhatsApp-tabblad alvast direct vanuit de klikactie.
  let whatsappWindow = null;
  const wantsWhatsapp = chosenChannel === "whatsapp" || chosenChannel === "both";

  if (wantsWhatsapp) {
    try {
      whatsappWindow = window.open("", "_blank");

      if (whatsappWindow) {
        try { whatsappWindow.opener = null; } catch {}
        whatsappWindow.document.open();
        whatsappWindow.document.write(`
          <html>
            <head><title>WhatsApp openen</title></head>
            <body style="font-family: Calibri, Carlito, Arial, sans-serif; padding: 24px;">
              <h2>WhatsApp wordt voorbereid...</h2>
              <p>Dit venster wordt zo doorgestuurd naar WhatsApp.</p>
            </body>
          </html>
        `);
        whatsappWindow.document.close();
      }
    } catch {
      whatsappWindow = null;
    }
  }

  try {
    setSendingApproval(true);

    const docType = getApprovalDocumentType();
    await saveOfferDocumentFromPreview(form.id, docType);

    const requestChannel = chosenChannel === "email" ? "email" : "whatsapp";
    const created = await createApprovalRequest(requestChannel);
    const approval = created?.approval || {};
    const approvalId = approval?.id || created?.id;
    const approvalUrl = created?.approval_url || approval?.approval_url || "";
    const whatsappUrl = created?.whatsapp_url || approval?.whatsapp_url || "";

    let popupBlocked = false;
    let emailResult = null;

    if (wantsWhatsapp) {
      if (whatsappUrl) {
        if (whatsappWindow && !whatsappWindow.closed) {
          const readyPageWritten = writeWhatsappReadyPage(whatsappWindow, whatsappUrl);
          if (!readyPageWritten) {
            whatsappWindow.location.href = bestWhatsappOpenUrl(whatsappUrl);
          }
        } else {
          popupBlocked = true;
        }
      } else if (whatsappWindow && !whatsappWindow.closed) {
        try {
          whatsappWindow.close();
        } catch {}
      }
    }

    setLastApprovalInfo({
      approval_id: approvalId,
      approval_url: approvalUrl,
      whatsapp_url: whatsappUrl,
      channel: chosenChannel,
      popup_blocked: popupBlocked,
      sent_by_name: approval?.sent_by_name || "",
      sent_by_email: approval?.sent_by_email || "",
      sent_to_name: approval?.sent_to_name || "",
      sent_to: approval?.sent_to || approval?.sent_to_email || approval?.sent_to_mobile || "",
    });

    if (wantsWhatsapp) {
      if (!whatsappUrl) {
        if (chosenChannel === "whatsapp" && pref.emailAllowed) {
          await sendApprovalEmail(approvalId);
          setFlash("WhatsApp-link kon niet worden gemaakt. Akkoordverzoek per e-mail verstuurd ✅");
          setTimeout(() => setFlash(""), 2200);
          return;
        }

        if (chosenChannel === "whatsapp") {
          setSaveError("WhatsApp-link kon niet worden gemaakt en er is geen e-mail fallback ingesteld.");
          return;
        }
      }

      if (popupBlocked) {
        setFlash("Akkoordlink gemaakt. WhatsApp-popup is geblokkeerd; gebruik de WhatsApp-link hieronder.");
      }
    }

    if (chosenChannel === "email" || chosenChannel === "both") {
      emailResult = await sendApprovalEmail(approvalId);

      const accepted = Array.isArray(emailResult?.accepted)
        ? emailResult.accepted.join(", ")
        : "";

      const rejected = Array.isArray(emailResult?.rejected)
        ? emailResult.rejected.join(", ")
        : "";

      setLastApprovalInfo((prev) => ({
        ...(prev || {}),
        approval_id: approvalId,
        approval_url: approvalUrl,
        whatsapp_url: whatsappUrl,
        channel: chosenChannel,
        popup_blocked: popupBlocked,
        sent_by_name: approval?.sent_by_name || "",
        sent_by_email: approval?.sent_by_email || "",
        sent_to_name: approval?.sent_to_name || "",
        sent_to: approval?.sent_to || approval?.sent_to_email || approval?.sent_to_mobile || "",
        email_to: emailResult?.to || "",
        email_message: emailResult?.message || "",
        email_accepted: accepted,
        email_rejected: rejected,
      }));

      alert(
        `${emailResult?.message || "Akkoordverzoek per e-mail verstuurd."}` +
          `${accepted ? `\nGeaccepteerd door mailserver: ${accepted}` : ""}` +
          `${rejected ? `\nNiet geaccepteerd: ${rejected}` : ""}`
      );

      // Bij keuze 3 kan de e-mailmelding het WhatsApp-tabblad naar de
      // achtergrond drukken of de eerste doorsturing onderbreken.
      // Na het sluiten van de melding zetten we WhatsApp daarom nogmaals
      // expliciet klaar en brengen we het venster naar voren.
      if (
        chosenChannel === "both" &&
        whatsappUrl &&
        whatsappWindow &&
        !whatsappWindow.closed
      ) {
        const readyPageWritten = writeWhatsappReadyPage(
          whatsappWindow,
          whatsappUrl
        );

        if (!readyPageWritten) {
          try {
            whatsappWindow.location.href = bestWhatsappOpenUrl(whatsappUrl);
          } catch {}
        }

        try {
          whatsappWindow.focus();
        } catch {}
      }
    }

    if (chosenChannel === "both") {
      setFlash(popupBlocked
        ? "Akkoordlink gemaakt. E-mail verstuurd. WhatsApp-popup is geblokkeerd; gebruik de WhatsApp-link hieronder."
        : (isMobileDeviceForWhatsapp() ? "Akkoordlink gemaakt. E-mail verstuurd. WhatsApp staat klaar in het geopende venster ✅" : "Akkoordlink gemaakt. WhatsApp geopend en e-mail verstuurd ✅")
      );
    } else if (chosenChannel === "whatsapp") {
      setFlash(popupBlocked
        ? "Akkoordlink gemaakt. WhatsApp-popup is geblokkeerd; gebruik de WhatsApp-link hieronder."
        : (isMobileDeviceForWhatsapp() ? "Akkoordlink gemaakt. WhatsApp staat klaar in het geopende venster ✅" : "Akkoordlink gemaakt en WhatsApp geopend ✅")
      );
    } else {
      setFlash("Akkoordverzoek per e-mail verstuurd ✅");
    }

    setTimeout(() => setFlash(""), 2200);
  } catch (e) {
    try {
      if (whatsappWindow && !whatsappWindow.closed) whatsappWindow.close();
    } catch {}
    setSaveError(e?.message || String(e));
  } finally {
    setSendingApproval(false);
  }
}

  async function sendOfferEmail() {
    setSaveError(null);

    if (!formHasId()) {
      setSaveError("Sla de offerte eerst op.");
      return;
    }

    const to = currentInvoiceEmail;
    if (!to) {
      setSaveError("Bij deze relatie staat geen e-mailadres.");
      return;
    }

if (!currentInvoiceEmail) {
  setSaveError("Bij deze relatie staat geen e-mailadres.");
  return;
}

    if (!popupPrintRef.current) {
      setSaveError("Offerteweergave niet gevonden.");
      return;
    }

    try {
      setSendingEmail(true);

      const documentLabel =
        getApprovalDocumentType() === "order"
          ? "Opdrachtbevestiging"
          : "Offerte";

      const subjectTemplate = safeTrim(effectiveOfferSettings.email_subject);
      // Alleen een door de gebruiker opgeslagen Referentie gebruiken.
      // offerReferenceValue() heeft voor oude records nog een fallback op het
      // interne nummer; dat mag niet in klantmails terechtkomen.
      const storedOffer = items.find((item) => String(item.id) === String(form.id));
      const customerReference = storedOffer
        ? safeTrim(storedOffer.reference || "")
        : safeTrim(form.reference || "");
      const invoiceTitle = subjectTemplate
        ? subjectTemplate
            .replaceAll("{referentie}", customerReference)
            .replaceAll("{document_nummer}", customerReference) // oude sjablonen
            .replaceAll("{relatie}", recipientName || "")
            .replaceAll("{contactpersoon}", contactAanschrijving || pickContactFullName(selectedContact) || "")
            .replace(/[ \t]{2,}/g, " ").trim()
        : `${documentLabel}${customerReference ? ` ${customerReference}` : ""}`;

const printableHtml = buildOfferPrintHtml();

      const mailResult = await tryFetchJson(
        [`/api/offers/${encodeURIComponent(form.id)}/send-email`],
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            to,
            subject: invoiceTitle,
            invoiceNumber: form.invoice_number || String(form.id),
            html: printableHtml,
            total: invoiceTotals.total,
          }),
        }
      );

      const serverMessage = mailResult?.message || `Offerte/Opdracht verstuurd naar ${to}`;
      const accepted = Array.isArray(mailResult?.accepted) ? mailResult.accepted.join(", ") : "";
      const rejected = Array.isArray(mailResult?.rejected) ? mailResult.rejected.join(", ") : "";

      alert(`${serverMessage}${accepted ? `\nGeaccepteerd door mailserver: ${accepted}` : ""}${rejected ? `\nNiet geaccepteerd: ${rejected}` : ""}`);
      setFlash(`${serverMessage} ✅`);
      setTimeout(() => setFlash(""), 1500);
    } catch (e) {
      setSaveError(e?.message || String(e));
    } finally {
      setSendingEmail(false);
    }
  }

async function saveDeliveryStatus(nextStatus) {
  if (isReadonly || !formHasId()) return;

  const processStatus = normalizeDbStatus(form.status || "OFFERTE");
  if (!["OPDRACHT", "FACTUUR"].includes(processStatus)) return;

  const normalized = String(nextStatus || "").toUpperCase() === "DELIVERED"
    ? "DELIVERED"
    : "NOT_DELIVERED";

  const previous = form.delivery_status || "NOT_DELIVERED";
  setForm((prev) => ({ ...prev, delivery_status: normalized }));
  setSaveError(null);
  setLastApprovalInfo(null);

  try {
    const saved = await tryFetchJson(
      [`/api/offers/${encodeURIComponent(form.id)}/delivery-status`],
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ delivery_status: normalized }),
      }
    );

    setItems((prev) => upsertById(prev, {
      ...(saved && typeof saved === "object" ? saved : {}),
      id: form.id,
      delivery_status: normalized,
    }));

    setFlash(
      normalized === "DELIVERED"
        ? "Opdracht als opgeleverd gemarkeerd ✅"
        : "Oplevering teruggezet naar niet opgeleverd ✅"
    );
    setTimeout(() => setFlash(""), 1400);
  } catch (e) {
    setForm((prev) => ({ ...prev, delivery_status: previous }));
    setSaveError(e?.message || String(e));
  }
}

async function saveItem() {
  if (isFormLocked || isReadonly) return;

  setSaveError(null);
  setFlash("");
  setLastApprovalInfo(null);

    if (isReadonly) {
      setSaveError("Deze gebruiker heeft alleen-lezen rechten.");
      return;
    }

    if (!safeTrim(form.organisation_id)) return setSaveError("Kies eerst een relatie.");
    if (!safeTrim(form.invoice_date)) return setSaveError("Offertedatum is verplicht.");

    const payload = {
      organisation_id: form.organisation_id ? Number(form.organisation_id) : null,
      contact_id: form.contact_id ? Number(form.contact_id) : null,
      template_id: form.template_id ? Number(form.template_id) : null,
      invoice_date: form.invoice_date || null,
      due_date: form.due_date || null,
      order_date: form.order_date || null,
      planned_delivery_date: form.planned_delivery_date || null,
      invoice_number: form.invoice_number || null,
      reference: safeTrim(form.reference || ""),
      status: (form.status || "DRAFT"),
      delivery_status: form.delivery_status || "NOT_DELIVERED",
      series_code: form.series_code || null,
      notes: form.notes || "",

      document_subject: effectiveDocumentTexts.document_subject || "",
      ...documentVisibilityPayload(),
      document_salutation: effectiveDocumentTexts.document_salutation || "",
      document_intro_text: effectiveDocumentTexts.document_intro_text || "",
      document_body_text: effectiveDocumentTexts.document_body_text || "",
      document_conditions_text: effectiveDocumentTexts.document_conditions_text || "",
      document_payment_text: effectiveDocumentTexts.document_payment_text || "",
      document_planning_text: effectiveDocumentTexts.document_planning_text || "",
      document_remark_text: effectiveDocumentTexts.document_remark_text || "",
      document_warranty_text: effectiveDocumentTexts.document_warranty_text || "",
      document_closing_text: effectiveDocumentTexts.document_closing_text || "",
      document_show_agreement_block: effectiveDocumentTexts.document_show_agreement_block === true,
      document_agreement_text: effectiveDocumentTexts.document_agreement_text || "",
      document_texts_initialized: true,
    };

const isUpdate = formHasId();
const method = isUpdate ? "PUT" : "POST";
const urls = isUpdate ? [`/api/offers/${form.id}`] : ["/api/offers"];

    try {
      const saved = await tryFetchJson(urls, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const savedId = saved?.id || form.id;

      if (saved && typeof saved === "object") {
        setItems((prev) => upsertById(prev, saved));
        savedOfferSnapshotRef.current = {
          ...form,
          ...saved,
          id: saved?.id || form.id,
          template_id:
            saved?.template_id !== undefined && saved?.template_id !== null
              ? String(saved.template_id)
              : String(form.template_id || ""),
          ...effectiveDocumentTexts,
          document_texts_initialized: true,
        };
      }

      const pendingLine = getPendingLinePayload();

if (savedId && pendingLine) {
  await tryFetchJson(["/api/offer-lines"], {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...pendingLine,
      offer_id: Number(savedId),
      line_no: 1,
    }),
  });
}

      // vOFF-097: bij ieder normaal Opslaan ook de actuele PDF in Documenten
      // maken of bijwerken. De server gebruikt hiervoor dezelfde documentregel
      // per offerte/opdracht, zodat geen reeks dubbele PDF's ontstaat.
      if (savedId) {
        await saveCurrentOfferDocumentAfterSave(savedId);
      }

      resetRightPanelEmpty();
      setListIndex(-1);

      setFlash("Opgeslagen ✅");
      setTimeout(() => setFlash(""), 800);
      setReloadKey((k) => k + 1);

      setMode("search");
      setTimeout(() => {
        try {
          scrollRightTop();
          scrollMidTop();
          searchRef.current?.focus?.();
        } catch { }
      }, 0);
    } catch (e) {
      setSaveError(e?.message || String(e));
    }
  }
  async function openOfferPopupEdit() {
    setActiveDocumentEditorKey("");
    setNewLineMode("");
    setProjectSearch("");
    setSelectedProjectIds([]);
    setExcludedProjectIds([]);
    setIncludeChildProjects(false);
    setShowProjectOfferText(false);
    setShowProjectInternalText(false);
    setPopupMode("edit");
    await saveItemForPopup();
  }

  async function openOfferPopupPreview() {
    setNewLineMode("");
    setProjectSearch("");
    setSelectedProjectIds([]);
    setExcludedProjectIds([]);
    setIncludeChildProjects(false);
    setShowProjectOfferText(false);
    setShowProjectInternalText(false);
    setPopupMode("preview");
    await saveItemForPopup();
  }
  async function saveItemForPopup() {
    setSaveError(null);
    setFlash("");

    if (isLocked) {
      if (formHasId()) {
        await refreshSelectedInvoice();
        setShowLinesPopup(true);
      }
      return;
    }

    if (!safeTrim(form.organisation_id)) {
      setSaveError("Kies eerst een organisatie.");
      return;
    }

    if (!safeTrim(form.invoice_date)) {
      setSaveError("Offertedatum is verplicht.");
      return;
    }

    // Bestaat al? Dan gewoon popup openen met verse data
    if (formHasId()) {
      await refreshSelectedInvoice();
      setShowLinesPopup(true);
      return;
    }

    const payload = {
      organisation_id: form.organisation_id ? Number(form.organisation_id) : null,
      contact_id: form.contact_id ? Number(form.contact_id) : null,
      template_id: form.template_id ? Number(form.template_id) : null,
      invoice_date: form.invoice_date || null,
      due_date: form.due_date || null,
      order_date: form.order_date || null,
      planned_delivery_date: form.planned_delivery_date || null,
      invoice_number: form.invoice_number || null,
      reference: safeTrim(form.reference || ""),
      status: (form.status || "DRAFT"),
      delivery_status: form.delivery_status || "NOT_DELIVERED",
      series_code: form.series_code || null,
      notes: form.notes || "",

      document_subject: effectiveDocumentTexts.document_subject || "",
      ...documentVisibilityPayload(),
      document_salutation: effectiveDocumentTexts.document_salutation || "",
      document_intro_text: effectiveDocumentTexts.document_intro_text || "",
      document_body_text: effectiveDocumentTexts.document_body_text || "",
      document_conditions_text: effectiveDocumentTexts.document_conditions_text || "",
      document_payment_text: effectiveDocumentTexts.document_payment_text || "",
      document_planning_text: effectiveDocumentTexts.document_planning_text || "",
      document_remark_text: effectiveDocumentTexts.document_remark_text || "",
      document_warranty_text: effectiveDocumentTexts.document_warranty_text || "",
      document_closing_text: effectiveDocumentTexts.document_closing_text || "",
      document_show_agreement_block: effectiveDocumentTexts.document_show_agreement_block === true,
      document_agreement_text: effectiveDocumentTexts.document_agreement_text || "",
      document_texts_initialized: true,
    };

    try {
const saved = await tryFetchJson(["/api/offers"], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const newId = saved?.id ? String(saved.id) : "";

      if (saved && typeof saved === "object") {
        setItems((prev) => upsertById(prev, saved));
      }

      if (newId) {
        setSelectedId(newId);

        setForm((prev) => ({
          ...prev,
          ...saved,
          id: newId,
          organisation_id: saved?.organisation_id ? String(saved.organisation_id) : prev.organisation_id,
          contact_id: saved?.contact_id ? String(saved.contact_id) : prev.contact_id,
          status: saved?.status || prev.status || "DRAFT",
        }));

        await loadOrgDetail(saved?.organisation_id || form.organisation_id);
        await loadPayments(newId);

        const pendingLine = getPendingLinePayload();

        if (pendingLine) {
await tryFetchJson(["/api/offer-lines"], {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    ...pendingLine,
    offer_id: Number(newId),
    line_no: 1,
  }),
});
          setLineDraft({
            line_type: "Artikel",
            quantity: 1,
            description: "",
            unit: "",
            unit_price: "",
            vat_rate: pickOrgDefaultVatRate(activeOrg),
          });
        }

        await refreshSelectedInvoice();
      }

      setFlash("Offerte opgeslagen ✅");
      setTimeout(() => setFlash(""), 800);
      setShowLinesPopup(true);
    } catch (e) {
      setSaveError(e?.message || String(e));
    }
  }

async function deleteItem() {
  if (isFormLocked) return;

  setSaveError(null);
  setFlash("");
  setLastApprovalInfo(null);

    if (!formHasId()) return;

    const deleteStatus = normalizeDbStatus(form.status || "OFFERTE");

    if (deleteStatus !== "OFFERTE") {
      return setSaveError("Alleen een offerte kan worden verwijderd. Een opdracht blijft bewaard in het proces.");
    }

    const ok = window.confirm("Weet je zeker dat je deze offerte wilt verwijderen?");
    if (!ok) return;

    const id = form.id;
    try {
      await tryFetchJson([`/api/offers/${encodeURIComponent(form.id)}`], {
  method: "DELETE",
});
      setItems((prev) => removeById(prev, id));
      resetRightPanelEmpty();
      setListIndex(-1);

      setFlash("Verwijderd ✅");
      setTimeout(() => setFlash(""), 800);

      setMode("search");
      setTimeout(() => {
        try {
          scrollRightTop();
          scrollMidTop();
          searchRef.current?.focus?.();
        } catch { }
      }, 0);
    } catch (e) {
      setSaveError(e?.message || String(e));
    }
  }

  // ---------- PAYMENTS ----------
  const paidTotal = useMemo(() => payments.reduce((s, p) => s + Number(p.amount || 0), 0), [payments]);
  const openAmount = useMemo(() => Number(form.total || 0) - paidTotal, [form.total, paidTotal]);
  const paidLabel = useMemo(() => boolPaidLabel(openAmount), [openAmount]);


  async function addPayment() {
    setPayError(null);

    if (!formHasId()) {
      return setPayError("Sla eerst de offerte op, voordat je betalingen toevoegt.");
    }

    const currentStatus = normalizeDbStatus(form.status || "DRAFT");
    if (currentStatus === "DRAFT") {
      return setPayError("Bij een conceptofferte mogen nog geen betalingen worden ingevoerd.");
    }

    const paid_on = isoDate(payDraft.paid_on);
    const amount = Number(String(payDraft.amount || "").replace(",", "."));

    if (!paid_on) return setPayError("Kies een betaaldatum.");
    if (!Number.isFinite(amount) || amount <= 0) {
      return setPayError("Bedrag moet > 0 zijn.");
    }

    const payload = {
      paid_on,
      amount,
      notes: payDraft.notes || "",
    };

    try {
      const saved = await tryFetchJson([`/api/invoices/${form.id}/payments`], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      let nextPayments;

      if (saved && typeof saved === "object") {
        nextPayments = [...payments, saved].sort((a, b) =>
          isoDate(a.paid_on) < isoDate(b.paid_on) ? -1 : 1
        );
        setPayments(nextPayments);
      } else {
        await loadPayments(form.id);
        nextPayments = payments;
      }

      setPayDraft({
        paid_on: new Date().toLocaleDateString("en-CA"),
        amount: "",
        notes: "",
      });

      setFlash("Betaling toegevoegd ✅");
      setTimeout(() => setFlash(""), 800);

      await refreshSelectedInvoice();
    } catch (e) {
      setPayError(e?.message || String(e));
    }
  }

  async function deletePayment(pid) {
    setPayError(null);
    if (!formHasId()) return;
    const ok = window.confirm("Betaling verwijderen?");
    if (!ok) return;

    try {
      await tryFetchJson([`/api/invoices/${form.id}/payments/${pid}`], { method: "DELETE" });

      const nextPayments = payments.filter((x) => String(x.id) !== String(pid));
      setPayments(nextPayments);

      setFlash("Betaling verwijderd ✅");
      setTimeout(() => setFlash(""), 800);
      await refreshSelectedInvoice();
    } catch (e) {
      setPayError(e?.message || String(e));
    }
  }

  // ---------- OFFERTEREGELS ----------
  async function refreshSelectedInvoice() {
    if (!formHasId()) return;
    try {
      const det = await tryFetchJson([`/api/offers/${encodeURIComponent(form.id)}`]);
      const invoiceObj = det && det.invoice ? det.invoice : det;

      if (invoiceObj) {
        setForm((prev) => {
          const keepTemporaryTemplate =
            mode === "form" &&
            String(prev.template_id || "") !== String(invoiceObj.template_id || "");

          return {
            ...prev,
            ...invoiceObj,
            ...(keepTemporaryTemplate
              ? {
                  template_id: prev.template_id,
                  document_subject: prev.document_subject,
                  document_show_subject: prev.document_show_subject,
                  document_show_salutation: prev.document_show_salutation,
                  document_show_intro_text: prev.document_show_intro_text,
                  document_show_body_text: prev.document_show_body_text,
                  document_show_conditions_text: prev.document_show_conditions_text,
                  document_show_payment_text: prev.document_show_payment_text,
                  document_show_planning_text: prev.document_show_planning_text,
                  document_show_remark_text: prev.document_show_remark_text,
                  document_show_warranty_text: prev.document_show_warranty_text,
                  document_show_closing_text: prev.document_show_closing_text,
                  document_salutation: prev.document_salutation,
                  document_intro_text: prev.document_intro_text,
                  document_body_text: prev.document_body_text,
                  document_conditions_text: prev.document_conditions_text,
                  document_payment_text: prev.document_payment_text,
                  document_planning_text: prev.document_planning_text,
                  document_remark_text: prev.document_remark_text,
                  document_warranty_text: prev.document_warranty_text,
                  document_closing_text: prev.document_closing_text,
                  document_show_agreement_block: prev.document_show_agreement_block,
                  document_agreement_text: prev.document_agreement_text,
                  document_texts_initialized: prev.document_texts_initialized,
                }
              : {}),
            status: normalizeDbStatus(invoiceObj.status || prev.status || "DRAFT"),
          };
        });
      }

      const loadedLines =
        Array.isArray(det?.lines) ? det.lines :
          Array.isArray(det?.items) ? det.items :
            Array.isArray(invoiceObj?.lines) ? invoiceObj.lines :
              Array.isArray(invoiceObj?.items) ? invoiceObj.items :
                [];

      setLines(loadedLines);

      // refresh list (totals / status)
      await loadList();
    } catch (e) {
      // ignore
    }
  }
  function getPendingLinePayload() {
    const type = editableOfferLineType(lineDraft.line_type || "Artikel");
    const qty = numberFromAny(lineDraft.quantity, 0);
    const unitNumber = netPriceFromDisplayedPrice(lineDraft.unit_price, lineDraft.vat_rate || "hoog", generalSettings.offer_prices_include_vat === true);
    const unit = Number.isFinite(unitNumber) ? Number(unitNumber.toFixed(6)) : NaN;
    const desc = cleanLegacyOfferText(lineDraft.description);
    const vat = String(lineDraft.vat_rate || "hoog").toLowerCase();
    const isArticle = type === "Artikel";

    if (!hasVisibleOfferDescription(desc)) return null;

    if (isArticle) {
      if (!Number.isFinite(qty) || qty <= 0) return null;
      if (!Number.isFinite(unit)) return null;
    }

    return {
      line_type: backendOfferLineType(type),
      lineType: type,
      type,
      regeltype: type,
      description: desc,
      unit: isArticle ? String(lineDraft.unit || "").trim() : "",

      quantity: isArticle ? qty : 0,
      qty: isArticle ? qty : 0,
      aantal: isArticle ? qty : 0,

      unit_price: isArticle ? unit : 0,
      price: isArticle ? unit : 0,
      unitPrice: isArticle ? unit : 0,
      bedrag: isArticle ? unit : 0,
      amount: isArticle ? unit : 0,

      vat_rate: vat,
      vat: vat,
      btw: vat,
    };
  }


function buildOfferLineUpdatePayload(ln, lineNo) {
  const type = lineTypeOf(ln);
  const isArticle = type === "Artikel";

  return {
    line_no: Number(lineNo || 0),

    line_type: backendOfferLineType(type),
    lineType: type,
    type,
    regeltype: type,

    description: lineDescription(ln),
    unit: isArticle ? lineUnitLabel(ln) : "",

    quantity: isArticle ? lineQty(ln) : 0,
    qty: isArticle ? lineQty(ln) : 0,
    aantal: isArticle ? lineQty(ln) : 0,

    unit_price: isArticle ? lineUnitPrice(ln) : 0,
    price: isArticle ? lineUnitPrice(ln) : 0,
    unitPrice: isArticle ? lineUnitPrice(ln) : 0,
    bedrag: isArticle ? lineUnitPrice(ln) : 0,
    amount: isArticle ? lineUnitPrice(ln) : 0,

    vat_rate: lineVatRate(ln),
    vat: lineVatRate(ln),
    btw: lineVatRate(ln),
  };
}

async function persistOfferLineOrder(nextLines) {
  const ordered = Array.isArray(nextLines) ? nextLines : [];

  for (let i = 0; i < ordered.length; i += 1) {
    const ln = ordered[i];
    if (!ln?.id) continue;

    await tryFetchJson([`/api/offer-lines/${encodeURIComponent(ln.id)}`], {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(buildOfferLineUpdatePayload(ln, i + 1)),
    });
  }
}

async function reorderOfferLine(lineId, targetLineId) {
  if (!lineId || !targetLineId) return;
  if (String(lineId) === String(targetLineId)) return;
  if (isLocked || popupMode === "preview") return;

  const fromIndex = lines.findIndex((ln) => String(ln.id) === String(lineId));
  const toIndex = lines.findIndex((ln) => String(ln.id) === String(targetLineId));

  if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return;

  const previousLines = lines.slice();
  const nextLines = lines.slice();
  const [moved] = nextLines.splice(fromIndex, 1);
  nextLines.splice(toIndex, 0, moved);

  setLines(nextLines);
  setLineError(null);

  try {
    await persistOfferLineOrder(nextLines);
    setFlash("Volgorde aangepast ✅");
    setTimeout(() => setFlash(""), 900);
    await refreshSelectedInvoice();
  } catch (e) {
    setLines(previousLines);
    setLineError(e?.message || "Volgorde wijzigen mislukt.");
  }
}

async function moveOfferLineStep(lineId, direction) {
  if (!lineId || isLocked || popupMode === "preview") return;

  const idx = lines.findIndex((ln) => String(ln.id) === String(lineId));
  if (idx < 0) return;

  const nextIdx = idx + Number(direction || 0);
  if (nextIdx < 0 || nextIdx >= lines.length) return;

  const previousLines = lines.slice();
  const nextLines = lines.slice();
  const [moved] = nextLines.splice(idx, 1);
  nextLines.splice(nextIdx, 0, moved);

  setLines(nextLines);
  setLineError(null);

  try {
    await persistOfferLineOrder(nextLines);
    setFlash("Volgorde aangepast ✅");
    setTimeout(() => setFlash(""), 900);
    await refreshSelectedInvoice();
  } catch (e) {
    setLines(previousLines);
    setLineError(e?.message || "Volgorde wijzigen mislukt.");
  }
}


async function addInvoiceLine() {
  setLineError(null);

  if (!formHasId()) {
    setLineError("Sla eerst de offerte op.");
    return false;
  }

  if (isLocked) {
    setLineError("Deze opdracht is omgezet naar een factuur; regels zijn hier niet meer aanpasbaar.");
    return false;
  }

  const isEdit = !!editingLineId;
  const type = editableOfferLineType(lineDraft.line_type || "Artikel");
  const qty = numberFromAny(lineDraft.quantity, 0);
  const unitNumber = netPriceFromDisplayedPrice(
    lineDraft.unit_price,
    lineDraft.vat_rate || "hoog",
    generalSettings.offer_prices_include_vat === true
  );
  const unit = Number.isFinite(unitNumber) ? Number(unitNumber.toFixed(6)) : NaN;
  const desc = cleanLegacyOfferText(lineDraft.description);
  const vat = String(lineDraft.vat_rate || "hoog").toLowerCase();
  const isArticle = type === "Artikel";

  // vOFF-035: onthoud positie vóór opslaan, zodat de pagina na opslaan
  // niet naar onder/boven springt bij het opnieuw laden van offerteregels.
  const scrollSnapshot = {
    windowX: window.scrollX || 0,
    windowY: window.scrollY || 0,
    midTop: midScrollRef.current?.scrollTop ?? null,
    rightTop: rightScrollRef.current?.scrollTop ?? null,
  };

  function restoreScrollAfterLineSave() {
    setTimeout(() => {
      try {
        if (scrollSnapshot.midTop !== null && midScrollRef.current) {
          midScrollRef.current.scrollTop = scrollSnapshot.midTop;
        }
      } catch {}

      try {
        if (scrollSnapshot.rightTop !== null && rightScrollRef.current) {
          rightScrollRef.current.scrollTop = scrollSnapshot.rightTop;
        }
      } catch {}

      try {
        window.scrollTo(scrollSnapshot.windowX, scrollSnapshot.windowY);
      } catch {}

      try {
        if (isEdit) {
          const idx = lines.findIndex((ln) => String(ln.id) === String(editingLineId));
          const nextLine = idx >= 0 ? lines[idx + 1] : null;

          if (nextLine?.id) {
            const nextButton = document.querySelector(
              `[data-offer-line-edit-id="${String(nextLine.id)}"]`
            );

            nextButton?.scrollIntoView?.({
              block: "center",
              inline: "nearest",
              behavior: "auto",
            });
          }
        } else {
          lineDescRef.current?.focus?.({ preventScroll: true });
        }
      } catch {}
    }, 80);
  }

  if (!hasVisibleOfferDescription(desc)) {
    setLineError("Vul eerst een echte omschrijving in. Alleen opmaak of een lege regel is niet toegestaan.");
    restoreScrollAfterLineSave();
    return false;
  }

  if (isArticle) {
    if (!Number.isFinite(qty) || qty <= 0) {
      setLineError("Aantal moet groter dan 0 zijn.");
      restoreScrollAfterLineSave();
      return false;
    }

    if (!Number.isFinite(unit)) {
      setLineError("Bedrag (per stuk) moet een geldig getal zijn.");
      restoreScrollAfterLineSave();
      return false;
    }
  }

  const payload = {
    line_type: backendOfferLineType(type),
    lineType: type,
    type,
    regeltype: type,
    description: desc,
    unit: isArticle ? String(lineDraft.unit || "").trim() : "",

    quantity: isArticle ? qty : 0,
    qty: isArticle ? qty : 0,
    aantal: isArticle ? qty : 0,

    unit_price: isArticle ? unit : 0,
    price: isArticle ? unit : 0,
    unitPrice: isArticle ? unit : 0,
    bedrag: isArticle ? unit : 0,
    amount: isArticle ? unit : 0,

    vat_rate: vat,
    vat: vat,
    btw: vat,
  };

  try {
    const saved = await tryFetchJson(
      isEdit
        ? [`/api/offer-lines/${encodeURIComponent(editingLineId)}`]
        : ["/api/offer-lines"],
      {
        method: isEdit ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          isEdit
            ? payload
            : { ...payload, offer_id: Number(form.id), line_no: lines.length + 1 }
        ),
      }
    );

    const savedLineRaw =
      saved?.line ||
      saved?.invoice_line ||
      saved?.data ||
      saved;

    // Versiecontrole: een oudere server negeert de nieuwe kolom soms ongemerkt.
    if (payload.unit && String(savedLineRaw?.unit ?? "").trim() !== payload.unit) {
      await refreshSelectedInvoice().catch(() => {});
      throw new Error("De server heeft Eenheid niet opgeslagen. Controleer of server.js minimaal vserver-PTT-558 is.");
    }

    const savedLine =
      savedLineRaw && typeof savedLineRaw === "object"
        ? { ...savedLineRaw, ...payload, id: savedLineRaw.id ?? editingLineId }
        : null;

    if (savedLine) {
      if (isEdit) {
        setLines((prev) =>
          prev.map((ln) =>
            String(ln.id) === String(editingLineId) ? { ...ln, ...savedLine } : ln
          )
        );
      } else {
        setLines((prev) => [...prev, savedLine]);
      }
    }

    setEditingLineId(null);
    setSelectedProjectLineId("__manual__");
    setNewLineMode("");
    setProjectSearch("");
    setSelectedProjectIds([]);
    setExcludedProjectIds([]);
    setIncludeChildProjects(false);

    setLineDraft({
      line_type: "Artikel",
      quantity: 1,
      description: "",
      unit: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });

    setFlash(isEdit ? "Offerteregel gewijzigd ✅" : "Offerteregel toegevoegd ✅");
    setTimeout(() => setFlash(""), 900);

    await refreshSelectedInvoice();

    restoreScrollAfterLineSave();

    return true;
  } catch (e) {
    setLineError(e?.message || String(e));
    restoreScrollAfterLineSave();
    return false;
  }
}

function formatLineUnitPriceValue(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";

    const normalized = s.replace(",", ".");
    const num = Number(normalized);
    if (!Number.isFinite(num)) return s;

    return num.toFixed(2).replace(".", ",");
  }

  function handleUnitPriceCommit() {
    setLineDraft((prev) => ({
      ...prev,
      unit_price: formatLineUnitPriceValue(prev.unit_price),
    }));
  }

function startEditInvoiceLine(ln, focusField = "quantity") {
  setLineError(null);
  setEditingLineId(ln.id);

  setLineDraft({
    line_type: editableOfferLineType(lineTypeOf(ln)),
    quantity: String(lineQty(ln) || 1),
    description: String(lineDescription(ln) || ""),
    unit: lineUnitLabel(ln),
    unit_price: String(displayedPriceFromNetPrice(lineUnitPrice(ln), lineVatRate(ln), generalSettings.offer_prices_include_vat === true) || "").replace(".", ","),
    vat_rate: String(lineVatRate(ln) || "hoog"),
  });

  setTimeout(() => {
    try {
      const focusInput = focusField === "unit" ? unitInputRef.current : qtyInputRef.current;
      focusInput?.scrollIntoView?.({
        behavior: "smooth",
        block: "center",
      });
      focusInput?.focus?.();
      focusInput?.select?.();

    } catch {}
  }, 50);
}

function cancelEditInvoiceLine() {
  setEditingLineId(null);
  setLineError(null);
  setLineDraft({
    line_type: "Artikel",
    quantity: 1,
    description: "",
    unit: "",
    unit_price: "",
    vat_rate: pickOrgDefaultVatRate(activeOrg),
  });
}

function getOnderliggendeProjecten(parentId) {
  const result = [];

  function walk(pid) {
    const children = projectItems
      .filter((x) => String(x.parent_id || "") === String(pid || ""))
      .sort((a, b) =>
        String(a.full_code || a.code || "").localeCompare(
          String(b.full_code || b.code || ""),
          "nl"
        )
      );

    children.forEach((child) => {
      result.push(child);
      walk(child.id);
    });
  }

  walk(parentId);

  return result;
}

async function voegProjectRegelsToe(projectId) {
  if (!formHasId()) {
    setLineError("Sla eerst de offerte op.");
    return;
  }

  const hoofd = projectItems.find(
    (x) => String(x.id) === String(projectId)
  );

  if (!hoofd) return;

  const alleRegels = [hoofd];

  if (includeChildProjects) {
    alleRegels.push(...getOnderliggendeProjecten(hoofd.id));
  }



  const bruikbareRegels = alleRegels.filter((r) => {
    const hasPrijs = Number(r.price || 0) > 0;
    const hasTekst =
      safeTrim(r.offer_text) ||
      safeTrim(r.name);

    return hasPrijs || hasTekst;
  });

  try {
    for (const r of bruikbareRegels) {
      const omschrijving =
        projectDescriptionText(r.offer_text) ||
        projectDescriptionText(r.name) ||
        projectDescriptionText(r.full_name) ||
        "";

      const type = editableOfferLineType(lineTypeOf(r));
      const price = Number(r.price || 0);

      const payload = {
        offer_id: Number(form.id),
        line_no: lines.length + 1,

        line_type: backendOfferLineType(type),
        lineType: type,
        type,
        regeltype: type,
        description: omschrijving,
        unit: type === "Artikel" ? String(r.unit || "").trim() : "",

        quantity: type === "Artikel" ? 1 : 0,
        qty: type === "Artikel" ? 1 : 0,

        unit_price: type === "Artikel" ? price : 0,
        price: type === "Artikel" ? price : 0,
        unitPrice: type === "Artikel" ? price : 0,
        bedrag: type === "Artikel" ? price : 0,
        amount: type === "Artikel" ? price : 0,

        vat_rate: normalizeVatRate(r.vat_rate || "hoog"),
        vat: normalizeVatRate(r.vat_rate || "hoog"),
      };

      await tryFetchJson(
        ["/api/offer-lines"],
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
    }

await refreshSelectedInvoice();

setSelectedProjectLineId("__manual__");
    setIncludeChildProjects(false);

    setLineDraft({
      line_type: "Artikel",
      quantity: 1,
      description: "",
      unit: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });

    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch {}
    }, 80);

    setFlash(
      includeChildProjects
        ? "Project + onderliggende onderdelen toegevoegd ✅"
        : "Project toegevoegd ✅"
    );

    setTimeout(() => setFlash(""), 1200);

  } catch (e) {
    setLineError(e?.message || String(e));
  }
}

function vulRegelUitProjectbeheer(projectId) {
  setSelectedProjectLineId(projectId);

  if (!projectId) {
    setLineDraft({
      line_type: "Artikel",
      quantity: 1,
      description: "",
      unit: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });
    return;
  }

if (projectId === "__manual__") {
    setLineDraft({
      line_type: "Artikel",
      quantity: 1,
      description: "",
      unit: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });

    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch {}
    }, 50);

    return;
  }

const p = projectItems.find((x) => String(x.id) === String(projectId));
if (!p) return;



if (includeChildProjects) {
  voegProjectRegelsToe(projectId);
  return;
}

  const omschrijving =
    projectDescriptionText(p.offer_text) ||
    projectDescriptionText(p.name) ||
    projectDescriptionText(p.full_name) ||
    "";

  const projectLineType = editableOfferLineType(lineTypeOf(p));

  setLineDraft({
    line_type: projectLineType,
    quantity: projectLineType === "Artikel" ? 1 : 0,
    description: omschrijving,
    unit: projectLineType === "Artikel" ? String(p.unit || "").trim() : "",
    unit_price: projectLineType === "Artikel" ? String(p.price ?? "").replace(".", ",") : "",
    vat_rate: normalizeVatRate(p.vat_rate || "hoog"),
  });

  setTimeout(() => {
    try {
    } catch {}
  }, 50);
}


function projectSortValue(item = {}) {
  return safeTrim(item.full_code || item.code || item.full_name || item.name || "");
}

function sortedProjectItems(items = projectItems) {
  return (Array.isArray(items) ? items : [])
    .slice()
    .sort((a, b) =>
      projectSortValue(a).localeCompare(projectSortValue(b), "nl", {
        numeric: true,
        sensitivity: "base",
      })
    );
}

function resetNewLineSelection() {
  setNewLineMode("");
  setProjectSearch("");
  setSelectedProjectIds([]);
  setExcludedProjectIds([]);
  setSelectedProjectLineId("__manual__");
  setIncludeChildProjects(false);
  setShowProjectOfferText(false);
  setShowProjectInternalText(false);
  setExpandedProjectIds(new Set());
  setLineError(null);
  setLineDraft({
    line_type: "Artikel",
    quantity: 1,
    description: "",
    unit: "",
    unit_price: "",
    vat_rate: pickOrgDefaultVatRate(activeOrg),
  });
}

function openManualLineEntry() {
  setLineError(null);
  setNewLineMode("manual");
  setProjectSearch("");
  setSelectedProjectIds([]);
  setExcludedProjectIds([]);
  setIncludeChildProjects(false);
  setShowProjectOfferText(false);
  setShowProjectInternalText(false);
  setExpandedProjectIds(new Set());
  setLineDraft({
    line_type: "Artikel",
    quantity: 1,
    description: "",
    unit: "",
    unit_price: "",
    vat_rate: pickOrgDefaultVatRate(activeOrg),
  });

  setTimeout(() => {
    try { lineDescRef.current?.focus?.(); } catch {}
  }, 50);
}

async function openProjectLineSelection() {
  setLineError(null);
  setNewLineMode("project");
  setProjectSearch("");
  setSelectedProjectIds([]);
  setExcludedProjectIds([]);
  setIncludeChildProjects(false);
  setShowProjectOfferText(false);
  setShowProjectInternalText(false);
  setExpandedProjectIds(new Set());
  setProjectItemsLoading(true);

  try {
    // Niet vertrouwen op de lijst die alleen bij openen van Offertes is geladen:
    // nieuw toegevoegde/gewijzigde eenheden in Projectbeheer moeten direct meekomen.
    const fresh = await tryFetchJson(["/api/projectmanagement"], { cache: "no-store" });
    if (!Array.isArray(fresh)) throw new Error("Geen projectonderdelen ontvangen.");
    setProjectItems(fresh);
  } catch (err) {
    setProjectItems([]);
    setLineError(`Projectonderdelen opnieuw laden mislukt: ${err?.message || err}`);
  } finally {
    setProjectItemsLoading(false);
  }
}

function toggleProjectSelection(projectId) {
  const id = String(projectId || "");
  if (!id) return;

  setSelectedProjectIds((prev) => {
    const next = new Set((prev || []).map(String));
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return Array.from(next);
  });

  setExcludedProjectIds((prev) => (prev || []).filter((x) => String(x) !== id));
}

function handleProjectCheckboxToggle(projectId, { isExplicit = false, isAutomatic = false } = {}) {
  const id = String(projectId || "");
  if (!id) return;

  if (isExplicit) {
    setSelectedProjectIds((prev) => (prev || []).filter((x) => String(x) !== id));
    setExcludedProjectIds((prev) => (prev || []).filter((x) => String(x) !== id));
    return;
  }

  if (isAutomatic) {
    setExcludedProjectIds((prev) => {
      const next = new Set((prev || []).map(String));
      next.add(id);
      return Array.from(next);
    });
    return;
  }

  setExcludedProjectIds((prev) => (prev || []).filter((x) => String(x) !== id));
  setSelectedProjectIds((prev) => {
    const next = new Set((prev || []).map(String));
    next.add(id);
    return Array.from(next);
  });
}

function resolvedSelectedProjectItems() {
  const selected = new Set((selectedProjectIds || []).map(String));
  const excluded = new Set((excludedProjectIds || []).map(String));

  if (includeChildProjects) {
    (selectedProjectIds || []).forEach((id) => {
      getOnderliggendeProjecten(id).forEach((child) => {
        const childId = String(child.id);
        if (!excluded.has(childId)) {
          selected.add(childId);
        }
      });
    });
  }

  return sortedProjectItems(
    projectItems.filter((item) => {
      const itemId = String(item.id);
      return selected.has(itemId) && !excluded.has(itemId);
    })
  );
}

async function addSelectedProjectLines() {
  setLineError(null);

  if (!formHasId()) {
    setLineError("Sla eerst de offerte op.");
    return;
  }

  const chosen = resolvedSelectedProjectItems();

  if (!chosen.length) {
    setLineError("Selecteer minimaal één projectonderdeel.");
    return;
  }

  if (projectItemsLoading) {
    setLineError("De projectonderdelen worden nog geladen. Probeer het zo opnieuw.");
    return;
  }

  try {
    // Gebruik de actuele detailkaart als bron, niet alleen de eerdere lijst.
    const detailed = await Promise.all(chosen.map(async (row) => {
      const latest = await tryFetchJson([`/api/projectmanagement/${encodeURIComponent(row.id)}`], { cache: "no-store" });
      return { ...row, ...latest };
    }));

    const usable = detailed.filter((r) => {
      const hasPrice = Number(r.price || 0) > 0;
      const hasText = safeTrim(r.offer_text) || safeTrim(r.name) || safeTrim(r.full_name);
      return hasPrice || hasText;
    });



    const missingUnits = [];
    const startLineNo = lines.length + 1;

    for (let i = 0; i < usable.length; i += 1) {
      const r = usable[i];
      const description =
        projectDescriptionText(r.offer_text) ||
        projectDescriptionText(r.name) ||
        projectDescriptionText(r.full_name) ||
        "";

      const type = editableOfferLineType(lineTypeOf(r));
      const price = Number(r.price || 0);

      const chosenUnit = type === "Artikel" ? String(r.unit || "").trim() : "";
      if (type === "Artikel" && !chosenUnit) {
        missingUnits.push(String(r.full_code || r.code || r.name || r.id));
      }
      const saved = await tryFetchJson(["/api/offer-lines"], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          offer_id: Number(form.id),
          line_no: startLineNo + i,
          line_type: backendOfferLineType(type),
          lineType: type,
          type,
          regeltype: type,
          description,
          unit: chosenUnit,
          quantity: type === "Artikel" ? 1 : 0,
          qty: type === "Artikel" ? 1 : 0,
          unit_price: type === "Artikel" ? price : 0,
          price: type === "Artikel" ? price : 0,
          unitPrice: type === "Artikel" ? price : 0,
          bedrag: type === "Artikel" ? price : 0,
          amount: type === "Artikel" ? price : 0,
          vat_rate: normalizeVatRate(r.vat_rate || "hoog"),
          vat: normalizeVatRate(r.vat_rate || "hoog"),
        }),
      });
      if (chosenUnit && String(saved?.unit ?? "").trim() !== chosenUnit) {
        throw new Error(`Het projectonderdeel '${r.name || r.code}' is toegevoegd, maar de server heeft Eenheid niet opgeslagen. Controleer of server.js minimaal vserver-PTT-558 is.`);
      }
    }

    await refreshSelectedInvoice();

    const addedCount = usable.length;
    resetNewLineSelection();
    setFlash(`${addedCount} projectonderdeel${addedCount === 1 ? "" : "en"} toegevoegd ✅`);
    setTimeout(() => setFlash(""), 1400);
    if (missingUnits.length) {
      setLineError(`Bij ${missingUnits.join(", ")} is Eenheid nog leeg in Projectbeheer. Vul daar eerst een eenheid in, of pas de offerteregel aan met het potloodje.`);
    }
  } catch (e) {
    await refreshSelectedInvoice().catch(() => {});
    setLineError(e?.message || String(e));
  }
}

async function deleteInvoiceLine(lineId) {
  setLineError(null);

  if (!formHasId()) return;

  if (isLocked) {
    setLineError("Deze opdracht is omgezet naar een factuur; regels zijn hier niet meer aanpasbaar.");
    return;
  }

  const ok = window.confirm("Offerteregel verwijderen?");
  if (!ok) return;

  try {
    await tryFetchJson([`/api/offer-lines/${encodeURIComponent(lineId)}`], {
      method: "DELETE",
    });

    setLines((prev) => prev.filter((x) => String(x.id) !== String(lineId)));

    setFlash("Offerteregel verwijderd ✅");
    setTimeout(() => setFlash(""), 900);

    await refreshSelectedInvoice();
  } catch (e) {
    setLineError(e?.message || String(e));
  }
}

  // ---------- SPEECH ----------

  function isPopupOpen() {
    return !!showLinesPopup;
  }

  function isPopupField(el) {
    if (!el) return false;
    return (
      el === qtyInputRef.current ||
      el === lineDescRef.current ||
      el === linePriceRef.current ||
      el === lineVatRef.current
    );
  }

  function popupFocusOrder() {
    const arr = [qtyInputRef.current, lineDescRef.current, linePriceRef.current, lineVatRef.current]
      .filter(Boolean)
      .filter((el) => !el.disabled);
    return arr;
  }

function focusFirstPopupField() {
    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch { }
    }, 120);
  }

  function focusNextPopupField(dir = +1) {
    const arr = popupFocusOrder();
    if (!arr.length) return;

    const active = document.activeElement;
    let idx = arr.findIndex((el) => el === active);
    if (idx === -1) idx = dir > 0 ? -1 : arr.length;

    let next = idx + dir;
    if (next < 0) next = 0;
    if (next > arr.length - 1) next = arr.length - 1;

    const el = arr[next];
    if (!el) return;

    try {
      el.focus?.();
      if (el.tagName?.toLowerCase() === "input" || el.tagName?.toLowerCase() === "textarea") {
        el.select?.();
      }
    } catch { }
  }

  function popupPunctMap(t) {
    const x = norm(t);
    if (x === "punt") return ".";
    if (x === "komma") return ",";
    if (x === "dubbele punt" || x === "dubbelpunt") return ":";
    if (x === "puntkomma") return ";";
    if (x === "vraagteken") return "?";
    if (x === "uitroepteken") return "!";
    if (x === "nieuwe regel" || x === "enter" || x === "nieuwe regel maken") return "\n";
    return null;
  }

  function normalizePopupQty(raw) {
    const s = String(raw || "").trim().replace(",", ".");
    const n = Number(s);
    if (!Number.isFinite(n) || n <= 0) return "";
    return String(n);
  }

  function normalizePopupPrice(raw) {
    const s = String(raw || "").trim().replace(",", ".");
    const n = Number(s);
    if (!Number.isFinite(n) || n === 0) return "";
    return n.toFixed(2).replace(".", ",");
  }

  function popupVatFromSpeech(raw) {
    const x = norm(raw);
    if (x.includes("21") || x.includes("hoog")) return "hoog";
    if (x.includes("9") || x.includes("laag")) return "laag";
    if (x === "0" || x.includes("nul")) return "0";
    if (x.includes("verlegd")) return "verlegd";
    return "";
  }

  function applyDictationToPopupField(raw0) {
    const el = document.activeElement;
    if (!isPopupOpen() || !isPopupField(el)) return false;

    if (el === qtyInputRef.current) {
      const v = normalizePopupQty(raw0);
      if (!v) return false;
      setLineDraft((prev) => ({ ...prev, quantity: v }));
      return true;
    }

    if (el === lineDescRef.current) {
      const punct = popupPunctMap(raw0);

      if (punct !== null) {
        setLineDraft((prev) => ({
          ...prev,
          description: `${String(prev.description || "")}${punct}`,
        }));
        return true;
      }

      let txt = String(raw0 || "").trim()
        .replace(/\bnieuwe regel\b/gi, "\n")
        .replace(/\bpuntkomma\b/gi, ";")
        .replace(/\bdubbele punt\b/gi, ":")
        .replace(/\buitroepteken\b/gi, "!")
        .replace(/\bvraagteken\b/gi, "?")
        .replace(/\bkomma\b/gi, ",")
        .replace(/\bpunt\b/gi, ".")
        .replace(/\s+([.,!?;:])/g, "$1");

      txt = txt.replace(/(^|[\n.!?]\s*)([a-zà-ÿ])/g, (_, p1, p2) => p1 + p2.toUpperCase());

      setLineDraft((prev) => {
        const cur = String(prev.description || "");
        const sep = cur && !cur.endsWith(" ") && !cur.endsWith("\n") ? " " : "";
        return { ...prev, description: cur + sep + txt };
      });
      return true;
    }

    if (el === linePriceRef.current) {
      const v = normalizePopupPrice(raw0);
      if (!v) return false;
      setLineDraft((prev) => ({ ...prev, unit_price: v }));
      return true;
    }

    if (el === lineVatRef.current) {
      const v = popupVatFromSpeech(raw0);
      if (!v) return false;
      setLineDraft((prev) => ({ ...prev, vat_rate: v }));
      return true;
    }

    return false;
  }

  function inFormContext() {
    try {
      const el = document.activeElement;
      if (!el) return false;

      if (isPopupOpen() && isPopupField(el)) return true;

      const inRight = rightScrollRef.current?.contains?.(el) || false;

      // Alleen echte invoer-velden in rechterblok tellen als formulier-context
      const tag = (el.tagName || "").toLowerCase();
      const isInputLike =
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        el.isContentEditable;

      return inRight && isInputLike;
    } catch {
      return false;
    }
  }

async function saveDocumentTextsFromPopup() {
  if (!formHasId() || popupMode === "preview" || isLocked || isReadonly) return;

  const payload = {
    organisation_id: form.organisation_id ? Number(form.organisation_id) : null,
    contact_id: form.contact_id ? Number(form.contact_id) : null,
    template_id: form.template_id ? Number(form.template_id) : null,
    invoice_date: form.invoice_date || null,
    due_date: form.due_date || null,
    order_date: form.order_date || null,
    planned_delivery_date: form.planned_delivery_date || null,
    invoice_number: form.invoice_number || null,
    reference: safeTrim(form.reference || ""),
    status: form.status || "DRAFT",
    delivery_status: form.delivery_status || "NOT_DELIVERED",
    series_code: form.series_code || null,
    notes: form.notes || "",

    document_subject: effectiveDocumentTexts.document_subject || "",
    ...documentVisibilityPayload(),
    document_salutation: currentDocumentTextValue(
      "document_salutation",
      effectiveDocumentTexts.document_salutation || ""
    ),
    document_intro_text: currentDocumentTextValue(
      "document_intro_text",
      effectiveDocumentTexts.document_intro_text || ""
    ),
    document_body_text: currentDocumentTextValue(
      "document_body_text",
      effectiveDocumentTexts.document_body_text || ""
    ),
    document_conditions_text: currentDocumentTextValue(
      "document_conditions_text",
      effectiveDocumentTexts.document_conditions_text || ""
    ),
    document_payment_text: currentDocumentTextValue(
      "document_payment_text",
      effectiveDocumentTexts.document_payment_text || ""
    ),
    document_planning_text: currentDocumentTextValue(
      "document_planning_text",
      effectiveDocumentTexts.document_planning_text || ""
    ),
    document_remark_text: currentDocumentTextValue(
      "document_remark_text",
      effectiveDocumentTexts.document_remark_text || ""
    ),
    document_warranty_text: currentDocumentTextValue(
      "document_warranty_text",
      effectiveDocumentTexts.document_warranty_text || ""
    ),
    document_closing_text: currentDocumentTextValue(
      "document_closing_text",
      effectiveDocumentTexts.document_closing_text || ""
    ),
    document_show_agreement_block: effectiveDocumentTexts.document_show_agreement_block === true,
    document_agreement_text: currentDocumentTextValue(
      "document_agreement_text",
      effectiveDocumentTexts.document_agreement_text || ""
    ),
    document_texts_initialized: true,

    subtotal: invoiceTotals.subtotal || 0,
    vat_total: invoiceTotals.vatTotal || invoiceTotals.vat_total || 0,
    total: invoiceTotals.total || 0,
  };

  const saved = await tryFetchJson([`/api/offers/${encodeURIComponent(form.id)}`], {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (saved && typeof saved === "object") {
    setItems((prev) => upsertById(prev, saved));
    setForm((prev) => ({
      ...prev,
      ...saved,
      document_texts_initialized: true,
    }));
    documentTextDraftRef.current = {};
    documentTextSelectionRef.current = null;
  }
}

async function showLiveOfferPreview() {
  setLineError(null);
  setLetterheadPdfPreviewError("");

  try {
    // Laat een actief tekstblok eerst zijn laatste inhoud naar React schrijven.
    document.activeElement?.blur?.();
  } catch {}

  // Eén tick wachten, zodat de onBlur-wijziging zichtbaar is.
  await new Promise((resolve) => setTimeout(resolve, 0));

  setActiveDocumentEditorKey("");

  // Zonder eigen briefpapier blijft de bestaande StaffIQ-voorbeeldweergave exact behouden.
  if (!useOwnLetterhead) {
    setPopupMode("preview");
    return;
  }

  // Met eigen briefpapier tonen we voortaan exact dezelfde PDF-rendering
  // als de server gebruikt voor opslaan/mailen.
  try {
    setLetterheadPdfPreviewBusy(true);

    // Voor de afdruk-HTML moet React eerst de echte preview-variant renderen
    // (zonder bewerkknoppen/-kolommen). Daarna zetten we het onderliggende scherm terug.
    setPopupMode("preview");
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const html = buildOfferPrintHtml();
    if (!html) throw new Error("Voorbeeld kon niet worden opgebouwd.");

    const pdfBlob = await fetchPdfBlob("/api/offers/preview-pdf-html", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html }),
    });

    const nextUrl = URL.createObjectURL(pdfBlob);
    setLetterheadPdfPreviewUrl(nextUrl);
  } catch (err) {
    setLetterheadPdfPreviewError(err?.message || "PDF-voorbeeld maken mislukt.");
  } finally {
    setPopupMode("edit");
    setLetterheadPdfPreviewBusy(false);
  }
}

function closeLetterheadPdfPreview() {
  setLetterheadPdfPreviewError("");
  setLetterheadPdfPreviewUrl("");
}

function printLetterheadPdfPreview() {
  if (!letterheadPdfPreviewUrl) return;

  try {
    const frameWindow = letterheadPdfPreviewFrameRef.current?.contentWindow;
    if (frameWindow?.print) {
      frameWindow.focus?.();
      frameWindow.print();
      return;
    }
  } catch {}

  window.open(letterheadPdfPreviewUrl, "_blank", "noopener,noreferrer");
}

function returnToOfferEdit() {
  setLineError(null);
  if (letterheadPdfPreviewUrl) {
    closeLetterheadPdfPreview();
    return;
  }
  setPopupMode("edit");
}

// Zelfde opslag voor beide popupknoppen: alleen bij Opslaan/Sluiten wordt afgesloten.
async function saveOfferPopup({ closeAfter = false } = {}) {
  if (popupMode === "preview") {
    returnToOfferEdit();
    return;
  }
  if (isReadonly || isLocked) {
    setLineError("Deze offerte/opdracht kan niet worden gewijzigd.");
    return;
  }
  setLineError(null);
  try {
    document.activeElement?.blur?.();
  } catch {}
  await new Promise((resolve) => setTimeout(resolve, 0));

  try {
    if (!formHasId()) throw new Error("Sla eerst de offerte op via het hoofdscherm.");
    await saveDocumentTextsFromPopup();
    const pendingLine = getPendingLinePayload();
    if (pendingLine) {
      const saved = await addInvoiceLine();
      if (saved === false) return;
    }
    // Ook de PDF in Documenten bijwerken, met behoud van deze popup bij Opslaan.
    await saveCurrentOfferDocumentAfterSave(form.id, { keepPopupOpen: !closeAfter });
    if (closeAfter) {
      setShowLinesPopup(false);
      setActiveDocumentEditorKey("");
      setEditingLineId(null);
      setNewLineMode("");
    }
    setFlash(closeAfter ? "Offerte opgeslagen en gesloten ✅" : "Offerte opgeslagen ✅");
  } catch (error) {
    // Geen succesmelding en de popup niet sluiten als opslag niet is gelukt.
    setShowLinesPopup(true);
    setPopupMode("edit");
    setLineError(error?.message || "Opslaan is mislukt.");
  }
}

async function handleSaveCloseClick() {
  await saveOfferPopup({ closeAfter: true });
}

async function handleSaveWithoutCloseClick() {
  await saveOfferPopup({ closeAfter: false });
}

async function closeOfferPopup() {
  setLineError(null);

  if (popupMode !== "preview") {
    try {
      // Eerst de vrije documentteksten opslaan. Daarna mogen eventuele
      // openstaande offerteregels worden verwerkt en opnieuw geladen.
      await saveDocumentTextsFromPopup();

      const pendingLine = getPendingLinePayload();
      if (pendingLine) {
        const lineSaved = await addInvoiceLine();
        if (lineSaved === false) return;
      }

      // Eerst bevestigen dat het opslaan echt gelukt is. De melding staat
      // bewust vóór het sluiten, zodat deze niet verloren kan gaan door
      // de state-wijziging/rerender van de popup.
      window.alert("De offerte is opgeslagen.");

      // Daarna terug naar het onderliggende Offertes-scherm.
      setShowLinesPopup(false);
      setActiveDocumentEditorKey("");
      setEditingLineId(null);
      setNewLineMode("");
      setProjectSearch("");
      setSelectedProjectIds([]);
      setExcludedProjectIds([]);
      setIncludeChildProjects(false);

      setFlash("Offerte opgeslagen ✅");
      setTimeout(() => setFlash(""), 1800);
      return;
    } catch (err) {
      const message = err?.message || "Offerte opslaan mislukt.";
      setLineError(message);
      window.alert(message);
      return;
    }
  }

  // In voorbeeldmodus is dit alleen Sluiten: niets opslaan, wel terug
  // naar het vorige Offertes-scherm.
  setShowLinesPopup(false);
  setActiveDocumentEditorKey("");
}

async function annuleerOfferPopup() {
  setLineError(null);
  documentTextDraftRef.current = {};
  documentTextSelectionRef.current = null;
  setEditingLineId(null);
  setSelectedProjectLineId("__manual__");
  setNewLineMode("");
  setProjectSearch("");
  setSelectedProjectIds([]);
  setExcludedProjectIds([]);
  setIncludeChildProjects(false);

  setLineDraft({
    line_type: "Artikel",
    quantity: 1,
    description: "",
    unit: "",
    unit_price: "",
    vat_rate: pickOrgDefaultVatRate(activeOrg),
  });

  if (formHasId()) {
    try {
      const det = await tryFetchJson([`/api/offers/${encodeURIComponent(form.id)}`]);
      const persisted = det?.offer ? det.offer : det;

      if (persisted && typeof persisted === "object") {
        const restored = {
          ...emptyForm,
          ...persisted,
          id: String(persisted.id || form.id),
          organisation_id: persisted.organisation_id ? String(persisted.organisation_id) : "",
          contact_id: persisted.contact_id ? String(persisted.contact_id) : "",
          template_id: persisted.template_id ? String(persisted.template_id) : "",
          reference: offerReferenceValue(persisted),
          invoice_date: isoDate(persisted.invoice_date) || "",
          due_date: isoDate(persisted.due_date) || "",
          order_date: isoDate(persisted.order_date) || "",
          planned_delivery_date: isoDate(persisted.planned_delivery_date) || "",
          status: normalizeDbStatus(persisted.status || "DRAFT"),
          document_order: Array.isArray(persisted.document_order) ? persisted.document_order : [],
        };
        savedOfferSnapshotRef.current = { ...restored };
        setForm(restored);

        const restoredLines =
          Array.isArray(det?.lines) ? det.lines :
          Array.isArray(det?.items) ? det.items :
          Array.isArray(persisted?.lines) ? persisted.lines :
          Array.isArray(persisted?.items) ? persisted.items :
          [];
        setLines(restoredLines);
      }
    } catch {
      if (savedOfferSnapshotRef.current) {
        setForm({ ...savedOfferSnapshotRef.current });
      }
    }
  }

  setShowLinesPopup(false);
  setActiveDocumentEditorKey("");
}

  function handleVoiceCommandLike(raw) {
    const t = norm(raw);
    const parts = t.split(" ").filter(Boolean);
    const w1 = parts[0] || "";
    const active = document.activeElement;

    if (w1 === "offerte") {
      saveItemForPopup();
      return true;
    }

if (w1 === "sluiten" && isPopupOpen()) {
  closeOfferPopup();
  return true;
}

    if (w1 === "regel" && isPopupOpen()) {
      addInvoiceLine();
      return true;
    }

    if (w1 === "volgende") {
      if (isPopupOpen() && isPopupField(active)) {
        if (active === lineVatRef.current) {
          addInvoiceLine();
          setTimeout(() => {
            qtyInputRef.current?.focus?.();
            qtyInputRef.current?.select?.();
          }, 0);
        } else {
          focusNextPopupField(+1);
        }
        return true;
      }

      if (inFormContext()) {
        if (active === payDateRef.current) {
          setTimeout(() => {
            payAmtRef.current?.focus?.();
          }, 0);
        } else if (active === payAmtRef.current) {
          addPayment();
          setTimeout(() => {
            payNotesRef.current?.focus?.();
          }, 0);
        } else {
          focusNextField(+1);
        }
      } else {
        moveCursor(+1);
      }
      return true;
    }

    if (w1 === "vorige") {
      if (isPopupOpen() && isPopupField(active)) {
        focusNextPopupField(-1);
        return true;
      }

      if (inFormContext()) {
        focusNextField(-1);
      } else {
        moveCursor(-1);
      }
      return true;
    }

if (w1 === "terug" || w1 === "links") {
  if (isPopupOpen()) {
    closeOfferPopup();
    return true;
  }

      resetRightPanelEmpty();
      setMode("search");
      setTimeout(() => {
        searchRef.current?.focus?.();
      }, 0);
      return true;
    }

if (w1 === "rechts" || w1 === "selecteer" || w1 === "selecteren" || w1 === "item") {
      openCurrentRowToRight();
      return true;
    }

    if (w1 === "nieuw" || w1 === "nieuwe") {
      if (isPopupOpen()) {
        setEditingLineId(null);
        setLineDraft({
          line_type: "Artikel",
          quantity: 1,
          description: "",
          unit: "",
          unit_price: "",
          vat_rate: pickOrgDefaultVatRate(activeOrg),
        });
        focusFirstPopupField();
        return true;
      }

      newItem();
      return true;
    }

    if (w1 === "vernieuw" || w1 === "vernieuwen") {
      vernieuwList();
      return true;
    }

    if (w1 === "opslaan" || w1 === "bewaren") {
      if (isPopupOpen()) {
        addInvoiceLine();
        return true;
      }

      saveItem();
      return true;
    }

    if (w1 === "verwijder" || w1 === "verwijderen" || w1 === "delete") {
      deleteItem();
      return true;
    }

    if (w1 === "betaling") {
      addPayment();
      setTimeout(() => {
        payNotesRef.current?.focus?.();
      }, 0);
      return true;
    }

    return false;
  }

  function highlightItemIndex(idx) {
    const L = sortedItems.length;
    if (L <= 0) return;
    const clamped = clampIndex(idx, L);
    setListIndex(clamped);
    setTimeout(() => scrollRowIntoView(clamped), 0);
  }

function openCurrentRowToRight() {
    const L = sortedItems.length;
    if (L <= 0) return;

    const idx = ensureCursorExists();
    if (idx < 0) return;

    const it = sortedItems[idx];
    if (!it) return;

    setListIndex(idx);
    loadItemFromRow(it);
    setMode("form");

    if (window.innerWidth <= 768) {
      focusFirstRightFieldMobile();
    } else {
      focusFirstRightField();
    }

    setTimeout(() => scrollRowIntoView(idx), 0);
  }

  function getFocusableElements() {
    const els = focusOrderRefs.map((r) => r?.current).filter(Boolean);
    return els.filter((el) => {
      try {
        if (el.disabled) return false;
        const rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      } catch {
        return false;
      }
    });
  }

  function focusFirstRightField() {
    setTimeout(() => {
      try {
        scrollRightTop();
        orgRef.current?.focus?.();
      } catch { }
    }, 0);
  }

  function focusNextField(dir = +1) {
    const els = getFocusableElements();
    if (!els.length) return;

    const active = document.activeElement;
    let idx = els.findIndex((el) => el === active);
    if (idx === -1) idx = dir > 0 ? -1 : els.length;

    let next = idx + dir;
    if (next < 0) next = 0;
    if (next > els.length - 1) next = els.length - 1;

    const el = els[next];
    if (!el) return;

    try {
      el.focus?.();
      el.scrollIntoView?.({ block: "nearest" });
    } catch { }
  }
  useEffect(() => {
    if (!pendingSpeechSearch) return;
    if (loading) return;

    if (sortedItems.length > 0) {
      setListIndex(0);
      setTimeout(() => {
        scrollMidTop();
        scrollRowIntoView(0);
      }, 0);
    } else {
      setListIndex(-1);
      setTimeout(() => scrollMidTop(), 0);
    }

    setPendingSpeechSearch(false);
  }, [pendingSpeechSearch, loading, sortedItems.length]);

  function applyDictationToFocusedField(raw0) {
    const el = document.activeElement;
    if (!el) return false;

    const containerHas = rightScrollRef.current?.contains?.(el);
    if (!containerHas) return false;

    const tag = (el.tagName || "").toLowerCase();
    const type = (el.getAttribute?.("type") || "").toLowerCase();

    if (el === orgRef.current) {
      const spoken = norm(raw0);
      const found = orgs.find((o) => norm(pickOrgName(o)) === spoken || norm(pickOrgName(o)).includes(spoken));
      if (!found) return false;

      setForm((prev) => ({
        ...prev,
        organisation_id: String(found.id || ""),
        contact_id: "",
      }));
      return true;
    }

    if (el === contactRef.current) {
      const spoken = norm(raw0);
      const found = contacts.find((c) => {
        const nm = pickContactFullName(c);
        return norm(nm) === spoken || norm(nm).includes(spoken);
      });
      if (!found) return false;

      setForm((prev) => ({
        ...prev,
        contact_id: String(found.id || ""),
      }));
      return true;
    }

    if (el === invNumRef.current) {
      const v = String(raw0 || "").trim();
      setForm((prev) => ({ ...prev, reference: v }));
      return true;
    }

    if (el === invDateRef.current || (tag === "input" && type === "date" && el === invDateRef.current)) {
      const iso = parseDutchDateToISO(raw0);
      if (!iso) return false;
      setForm((prev) => ({ ...prev, invoice_date: iso }));
      return true;
    }

    if (el === payDateRef.current) {
      const iso = parseDutchDateToISO(raw0);
      if (!iso) return false;
      setPayDraft((prev) => ({ ...prev, paid_on: iso }));
      return true;
    }

    if (el === payAmtRef.current) {
      const amt = decimal2OrEmptyString(raw0);
      if (!amt) return false;
      setPayDraft((prev) => ({ ...prev, amount: amt }));
      return true;
    }

    if (el === payNotesRef.current) {
      const punct = punctToChar(raw0);

      if (punct) {
        setForm((prev) => ({
          ...prev,
          notes: `${String(prev.notes || "")}${punct}`,
        }));
        return true;
      }

      let txt = String(raw0 || "").trim()
        .replace(/\bnieuwe regel\b/gi, "\n")
        .replace(/\bpuntkomma\b/gi, ";")
        .replace(/\bdubbele punt\b/gi, ":")
        .replace(/\buitroepteken\b/gi, "!")
        .replace(/\bvraagteken\b/gi, "?")
        .replace(/\bkomma\b/gi, ",")
        .replace(/\bpunt\b/gi, ".")
        .replace(/\s+([.,!?;:])/g, "$1");

      txt = txt.replace(/(^|[\n.!?]\s*)([a-zà-ÿ])/g, (_, p1, p2) => p1 + p2.toUpperCase());

      setForm((prev) => {
        const cur = String(prev.notes || "");
        const sep = cur && !cur.endsWith(" ") && !cur.endsWith("\n") ? " " : "";
        return { ...prev, notes: cur + sep + txt };
      });
      return true;
    }

if (el === statusRef.current && tag === "select") {
      const spoken = norm(raw0 || "");
      let next = "";
      if (spoken.includes("concept")) next = "DRAFT";
      else if (spoken.includes("verzonden")) next = "SENT";
      if (!next) return false;
      setForm((prev) => ({ ...prev, status: next }));
      return true;
    }

    return false;
  }

  const voice = useVoiceCommands({
    lang: "nl-NL",
    timeoutMs: 8500,
    onCommand: (cmd, rawHeard) => {
      const raw = String(rawHeard || "").trim();
      if (raw) {
        setSpeechInfo(`🎙 ${raw}`);
        setTimeout(() => setSpeechInfo(""), 2000);
      }
      if (raw && handleVoiceCommandLike(raw)) return true;
      if (!cmd || !cmd.type) return false;
      if (cmd.type === "new" || cmd.type === "nieuw") { newItem(); return true; }
      if (cmd.type === "refresh") { vernieuwList(); return true; }
      if (cmd.type === "save") { saveItem(); return true; }
      if (cmd.type === "delete") { deleteItem(); return true; }
      return false;
    },
    onDictation: (text) => {
      const raw0 = String(text || "").trim();
      if (!raw0) return;
      setSpeechInfo(`🎙 ${raw0}`);
      setTimeout(() => setSpeechInfo(""), 2000);
      if (handleVoiceCommandLike(raw0)) return;
      if (applyDictationToPopupField(raw0)) return;
      if (applyDictationToFocusedField(raw0)) return;
      if (mode === "search") {
        if (isEmptyWord(raw0)) {
          setQ("");
        } else {
          setQ(raw0);
        }
      }
    },
  });

    useEffect(() => {
      const cur = String(voice.error || "");
      const prev = String(prevVoiceErrorRef.current || "");
      if (cur && cur !== prev) {
        setHideVoiceError(false);
        prevVoiceErrorRef.current = cur;
      }
      if (!cur) prevVoiceErrorRef.current = "";
    }, [voice.error]);

    function startSpeakSmart() {
      if (!voice.supported || voice.listening) return;
      setHideVoiceError(true);
      voice.startOnce();
    }


// ---------- AI OFFERTES ----------
function openAiPopup(source = "page") {
  setAiSource(source);
  setAiOpen(true);
  setAiText("");
  setFlash("");
  setTimeout(() => {
    try {
      aiTextRef.current?.focus?.({ preventScroll: true });
    } catch {
      try { aiTextRef.current?.focus?.(); } catch {}
    }
  }, 0);
}

function closeAiPopup() {
  if (aiBusy) return;
  setAiOpen(false);
  setAiText("");
  setAiSource("page");
}

function firstFilled(...vals) {
  for (const v of vals) {
    const t = safeTrim(v);
    if (t) return t;
  }
  return "";
}

function formatAnyAmount(v) {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "-";
  return euro(n);
}

function getOrganisationIdForAi() {
  return form?.organisation_id || activeOrg?.id || selectedInvoiceRow?.organisation_id || "";
}

function getOrganisationNameForAi() {
  return firstFilled(
    activeOrg?.name,
    activeOrg?.organisation_name,
    selectedInvoiceRow?.organisation_name,
    recipientName
  );
}

function getContactForAi() {
  return selectedContact || null;
}

function buildCurrentOfferContext() {
  const orgName = getOrganisationNameForAi();
  const contact = getContactForAi();
  const contactName = firstFilled(
    contact?.search_name,
    contact?.full_name,
    contact?.naam,
    [contact?.first_name, contact?.name_prefix, contact?.last_name].filter(Boolean).join(" "),
    pickContactNameFromRow(selectedInvoiceRow || {})
  );

  const offerNumber = firstFilled(form.invoice_number, selectedInvoiceRow?.invoice_number, selectedInvoiceRow?.offer_number);
  const offerDate = firstFilled(formatNlDate(form.invoice_date), formatNlDate(selectedInvoiceRow?.invoice_date), formatNlDate(selectedInvoiceRow?.offer_date));
  const status = statusLabel(form.status || selectedInvoiceRow?.status);

  const out = [];
  out.push("HUIDIGE OFFERTE");
  out.push(`Relatie: ${orgName || "-"}`);
  out.push(`Contactpersoon: ${contactName || "-"}`);
  out.push(`Offertenummer/referentie: ${offerNumber || "-"}`);
  out.push(`Offertedatum: ${offerDate || "-"}`);
  out.push(`Status: ${status || "-"}`);
  out.push(`Totaal: ${euro(invoiceTotals.total || form.total || selectedInvoiceRow?.total || 0)}`);
  out.push("");
  out.push("REGELS");

  const useLines = Array.isArray(linesForTotals) ? linesForTotals : [];
  if (!useLines.length) {
    out.push("Geen offerteregels gevonden.");
  } else {
    useLines.forEach((ln, idx) => {
      out.push(`${idx + 1}. ${lineQty(ln)} x ${lineDescription(ln) || "-"} à ${euro(lineUnitPrice(ln))} (${vatLabelForRate(lineVatRate(ln))})`);
    });
  }

  if (safeTrim(form.notes)) {
    out.push("");
    out.push("NOTITIES");
    out.push(form.notes);
  }

  return out.join("\n");
}

function runAiOrganisationData() {
  const org = activeOrg || selectedInvoiceRow || {};
  const lines = [];
  lines.push("RELATIE GEGEVENS");
  lines.push(`Naam: ${getOrganisationNameForAi() || "-"}`);
  lines.push(`Telefoon: ${firstFilled(org.phone, org.org_phone) || "-"}`);
  lines.push(`Mobiel: ${firstFilled(org.mobile, org.org_mobile) || "-"}`);
  lines.push(`E-mail: ${firstFilled(org.email, org.org_email) || "-"}`);
  lines.push(`Website: ${firstFilled(org.website) || "-"}`);
  lines.push(`KvK: ${firstFilled(org.kvk, org.kvk_number) || "-"}`);
  lines.push(`BTW nummer: ${pickOrgVatNumber(org) || "-"}`);
  lines.push("");
  lines.push("Correspondentieadres:");
  lines.push(firstFilled([
    org.corr_street,
    org.corr_house_number,
    org.corr_addition,
  ].filter(Boolean).join(" ")) || "-");
  lines.push(firstFilled([org.corr_postcode, org.corr_city].filter(Boolean).join(" ")) || "-");
  lines.push(firstFilled(org.corr_country) || "-");

  setAiText(lines.join("\n"));
  setFlash("Relatiegegevens getoond ✓");
}

function runAiContactData() {
  const c = getContactForAi();
  const lines = [];
  lines.push("CONTACTPERSOON GEGEVENS");

  if (!c) {
    lines.push("Geen contactpersoon gekozen of geladen.");
    setAiText(lines.join("\n"));
    setFlash("");
    return;
  }

  const contactName = firstFilled(
    c.search_name,
    c.full_name,
    c.naam,
    [c.first_name, c.name_prefix, c.last_name].filter(Boolean).join(" ")
  );

  lines.push(`Naam: ${contactName || "-"}`);
  lines.push(`Functie: ${firstFilled(c.job_title, c.function, c.functie) || "-"}`);
  lines.push(`Telefoon: ${firstFilled(c.phone, c.telephone) || "-"}`);
  lines.push(`Mobiel: ${firstFilled(c.mobile) || "-"}`);
  lines.push(`E-mail: ${firstFilled(c.email) || "-"}`);
  lines.push(`Aanschrijving: ${firstFilled(c.aanschrijving, c.aanhef, c.salutation) || "-"}`);

  setAiText(lines.join("\n"));
  setFlash("Contactpersoongegevens getoond ✓");
}

async function runAiDossierOverview() {
  const orgId = getOrganisationIdForAi();
  if (!orgId) {
    setAiText("Kies eerst een relatie.");
    return;
  }

  try {
    setAiBusy(true);
    setFlash("Dossieroverzicht wordt gemaakt...");

    const dossier = await tryFetchJson([`/api/organisations/${encodeURIComponent(orgId)}/dossier`]);
    const org = dossier?.organisation || {};
    const contactsList = Array.isArray(dossier?.contacts) ? dossier.contacts : [];
    const notesTasks = Array.isArray(dossier?.notes_tasks) ? dossier.notes_tasks : [];
    const offers = Array.isArray(dossier?.offers) ? dossier.offers : [];
    const invoices = Array.isArray(dossier?.invoices) ? dossier.invoices : [];

    const lines = [];
    lines.push("DOSSIER OVERZICHT");
    lines.push(`Relatie: ${firstFilled(org.name, getOrganisationNameForAi()) || "-"}`);
    lines.push(`Telefoon: ${firstFilled(org.phone, org.mobile) || "-"}`);
    lines.push(`E-mail: ${firstFilled(org.email) || "-"}`);
    lines.push(`KvK: ${firstFilled(org.kvk, org.kvk_number) || "-"}`);
    lines.push("");

    lines.push(`CONTACTPERSONEN (${contactsList.length})`);
    if (!contactsList.length) lines.push("Geen contactpersonen gevonden.");
    contactsList.forEach((c) => {
      const nm = firstFilled(c.search_name, c.full_name, c.naam, [c.last_name, c.first_name].filter(Boolean).join(", ")) || "-";
      lines.push(`- ${nm} | ${firstFilled(c.phone, c.mobile) || "-"} | ${firstFilled(c.email) || "-"}`);
    });
    lines.push("");

    lines.push(`NOTITIES/TAKEN (${notesTasks.length})`);
    if (!notesTasks.length) lines.push("Geen notities/taken gevonden.");
    notesTasks.slice(0, 20).forEach((n) => {
      lines.push(`- ${firstFilled(n.kind, n.type) || "-"} | ${firstFilled(n.subject, n.title) || "-"} | ${firstFilled(n.status) || "-"}`);
    });
    lines.push("");

    lines.push(`OFFERTES (${offers.length}) - nieuw naar oud`);
    if (!offers.length) lines.push("Geen offertes gevonden.");
    offers.forEach((o) => {
      lines.push(`- ${firstFilled(o.dossier_date, formatNlDate(o.offer_date), formatNlDate(o.invoice_date)) || "-"} | ${firstFilled(o.dossier_number, o.offer_number, o.invoice_number) || "-"} | ${firstFilled(o.status) || "-"} | ${formatAnyAmount(firstFilled(o.dossier_total, o.total))}`);
    });
    lines.push("");

    lines.push(`FACTUREN (${invoices.length}) - nieuw naar oud`);
    if (!invoices.length) lines.push("Geen facturen gevonden.");
    invoices.forEach((i) => {
      lines.push(`- ${firstFilled(i.dossier_date, formatNlDate(i.invoice_date)) || "-"} | ${firstFilled(i.dossier_number, i.invoice_number) || "-"} | ${firstFilled(i.status) || "-"} | ${formatAnyAmount(firstFilled(i.dossier_total, i.total))}`);
    });

    setAiText(lines.join("\n"));
    setFlash("Dossieroverzicht gemaakt ✓");
  } catch (err) {
    setAiText("FOUT:\n" + (err?.message || "Onbekende fout"));
    setFlash("");
  } finally {
    setAiBusy(false);
  }
}

async function runAiOfferCheck() {
  try {
    setAiBusy(true);
    setFlash("AI controleert offerte...");

    const prompt = `
Je bent een ervaren Nederlandse sales- en administratie-assistent in StaffIQ.
Controleer deze offerte inhoudelijk en praktisch.

${buildCurrentOfferContext()}

Geef antwoord in duidelijk Nederlands met deze kopjes:
1. Korte conclusie
2. Mogelijke fouten of ontbrekende gegevens
3. Financiële controle
4. Advies om de offerte sterker te maken
5. Actiepunten
    `.trim();

    const res = await tryFetchJson(["/api/ai/organisations/check"], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        organisation: activeOrg || {},
        mode: "chat",
        question: "Controleer deze offerte.",
        prompt,
      }),
    });

    if (!res?.ok) throw new Error(res?.error || "AI controle mislukt");

    setAiText(res.result || "Geen resultaat");
    setFlash("Offerte gecontroleerd ✓");
  } catch (err) {
    setAiText("FOUT:\n" + (err?.message || "Onbekende fout"));
    setFlash("");
  } finally {
    setAiBusy(false);
  }
}

function appendAiConversation(qText, aText) {
  const block =
    `Vraag:\n${qText || "-"}\n\n` +
    `----------------------------------------\n\n` +
    `Antwoord:\n${aText || "-"}\n\n` +
    `========================================\n\n`;

  setAiText((prev) => {
    const cur = String(prev || "").trim();
    if (!cur) return block;
    return `${cur}\n\n${block}`;
  });
}

async function runAiChat() {
  const question = String(aiText || "").trim();

  if (!question) {
    setAiText("Typ eerst een vraag voor Chat met AI.\n\nBijvoorbeeld:\nWat ontbreekt er nog in deze offerte?");
    setTimeout(() => {
      try { aiTextRef.current?.focus?.({ preventScroll: true }); } catch { try { aiTextRef.current?.focus?.(); } catch {} }
    }, 0);
    return;
  }

  try {
    setAiBusy(true);
    setFlash("AI beantwoordt vraag...");

    const prompt = `
Je bent een zakelijke assistent voor StaffIQ.
Beantwoord de vraag op basis van deze offerte, relatie en contactpersoon.

${buildCurrentOfferContext()}

VRAAG:
${question}

Antwoord in helder Nederlands. Zeg eerlijk als iets niet uit de gegevens blijkt.
    `.trim();

    const res = await tryFetchJson(["/api/ai/organisations/check"], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        organisation: activeOrg || {},
        mode: "chat",
        question,
        prompt,
      }),
    });

    if (!res?.ok) throw new Error(res?.error || "AI chat mislukt");

    appendAiConversation(question, res.result || "Geen antwoord");
    setFlash("AI chat gereed ✓");
  } catch (err) {
    appendAiConversation(question, "FOUT: " + (err?.message || "Onbekende fout"));
    setFlash("");
  } finally {
    setAiBusy(false);
  }
}

function printAiDocument() {
  const title = aiSource === "popup" ? "StaffIQ AI Offerte" : "StaffIQ AI Offertes";
  const content = String(aiText || "").trim() || "Geen inhoud om te printen.";

  const html = `
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: Calibri, Carlito, Arial, sans-serif; padding: 24px; color: #111; line-height: 1.45; white-space: pre-wrap; }
          h1 { font-size: 20px; margin: 0 0 18px 0; }
        </style>
      </head>
      <body>
        <h1>${title}</h1>
        <div>${content.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}</div>
      </body>
    </html>
  `;

  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { try { win.print(); } catch {} }, 300);
}

function startAiSpeak() {
  if (!voice.supported || voice.listening) return;
  try { aiTextRef.current?.focus?.({ preventScroll: true }); } catch { try { aiTextRef.current?.focus?.(); } catch {} }
  voice.startOnce();
}

// ---------- LAYOUT (zelfde stijl als Contactpersonen) ----------
    const isMobile = window.innerWidth <= 768;
    const RIGHT_WIDTH = isMobile ? "100%" : 320;
    const GAP = isMobile ? 18 : 14;
    const TABLE_MIN_WIDTH = 1410;
    const MID_BOTTOM_OFFSET = isMobile ? 90 : 135;

    // Kolombreedtes
    const colWidths = {
      zoeknaam: 68,
      contact: 62,
      invnr: 44,
      invdt: 44,
      totaal: 48,
      tel: 62,
      mob: 62,
      email: 78,
      city: 44,
      country: 40,
      status: 38,
      companyCode: 90,
    };

    const searchInputStyle = {
      padding: "7px 10px",
      width: 180,
      border: "1px solid #d9d9d9",
      borderRadius: 4,
      background: "white",
      outline: "none",
      boxSizing: "border-box",
    };

    const inputStyle = {
      padding: "7px 10px",
      width: "100%",
      minWidth: 0,
      border: "1px solid #d9d9d9",
      borderRadius: 4,
      background: "white",
      boxSizing: "border-box",
    };

    const dateInputStyle = {
      ...inputStyle,
      paddingRight: 30,
    };

const buttonStyle = {
  padding: "6px 6px",
  border: "1px solid #d9d9d9",
  borderRadius: 4,
  background: "white",
  cursor: "pointer",
  whiteSpace: "nowrap",
  fontSize: 12,
  minWidth: 0,
};

    const buttonPrimary = (bg) => ({
      ...buttonStyle,
      background: bg,
      color: "white",
      border: "1px solid rgba(0,0,0,0.05)",
    });

    const iconActionButtonStyle = ({ bg, color = "#fff", disabled = false }) => ({
      ...buttonStyle,
      width: 34,
      height: 30,
      padding: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 16,
      fontWeight: 700,
      lineHeight: 1,
      background: bg,
      color,
      border: "1px solid rgba(0,0,0,0.08)",
      opacity: disabled ? 0.5 : 1,
      cursor: disabled ? "not-allowed" : "pointer",
    });

    const buttonDisabledStyle = { ...buttonStyle, opacity: 0.55, cursor: "not-allowed" };

    const selectStyle = {
      height: 30,
      padding: "0 8px",
      border: "1px solid #d9d9d9",
      borderRadius: 4,
      background: "white",
      width: "100%",
      minWidth: 0,
      boxSizing: "border-box",
    };

    const tableStyle = { width: "100%", borderCollapse: "separate", borderSpacing: 0, tableLayout: "fixed" };

    const thBase = {
      textAlign: "left",
      fontSize: 12,
      color: "#444",
      fontWeight: 700,
      padding: "8px 6px",
      borderBottom: "1px solid #e6e6e6",
      whiteSpace: "nowrap",
      position: "sticky",
      top: 0,
      zIndex: 5,
      background: "#fff",
      userSelect: "none",
    };

    const thClickable = { ...thBase, cursor: "pointer" };

    const filterThStyle = {
      ...thBase,
      fontWeight: 400,
      padding: "6px 6px 8px 6px",
      borderBottom: "1px solid #ededed",
      top: 32,
      zIndex: 4,
      cursor: "default",
    };

    const tdStyle = {
      padding: "7px 6px",
      borderBottom: "1px solid #efefef",
      fontSize: 13,
      color: "#222",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };

    const rowBgCursor = "#f3f7ff";
    const rowBgSelected = "#e6f0ff";

    function sortToggle(key) {
      setSort((s) => {
        if (s.key !== key) return { key, dir: key === "invoice_date" ? "desc" : "asc" };
        return { key, dir: s.dir === "asc" ? "desc" : "asc" };
      });
    }

    function sortArrow(key) {
      if (sort.key !== key) return "";
      return sort.dir === "asc" ? " ▲" : " ▼";
    }

    const deleteEnabled = formHasId() && currentStatus === "OFFERTE";

    const companyInvoiceProfile = {
      name: "Tech Company BV",
      addressLines: ["Europaplein 1", "Gebouw 21 - 2.05", "5684 ZC BEST"],
      email: "peter@techcompany.nl",
      phone: "+31 76 2031933",
      kvk: "67282466",
      vatNumber: "NL856911252B01",
      iban: "NL59 INGB 0007 6330 52",
      gIban: "G-REKENING NOG IN TE STELLEN",
      footerText:
        "Wij verzoeken u vriendelijk bij uw reactie de referentie te vermelden.",
    };

    const selectedInvoiceRow = useMemo(() => {
      const rid = String(form.id || selectedId || "");
      if (!rid) return null;
      return items.find((x) => String(x.id || "") === rid) || null;
    }, [items, form.id, selectedId]);

    const activeOrg = orgDetail || selectedOrgFromList || null;
    const activeDocumentType =
      normalizeDbStatus(form.status || "OFFERTE") === "OFFERTE"
        ? "offer"
        : "order";

    const normalizedOrderDocumentSettings = {
      offer_title:
        orderDocumentSettings.document_title ||
        orderDocumentSettings.offer_title ||
        "Opdrachtbevestiging",
      offer_contact_person:
        orderDocumentSettings.contact_person ||
        orderDocumentSettings.offer_contact_person ||
        "",
      offer_company_name:
        orderDocumentSettings.company_name ||
        orderDocumentSettings.offer_company_name ||
        "",
      offer_company_address_1:
        orderDocumentSettings.company_address_1 ||
        orderDocumentSettings.offer_company_address_1 ||
        "",
      offer_company_address_2:
        orderDocumentSettings.company_address_2 ||
        orderDocumentSettings.offer_company_address_2 ||
        "",
      offer_company_postcode:
        orderDocumentSettings.company_postcode ||
        orderDocumentSettings.offer_company_postcode ||
        "",
      offer_company_city:
        orderDocumentSettings.company_city ||
        orderDocumentSettings.offer_company_city ||
        "",
      offer_company_country:
        orderDocumentSettings.company_country ||
        orderDocumentSettings.offer_company_country ||
        "",
      offer_company_email:
        orderDocumentSettings.company_email ||
        orderDocumentSettings.offer_company_email ||
        "",
      offer_company_website:
        orderDocumentSettings.company_website ||
        orderDocumentSettings.offer_company_website ||
        "",
      offer_company_phone:
        orderDocumentSettings.company_phone ||
        orderDocumentSettings.offer_company_phone ||
        "",
      offer_company_kvk:
        orderDocumentSettings.company_kvk ||
        orderDocumentSettings.offer_company_kvk ||
        "",
      offer_company_vat:
        orderDocumentSettings.company_vat ||
        orderDocumentSettings.offer_company_vat ||
        "",
      offer_company_iban:
        orderDocumentSettings.company_iban ||
        orderDocumentSettings.offer_company_iban ||
        "",
      offer_company_g_iban:
        orderDocumentSettings.company_g_iban ||
        orderDocumentSettings.offer_company_g_iban ||
        "",
      logo_url: orderDocumentSettings.logo_url || "",
      offer_text:
        orderDocumentSettings.intro_text ||
        orderDocumentSettings.offer_text ||
        "",
      offer_footer_text:
        orderDocumentSettings.footer_text ||
        orderDocumentSettings.offer_footer_text ||
        "",
      email_subject:
        orderDocumentSettings.email_subject ||
        "Opdrachtbevestiging {referentie}",
      email_text: orderDocumentSettings.email_text || "",
      whatsapp_text: orderDocumentSettings.whatsapp_text || "",
      approval_text: orderDocumentSettings.approval_text || "",
      approved_page_text: orderDocumentSettings.approved_page_text || "",
      rejected_page_text: orderDocumentSettings.rejected_page_text || "",
    };

    const effectiveOfferSettings =
      activeDocumentType === "order"
        ? {
            ...invoiceSettings,
            ...normalizedOrderDocumentSettings,
          }
        : {
            ...invoiceSettings,
            ...offerDocumentSettings,
          };

    const letterheadBackgroundDataUrl = safeTrim(
      letterheadSettings?.letterhead_background_data_url ||
      (
        /^data:image\//i.test(safeTrim(letterheadSettings?.letterhead_data_url))
          ? letterheadSettings?.letterhead_data_url
          : ""
      )
    );
    const useOwnLetterhead =
      letterheadSettings?.use_own_letterhead === true &&
      !!letterheadBackgroundDataUrl;
    // vOFF-131: in Bewerken blijft het document rustig en zonder voorgedrukte achtergrond.
    // De echte achtergrond is zichtbaar in PDF-Voorbeeld, print, mail en opgeslagen document.
    const showLetterheadOnEditor = useOwnLetterhead && popupMode === "preview";
    const approvalPreference = getRelationApprovalPreference();
    const canSendForApproval = approvalPreference.whatsappAllowed || approvalPreference.emailAllowed;
    const approvalButtonDisabled = sendingApproval || !formHasId() || !canSendForApproval;
    const approvalButtonTitle = !formHasId()
      ? "Sla de offerte/opdracht eerst op."
      : !canSendForApproval
        ? "Bij deze relatie staat akkoord via WhatsApp of E-mail niet aan, of mobiel/e-mail ontbreekt."
        : "Maak akkoordlink en verstuur volgens relatievoorkeur WhatsApp/E-mail";

    function templateTypeLabel(value) {
      const t = String(value || "offer").toLowerCase();

      if (t === "order") return "Opdracht";
      if (t === "both") return "Beide";

      return "Offerte";
    }

    const selectableOfferTemplates = useMemo(() => {
      return (offerTemplates || [])
        .filter((tpl) => {
          if (tpl.active === false) return false;

          const type = String(tpl.template_type || "offer").toLowerCase();
          if (activeDocumentType === "order") {
            return type === "order" || type === "both";
          }

          return type === "offer" || type === "both";
        })
        .slice()
        .sort((a, b) => {
          const ta = templateTypeLabel(a.template_type);
          const tb = templateTypeLabel(b.template_type);

          if (ta !== tb) return ta.localeCompare(tb, "nl");

          return String(a.name || "").localeCompare(String(b.name || ""), "nl");
        });
    }, [offerTemplates, activeDocumentType]);

    const selectedOfferTemplate = useMemo(() => {
      const wanted = String(form.template_id || "");
      if (!wanted) return null;
      return (offerTemplates || []).find((tpl) => String(tpl.id) === wanted) || null;
    }, [offerTemplates, form.template_id]);

    function templateTexts(tpl = null) {
      const source = tpl || {};
      return {
        document_subject: source.subject || "",
        document_show_subject: source.show_subject !== false,
        document_salutation: source.salutation || "",
        document_show_salutation: source.show_salutation !== false,
        document_intro_text: source.intro_text || "",
        document_show_intro_text: source.show_intro_text !== false,
        document_body_text: source.body_text || "",
        document_show_body_text: source.show_body_text !== false,
        document_conditions_text: source.conditions_text || "",
        document_show_conditions_text: source.show_conditions_text !== false,
        document_payment_text: source.payment_text || "",
        document_show_payment_text: source.show_payment_text !== false,
        document_planning_text: source.planning_text || "",
        document_show_planning_text: source.show_planning_text !== false,
        document_remark_text: source.remark_text || "",
        document_show_remark_text: source.show_remark_text !== false,
        document_warranty_text: source.warranty_text || "",
        document_show_warranty_text: source.show_warranty_text !== false,
        document_closing_text: source.closing_text || "",
        document_show_closing_text: source.show_closing_text !== false,
        document_show_agreement_block: source.show_agreement_block === true,
        document_agreement_text: source.agreement_text || "",
        document_texts_initialized: true,
      };
    }

    function fallbackDocumentTexts() {
      if (selectedOfferTemplate) return templateTexts(selectedOfferTemplate);

      return {
        document_subject: "",
        document_show_subject: true,
        document_salutation: "",
        document_show_salutation: true,
        document_intro_text: effectiveOfferSettings?.offer_text || "",
        document_show_intro_text: true,
        document_body_text: "",
        document_show_body_text: true,
        document_conditions_text: "",
        document_show_conditions_text: true,
        document_payment_text: "",
        document_show_payment_text: true,
        document_planning_text: "",
        document_show_planning_text: true,
        document_remark_text: "",
        document_show_remark_text: true,
        document_warranty_text: "",
        document_show_warranty_text: true,
        document_closing_text: "",
        document_show_closing_text: true,
        document_show_agreement_block: false,
        document_agreement_text: "",
        document_texts_initialized: false,
      };
    }

    const effectiveDocumentTexts = form.document_texts_initialized === true
      ? {
          document_subject: form.document_subject || "",
          document_show_subject: form.document_show_subject !== false,
          document_salutation: form.document_salutation || "",
          document_show_salutation: form.document_show_salutation !== false,
          document_intro_text: form.document_intro_text || "",
          document_show_intro_text: form.document_show_intro_text !== false,
          document_body_text: form.document_body_text || "",
          document_show_body_text: form.document_show_body_text !== false,
          document_conditions_text: form.document_conditions_text || "",
          document_show_conditions_text: form.document_show_conditions_text !== false,
          document_payment_text: form.document_payment_text || "",
          document_show_payment_text: form.document_show_payment_text !== false,
          document_planning_text: form.document_planning_text || "",
          document_show_planning_text: form.document_show_planning_text !== false,
          document_remark_text: form.document_remark_text || "",
          document_show_remark_text: form.document_show_remark_text !== false,
          document_warranty_text: form.document_warranty_text || "",
          document_show_warranty_text: form.document_show_warranty_text !== false,
          document_closing_text: form.document_closing_text || "",
          document_show_closing_text: form.document_show_closing_text !== false,
          document_show_agreement_block: form.document_show_agreement_block === true,
          document_agreement_text: form.document_agreement_text || "",
        }
      : fallbackDocumentTexts();

    function applyTemplateToDocumentTexts(templateId) {
      const id = String(templateId || "");
      const tpl = (offerTemplates || []).find((row) => String(row.id) === id) || null;

      setForm((prev) => ({
        ...prev,
        template_id: id,
        ...templateTexts(tpl),
      }));
    }

    function clearDocumentTexts() {
      const ok = window.confirm(
        "Alle teksten van deze offerte/opdracht leegmaken?\n\nDe standaardinstellingen en het sjabloon blijven ongewijzigd."
      );
      if (!ok) return;

      setForm((prev) => ({
        ...prev,
        document_subject: "",
        document_salutation: "",
        document_intro_text: "",
        document_body_text: "",
        document_conditions_text: "",
        document_payment_text: "",
        document_planning_text: "",
        document_remark_text: "",
        document_warranty_text: "",
        document_closing_text: "",
        document_show_agreement_block: false,
        document_agreement_text: "",
        document_texts_initialized: true,
      }));
    }

    function reloadDocumentTextsFromTemplate() {
      if (!selectedOfferTemplate) {
        alert("Kies eerst een sjabloon.");
        return;
      }

      const ok = window.confirm(
        "De huidige aangepaste teksten worden vervangen door de teksten uit het gekozen sjabloon. Doorgaan?"
      );
      if (!ok) return;

      setForm((prev) => ({
        ...prev,
        ...templateTexts(selectedOfferTemplate),
      }));
    }

    function updateDocumentText(field, value) {
      setForm((prev) => ({
        ...prev,
        [field]: value,
        document_texts_initialized: true,
      }));
    }

    function documentVisibilityPayload(source = effectiveDocumentTexts) {
      const s = source || {};
      return {
        document_show_subject: s.document_show_subject !== false,
        document_show_salutation: s.document_show_salutation !== false,
        document_show_intro_text: s.document_show_intro_text !== false,
        document_show_body_text: s.document_show_body_text !== false,
        document_show_conditions_text: s.document_show_conditions_text !== false,
        document_show_payment_text: s.document_show_payment_text !== false,
        document_show_planning_text: s.document_show_planning_text !== false,
        document_show_remark_text: s.document_show_remark_text !== false,
        document_show_warranty_text: s.document_show_warranty_text !== false,
        document_show_closing_text: s.document_show_closing_text !== false,
      };
    }

    function editableRichTextFromElement(element) {
      return normalizeRichTextHtml(element?.innerHTML || "");
    }





    function currentDocumentTextValue(field, fallback = "") {
      const draft = documentTextDraftRef.current?.[field];

      return draft !== undefined
        ? draft
        : fallback;
    }




    // ---------- GEZAMENLIJKE DOCUMENTVOLGORDE ----------
    const documentBlockDefinitions = [
      ["document_salutation", "Aanhef", "document_show_salutation"],
      ["document_intro_text", "Introductietekst", "document_show_intro_text"],
      ["document_body_text", "Hoofdtekst", "document_show_body_text"],
      ["document_conditions_text", "Voorwaarden", "document_show_conditions_text"],
      ["document_payment_text", "Betaling", "document_show_payment_text"],
      ["document_planning_text", "Planning", "document_show_planning_text"],
      ["document_remark_text", "Opmerking", "document_show_remark_text"],
      ["document_warranty_text", "Garantie", "document_show_warranty_text"],
      ["document_closing_text", "Afsluiting", "document_show_closing_text"],
    ];
    const preTotalBlockKeys = new Set(["document_salutation", "document_intro_text", "document_body_text"]);

    function defaultDocumentOrder() {
      const pre = documentBlockDefinitions.filter(([k]) => preTotalBlockKeys.has(k)).map(([key]) => ({ type: "block", key }));
      const lineItems = (lines || []).filter((ln) => ln?.id).map((ln) => ({ type: "line", id: Number(ln.id) }));
      const post = documentBlockDefinitions.filter(([k]) => !preTotalBlockKeys.has(k)).map(([key]) => ({ type: "block", key }));
      return [...pre, ...lineItems, ...post];
    }

    function normalizedDocumentOrder() {
      const saved = Array.isArray(form.document_order) ? form.document_order : [];
      if (!saved.length) return defaultDocumentOrder();
      const blocks = new Set(documentBlockDefinitions.map(([k]) => k));
      const lineIds = new Set((lines || []).filter((ln) => ln?.id).map((ln) => String(ln.id)));
      const seen = new Set();
      const result = [];
      saved.forEach((item) => {
        if (item?.type === "block" && blocks.has(String(item.key || ""))) {
          const t = `b:${item.key}`; if (!seen.has(t)) { seen.add(t); result.push({ type: "block", key: String(item.key), ...(item.page_break_after === true ? { page_break_after: true } : {}) }); }
        } else if (item?.type === "line" && lineIds.has(String(item.id || ""))) {
          const t = `l:${item.id}`; if (!seen.has(t)) { seen.add(t); result.push({ type: "line", id: Number(item.id), ...(item.page_break_after === true ? { page_break_after: true } : {}) }); }
        }
      });
      const missingLines = (lines || []).filter((ln) => ln?.id && !seen.has(`l:${ln.id}`)).map((ln) => ({ type: "line", id: Number(ln.id) }));
      let at = result.findIndex((item) => item.type === "block" && !preTotalBlockKeys.has(String(item.key || "")));
      if (at < 0) at = result.length;
      result.splice(at, 0, ...missingLines);
      documentBlockDefinitions.forEach(([key]) => { if (!seen.has(`b:${key}`)) result.push({ type: "block", key }); });
      return result;
    }

    async function saveDocumentOrder(nextOrder) {
      if (!formHasId()) return;
      const compact = nextOrder.map((item) => ({
        ...(item.type === "line"
          ? { type: "line", id: Number(item.id) }
          : { type: "block", key: String(item.key) }),
        ...(item.page_break_after === true ? { page_break_after: true } : {}),
      }));
      const previous = Array.isArray(form.document_order) ? form.document_order : [];
      setForm((prev) => ({ ...prev, document_order: compact }));
      try {
        const saved = await tryFetchJson([`/api/offers/${encodeURIComponent(form.id)}/document-order`], {
          method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ document_order: compact }),
        });
        // Een oude server accepteert het verzoek maar wist stilzwijgend paginaovergangen.
        // Dan geen misleidende succesmelding tonen en direct de oude toestand herstellen.
        if (compact.some((item) => item.page_break_after === true) &&
          !compact.filter((item) => item.page_break_after === true).every((item) =>
            (saved?.document_order || []).some((row) =>
              (item.type === "line" ? row.type === "line" && String(row.id) === String(item.id)
                : row.type === "block" && row.key === item.key) && row.page_break_after === true
            )
          )) {
          throw new Error("De server ondersteunt paginaovergangen nog niet. Gebruik de bijbehorende nieuwe serverversie.");
        }
        setFlash("Documentindeling opgeslagen ✅"); setTimeout(() => setFlash(""), 900);
      } catch (e) {
        setForm((prev) => ({ ...prev, document_order: previous }));
        setLineError(e?.message || "Documentindeling opslaan mislukt.");
      }
    }

    async function toggleDocumentPageBreak(item) {
      if (!formHasId() || isLocked || isReadonly || popupMode === "preview") return;
      const token = documentItemToken(item);
      const order = normalizedDocumentOrder();
      const next = order.map((row) => documentItemToken(row) === token
        ? { ...row, page_break_after: row.page_break_after !== true }
        : row);
      await saveDocumentOrder(next);
    }

    function hasPageBreakAfter(item) {
      const token = documentItemToken(item);
      return normalizedDocumentOrder().some((row) => documentItemToken(row) === token && row.page_break_after === true);
    }

    function renderPageBreakMarker(item) {
      return (
        <div key={`page-break-${documentItemToken(item)}`}
          className="staffiq-print-page-break"
          aria-label="Nieuwe pagina"
          style={popupMode === "preview"
            ? { display: "block", height: 0, margin: 0, breakAfter: "page", pageBreakAfter: "always" }
            : { borderTop: "1px dashed #8aa4c2", margin: "8px 0", padding: "2px 0", fontSize: 12, color: "#466b92" }}
        >
          {popupMode !== "preview" && <span className="staffiq-print-page-break-label">Nieuwe pagina vanaf hier</span>}
        </div>
      );
    }

    const documentDragRef = useRef(null);

    function documentItemToken(item) {
      return item?.type === "line"
        ? `l:${item.id}`
        : `b:${item?.key || ""}`;
    }

    function autoScrollOfferPopupDuringDrag(e) {
      const scroller = offerPopupScrollRef.current;
      if (!scroller) return;

      const edge = 90;
      const maxStep = 34;
      const y = Number(e?.clientY || 0);
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      if (!viewportHeight) return;

      let delta = 0;

      if (y < edge) {
        const strength = Math.max(0, Math.min(1, (edge - y) / edge));
        delta = -Math.max(8, Math.round(maxStep * strength));
      } else if (y > viewportHeight - edge) {
        const strength = Math.max(0, Math.min(1, (y - (viewportHeight - edge)) / edge));
        delta = Math.max(8, Math.round(maxStep * strength));
      }

      if (delta !== 0) {
        scroller.scrollTop += delta;
      }
    }

    function startDocumentDrag(e, item) {
      if (!item || isLocked || popupMode === "preview") {
        e.preventDefault();
        return;
      }

      documentDragRef.current = item;

      try {
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/plain", documentItemToken(item));
      } catch (_) {}
    }

    function endDocumentDrag() {
      documentDragRef.current = null;
    }

    function allowDocumentDrop(e) {
      if (isLocked || popupMode === "preview") return;

      e.preventDefault();
      autoScrollOfferPopupDuringDrag(e);

      try {
        e.dataTransfer.dropEffect = "move";
      } catch (_) {}
    }

    async function dropDocumentItem(e, targetItem) {
      e.preventDefault();

      const sourceItem = documentDragRef.current;
      documentDragRef.current = null;

      if (!sourceItem || !targetItem || isLocked || popupMode === "preview") return;

      const sourceToken = documentItemToken(sourceItem);
      const targetToken = documentItemToken(targetItem);

      if (!sourceToken || sourceToken === targetToken) return;

      const order = normalizedDocumentOrder();
      const sourceIdx = order.findIndex((x) => documentItemToken(x) === sourceToken);
      const originalTargetIdx = order.findIndex((x) => documentItemToken(x) === targetToken);

      if (sourceIdx < 0 || originalTargetIdx < 0) return;

      // Bepaal of de muis in de bovenste of onderste helft van het doel staat.
      // Daardoor voelt neerzetten natuurlijk aan en werkt ook één positie omlaag.
      let placeAfterTarget = false;

      try {
        const targetElement = e.currentTarget;
        const rect = targetElement?.getBoundingClientRect?.();

        if (rect && Number.isFinite(rect.top) && Number.isFinite(rect.height)) {
          placeAfterTarget = e.clientY > rect.top + rect.height / 2;
        }
      } catch (_) {}

      const next = order.slice();
      const [moved] = next.splice(sourceIdx, 1);

      const targetIdxAfterRemoval = next.findIndex(
        (x) => documentItemToken(x) === targetToken
      );

      if (targetIdxAfterRemoval < 0) return;

      const insertAt = targetIdxAfterRemoval + (placeAfterTarget ? 1 : 0);
      next.splice(insertAt, 0, moved);

      await saveDocumentOrder(next);
    }

    async function moveDocumentItem(item, direction) {
      if (!item || isLocked || popupMode === "preview") return;
      const order = normalizedDocumentOrder();
      const token = item.type === "line" ? `l:${item.id}` : `b:${item.key}`;
      const idx = order.findIndex((x) => (x.type === "line" ? `l:${x.id}` : `b:${x.key}`) === token);
      const nextIdx = idx + Number(direction || 0);
      if (idx < 0 || nextIdx < 0 || nextIdx >= order.length) return;
      const next = order.slice(); const [moved] = next.splice(idx, 1); next.splice(nextIdx, 0, moved);
      await saveDocumentOrder(next);
    }

    function documentMoveButtons(item) {
      if (popupMode === "preview") return null;
      const order = normalizedDocumentOrder();
      const token = item.type === "line" ? `l:${item.id}` : `b:${item.key}`;
      const idx = order.findIndex((x) => (x.type === "line" ? `l:${x.id}` : `b:${x.key}`) === token);
      const canMove = !isLocked && idx >= 0;
      const st = { border: "none", background: "transparent", padding: "0 2px", fontSize: 14, lineHeight: 1 };
      return <>
        <button type="button" onClick={(e) => { e.stopPropagation(); moveDocumentItem(item, -1); }} disabled={!canMove || idx <= 0} title="Onderdeel omhoog" style={{ ...st, opacity: canMove && idx > 0 ? .8 : .25, cursor: canMove && idx > 0 ? "pointer" : "not-allowed" }}>↑</button>
        <button type="button" onClick={(e) => { e.stopPropagation(); moveDocumentItem(item, 1); }} disabled={!canMove || idx >= order.length - 1} title="Onderdeel omlaag" style={{ ...st, opacity: canMove && idx < order.length - 1 ? .8 : .25, cursor: canMove && idx < order.length - 1 ? "pointer" : "not-allowed" }}>↓</button>
        <button type="button" onClick={(e) => { e.stopPropagation(); toggleDocumentPageBreak(item); }}
          disabled={!canMove} aria-pressed={hasPageBreakAfter(item)}
          title={hasPageBreakAfter(item) ? "Paginaovergang na dit blok verwijderen" : "Nieuwe pagina na dit blok (ook Ctrl+Enter in de tekst)"}
          style={{ ...st, color: hasPageBreakAfter(item) ? "#0b64bd" : "#555", background: hasPageBreakAfter(item) ? "#e2f0ff" : "transparent", fontWeight: 700, cursor: canMove ? "pointer" : "not-allowed" }}>📄</button>
      </>;
    }

    function documentEditorHeight(label) {
      const key = String(label || "").toLowerCase();

      if (key.includes("hoofdtekst")) return 180;
      if (key.includes("voorwaarden")) return 150;
      if (key.includes("introductie")) return 120;
      if (key.includes("aanhef")) return 70;

      return 100;
    }

    function renderEditableDocumentText(field, value, label, extraStyle = {}) {
      const html = normalizeRichTextHtml(value);
      // vOFF-137: ook tijdens Bewerken een ingevulde aanhef tonen.
      // De onderliggende tekst blijft {aanhef}, zodat wisselen van relatie werkt.
      const hasSalutationToken = field === "document_salutation" && /\{\{?\s*aanhef\s*\}\}?/i.test(html);
      const displayHtml = hasSalutationToken ? fillOfferTokens(html) : html;

      if (popupMode === "preview") {
        return renderTemplateBlock(html, extraStyle);
      }

      return (
        <div
          onDragOver={allowDocumentDrop}
          onDrop={(e) => dropDocumentItem(e, { type: "block", key: field })}
          style={{
            marginTop: 10,
            marginBottom: 14,
            width: "100%",
            ...extraStyle,
          }}
        >
          <div
            className="offer-edit-label"
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "#333",
              marginBottom: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 8,
            }}
          >
            <span>{label}</span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
              <span
                draggable={!isLocked}
                onDragStart={(e) => {
                  e.stopPropagation();
                  startDocumentDrag(e, { type: "block", key: field });
                }}
                onDragEnd={endDocumentDrag}
                title="Sleep om dit onderdeel te verplaatsen"
                style={{
                  border: "none",
                  background: "transparent",
                  padding: "0 2px",
                  fontSize: 14,
                  lineHeight: 1,
                  cursor: !isLocked ? "grab" : "default",
                  opacity: !isLocked ? 0.8 : 0.25,
                  userSelect: "none",
                }}
              >
                ↕
              </span>
              {documentMoveButtons({ type: "block", key: field })}
            </span>
          </div>

          <RichTextEditor
            value={displayHtml}
            onPageBreakShortcut={() => toggleDocumentPageBreak({ type: "block", key: field })}
            minHeight={documentEditorHeight(label)}
            placeholder={label}
            toolbarVisible={activeDocumentEditorKey === field}
            onActivate={() => setActiveDocumentEditorKey(field)}
            onChange={(nextValue) => {
              let saveValue = nextValue;
              if (hasSalutationToken) {
                // Als de getoonde aanhef wordt opgemaakt of opnieuw opgeslagen,
                // moet de ingevulde naam weer terug naar de dynamische invulcode.
                // Eigen afwijkende tekst blijft onveranderd bewaard.
                const displayedSalutation = escapeRichTextHtml(getCurrentRelationSalutation());
                if (displayedSalutation) {
                  saveValue = String(saveValue || "").split(displayedSalutation).join("{aanhef}");
                }
              }
              documentTextDraftRef.current[field] = saveValue;
              updateDocumentText(field, saveValue);
            }}
          />
        </div>
      );
    }

    function renderEditableSubject() {
      const fallback = normalizeDbStatus(form.status || "OFFERTE") === "OFFERTE"
        ? "prijsopgave"
        : "bevestiging opdracht";
      const subject = effectiveDocumentTexts.document_subject || "";
      if (effectiveDocumentTexts.document_show_subject === false) return null;

      // vOFF-138: onderwerp bevat optionele rich-text-opmaak uit het sjabloon.
      // In de PDF/Voorbeeld wordt die opmaak echt gerenderd, niet als HTML-tekst getoond.
      if (popupMode === "preview") {
        return (
          <div className="staffiq-offer-fixed-text" style={{ display: "grid", gridTemplateColumns: "70px 1fr", gap: 6,
            fontFamily: "Calibri, Carlito, Arial, sans-serif", fontSize: "11pt", marginBottom: 6 }}>
            <span>Betreft:</span>
            <div className="staffiq-rich-text-surface" style={{ minWidth: 0, lineHeight: 1.15 }}
              dangerouslySetInnerHTML={{ __html: normalizeRichTextHtml(subject || fallback) }} />
          </div>
        );
      }

      return (
        <div className="staffiq-offer-fixed-text" style={{ marginBottom: 8, fontFamily: "Calibri, Carlito, Arial, sans-serif",
          fontSize: "11pt" }}>
          <div style={{ marginBottom: 4 }}>Betreft:</div>
          <RichTextEditor
            value={subject || fallback}
            minHeight={50}
            placeholder="Betreft / onderwerp"
            toolbarVisible={activeDocumentEditorKey === "document_subject"}
            onActivate={() => setActiveDocumentEditorKey("document_subject")}
            onChange={(nextValue) => {
              documentTextDraftRef.current.document_subject = nextValue;
              updateDocumentText("document_subject", nextValue);
            }}
          />
        </div>
      );
    }

    // vOFF-135: hetzelfde ingevulde aanhefresultaat voor Voorbeeld en afdruk-PDF.
    function getCurrentRelationSalutation() {
      const raw = [
        activeOrg?.salutation, orgDetail?.salutation,
        activeOrg?.aanhef, orgDetail?.aanhef,
        activeOrg?.aanschrijving, orgDetail?.aanschrijving,
        selectedContact?.aanschrijving, selectedContact?.aanhef, selectedContact?.salutation,
      ].map(safeTrim).find((text) => text && !/^\{\{?\s*aanhef\s*\}\}?$/i.test(text));
      if (raw) return raw;

      // Geen losse naam of geslacht raden bij zakelijke relaties.
      // Bij Particulieren of een geselecteerde contactpersoon is een echte voornaam bekend.
      const firstName = safeTrim(
        selectedContact?.first_name || selectedContact?.voornaam ||
        (selectedRelationIsPrivate ? (activeOrg?.first_name || orgDetail?.first_name) : "")
      );
      return firstName ? `Beste ${firstName},` : "Geachte heer/mevrouw,";
    }

    function fillOfferTokens(raw) {
      return String(raw || "").replace(/\{\{?\s*aanhef\s*\}\}?([\s]*(?:,|&#44;))?/gi, (_match, trailingComma) => {
        const salutation = getCurrentRelationSalutation().trim();
        const hasComma = /,$/.test(salutation);
        return escapeRichTextHtml(hasComma ? salutation : `${salutation},`);
      });
    }

    function renderTemplateBlock(text, extraStyle = {}) {
      // Tekst blijft als sjabloon opgeslagen; hier alleen de WEERGAVE vervangen.
      const salutationTemplate = !richTextPlainText(text) && text === effectiveDocumentTexts.document_salutation
        ? "{aanhef}" : text;
      const value = fillOfferTokens(normalizeRichTextHtml(salutationTemplate));
      if (!richTextPlainText(value)) return null;

      return (
        <>
        <style>{STAFFIQ_RICH_TEXT_TOP_CSS}</style>
        <div
          className="staffiq-rich-text-surface staffiq-offer-project-text"
          style={{
            marginTop: 0,
            marginBottom: "12pt",
            fontFamily: "Calibri, Carlito, Arial, sans-serif",
            fontSize: "11pt",
            lineHeight: 1.15,
            whiteSpace: "normal",
            width: "100%",
            maxWidth: "100%",
            ...extraStyle,
          }}
          dangerouslySetInnerHTML={{ __html: value }}
        />
        </>
      );
    }

    const orgVatNumber = pickOrgVatNumber(activeOrg);
    const gPercentage = pickOrgGrekeningPercent(activeOrg);

const linesForTotals = useMemo(() => {
  const arr = Array.isArray(lines) ? [...lines] : [];

  const draftLineType = normalizeOfferLineType(lineDraft.line_type || "Artikel");
  const draftQty = numberFromAny(lineDraft.quantity, 0);
  const draftDesc = String(lineDraft.description || "");
  const draftUnit = netPriceFromDisplayedPrice(lineDraft.unit_price, lineDraft.vat_rate || "hoog", generalSettings.offer_prices_include_vat === true);

  if (!draftDesc.trim()) {
    return arr;
  }

  if (draftLineType === "Artikel" && !(draftQty > 0 && Number.isFinite(draftUnit) && draftUnit !== 0)) {
    return arr;
  }

  const draftLine = {
    line_type: draftLineType,
    quantity: draftLineType === "Artikel" ? draftQty : 0,
    qty: draftLineType === "Artikel" ? draftQty : 0,
    description: draftDesc,
    unit: draftLineType === "Artikel" ? String(lineDraft.unit || "").trim() : "",
    unit_price: draftLineType === "Artikel" ? draftUnit : 0,
    price: draftLineType === "Artikel" ? draftUnit : 0,
    vat_rate: lineDraft.vat_rate || "hoog",
    vat: lineDraft.vat_rate || "hoog",
  };

  if (editingLineId) {
    return arr.map((ln) =>
      String(ln.id) === String(editingLineId) ? { ...ln, ...draftLine } : ln
    );
  }

  return [...arr, draftLine];
}, [lines, lineDraft, editingLineId, generalSettings.offer_prices_include_vat]);

    const invoiceTotals = useMemo(
      () => calcOfferTotals(linesForTotals),
      [linesForTotals]
    );

    const offerteTotaalBedrag = Number(invoiceTotals.total || 0);

    const gAmount = useMemo(() => {
      return invoiceTotals.total * (gPercentage / 100);
    }, [invoiceTotals.total, gPercentage]);

    const ibanAmount = useMemo(() => {
      return invoiceTotals.total - gAmount;
    }, [invoiceTotals.total, gAmount]);

    const isCreditInvoice = invoiceTotals.total < 0;
    const effectiveGPercentage = isCreditInvoice ? 0 : gPercentage;

    const recipientName =
      activeOrg?.name ||
      activeOrg?.organisation_name ||
      activeOrg?.bedrijfsnaam ||
      "";

    const selectedContact = useMemo(() => {
      const cid = String(form.contact_id || "");
      if (!cid) return null;
      return contacts.find((c) => String(c.id || "") === cid) || null;
    }, [contacts, form.contact_id]);

    const contactAanschrijving =
      safeTrim(
        selectedContact?.aanschrijving ||
        selectedContact?.aanhef ||
        selectedContact?.salutation ||
        ""
      );

    // Mobiel heeft voorkeur; als dat bij Relaties ontbreekt, gebruik Telefoon.
    const recipientPhone = safeTrim(
      activeOrg?.mobile || activeOrg?.mobile_phone || activeOrg?.phone ||
      selectedInvoiceRow?.org_mobile || selectedInvoiceRow?.org_phone || ""
    );
    const recipientEmail = safeTrim(
      activeOrg?.email || selectedInvoiceRow?.org_email || ""
    );

    const recipientAddressLines = useMemo(() => {
      if (!activeOrg) return [];

      const line1 = safeTrim(
        [
          activeOrg.corr_street,
          activeOrg.corr_house_number,
          activeOrg.corr_addition,
        ]
          .filter(Boolean)
          .join(" ")
      );

      const pcCity = [
        safeTrim(activeOrg.corr_postcode),
        safeTrim(activeOrg.corr_city),
      ]
        .filter(Boolean)
        .join(" ");

      const country = safeTrim(activeOrg.corr_country);

      return [line1, pcCity, country].filter(Boolean);
    }, [activeOrg]);

    useEffect(() => {
      const defaultVat = pickOrgDefaultVatRate(activeOrg);
      setLineDraft((prev) => ({ ...prev, vat_rate: defaultVat }));
    }, [form.organisation_id, activeOrg?.id]);


    function offerLineGridTemplate() {
      if (popupMode === "preview") {
        return invoiceTotals.hideVatColumnOnInvoice
          ? "48px 86px minmax(0, 1fr) 100px 100px"
          : "48px 86px minmax(0, 1fr) 100px 100px 65px";
      }

      // vOFF-140: de vijf actie-icoontjes passen niet in 56px.
      // Alleen de bewerkweergave krijgt extra ruimte; Preview/PDF blijven identiek.
      return invoiceTotals.hideVatColumnOnInvoice
        ? "48px 86px minmax(0, 1fr) 100px 100px 116px"
        : "48px 86px minmax(0, 1fr) 100px 100px 65px 116px";
    }

    function offerLineDraftIsAmount() {
      return normalizeOfferLineType(lineDraft.line_type || "Artikel") === "Artikel";
    }

    function renderLineTypeSelect() {
      return (
        <select
          value={editableOfferLineType(lineDraft.line_type || "Artikel")}
          onChange={(e) => {
            const nextType = normalizeOfferLineType(e.target.value);

            setLineDraft((prev) => ({
              ...prev,
              line_type: nextType,
              quantity: nextType === "Artikel" ? (prev.quantity || 1) : 0,
              unit_price: nextType === "Artikel" ? prev.unit_price : "",
            }));
          }}
          disabled={!form.id || isLocked}
          style={{
            ...selectStyle,
            width: 130,
            marginBottom: 6,
            padding: "6px 6px",
            fontWeight: 700,
          }}
        >
          {OFFER_LINE_TYPES.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      );
    }

    function offerLineDragProps(ln, isEditingLine = false) {
      if (!ln?.id || popupMode === "preview") return {};

      // vOFF-115: de regel zelf is het drop-doel. Slepen start uitsluitend
      // via het ↕-handvat in renderOfferActions(). Hierdoor blijven klikken
      // en tekstbewerking op de regel zelf normaal werken.
      return {
        onDragOver: allowDocumentDrop,
        onDrop: (e) => dropDocumentItem(e, { type: "line", id: ln.id }),
      };
    }

    function renderOfferHeader(key = "offer-line-header", marginTop = 8) {
      return (
        <div
          key={key}
          style={{
            display: "grid",
            gridTemplateColumns: offerLineGridTemplate(),
            gap: 12,
            borderBottom: "2px solid #444",
            paddingBottom: 8,
            fontWeight: 700,
            fontSize: 14,
            marginTop,
          }}
        >
          <div style={{ textAlign: "right", paddingRight: 0 }}>Aantal</div>
          <div>Eenheid</div>
          <div>Omschrijving</div>
          <div></div> {/* Geen koptekst boven de eenheidsprijs; prijsbedragen blijven zichtbaar. */}
          <div style={{ textAlign: "right" }}>Totaal</div>
          {!invoiceTotals.hideVatColumnOnInvoice && (
            <div style={{ textAlign: "right" }}>Btw</div>
          )}
          {popupMode !== "preview" && <div></div>}
        </div>
      );
    }

    function renderOfferActions(ln) {
      if (popupMode === "preview") return null;

      const lineId = String(ln?.id || "");
      const idx = lines.findIndex((x) => String(x.id || "") === lineId);
      const canMove = !!lineId && !isLocked && idx >= 0;

      const iconButtonStyle = {
        border: "none",
        background: "transparent",
        cursor: "pointer",
        fontSize: 14,
        opacity: 0.75,
        padding: 0,
        margin: 0,
        lineHeight: 1,
      };

      return (
        <div
          data-offer-actions="1"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 5,
            flexWrap: "nowrap",
            minHeight: 24,
          }}
        >
          <span
            draggable={canMove}
            onDragStart={(e) => startDocumentDrag(e, { type: "line", id: ln.id })}
            onDragEnd={endDocumentDrag}
            title="Sleep om dit onderdeel te verplaatsen"
            style={{
              ...iconButtonStyle,
              cursor: canMove ? "grab" : "default",
              opacity: canMove ? 0.75 : 0.25,
              userSelect: "none",
            }}
          >
            ↕
          </span>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              moveDocumentItem({ type: "line", id: ln.id }, -1);
            }}
            disabled={!canMove}
            title="Onderdeel omhoog"
            style={{
              ...iconButtonStyle,
              opacity: canMove ? 0.75 : 0.25,
              cursor: canMove ? "pointer" : "not-allowed",
            }}
          >
            ↑
          </button>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              moveDocumentItem({ type: "line", id: ln.id }, 1);
            }}
            disabled={!canMove}
            title="Onderdeel omlaag"
            style={{
              ...iconButtonStyle,
              opacity: canMove ? 0.75 : 0.25,
              cursor: canMove ? "pointer" : "not-allowed",
            }}
          >
            ↓
          </button>

          <button type="button"
            onClick={(e) => { e.stopPropagation(); toggleDocumentPageBreak({ type: "line", id: ln.id }); }}
            title={hasPageBreakAfter({ type: "line", id: ln.id }) ? "Paginaovergang na deze regel verwijderen" : "Nieuwe pagina na deze regel"}
            aria-pressed={hasPageBreakAfter({ type: "line", id: ln.id })}
            style={{ ...iconButtonStyle, background: hasPageBreakAfter({ type: "line", id: ln.id }) ? "#e2f0ff" : "transparent" }}
          >📄</button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              startEditInvoiceLine(ln, "unit");
            }}
            title="Bewerken"
            style={iconButtonStyle}
          >
            ✏️
          </button>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              deleteInvoiceLine(ln.id);
            }}
            title="Verwijderen"
            style={iconButtonStyle}
          >
            🗑️
          </button>
        </div>
      );
    }

    function renderOfferLine(ln, idx, followsTextLine = false) {
      const type = lineTypeOf(ln);
      const isArticle = type === "Artikel";
      const isSubtotalLike = type === "Subtotaal" || type === "Totaal";
      const isHeader = type === "Kop";
      const qty = lineQty(ln);
      const unit = lineUnitPrice(ln);
      const rate = lineVatRate(ln);
      const displayedUnit = displayedPriceFromNetPrice(unit, rate, generalSettings.offer_prices_include_vat === true);
      const lineTotal = qty * displayedUnit;
      const isEditingLine = String(editingLineId || "") === String(ln.id || "");
      const canEditLine = popupMode !== "preview" && !isLocked;

      if (isEditingLine) {
        const draftIsArticle = offerLineDraftIsAmount();

        return (
          <div
            key={ln.id}
            onDragOver={allowDocumentDrop}
            onDrop={(e) => dropDocumentItem(e, { type: "line", id: ln.id })}
            style={{
              display: "grid",
              gridTemplateColumns: offerLineGridTemplate(),
              gap: 12,
              padding: "8px 0",
              borderBottom: "1px solid #ddd",
              fontSize: 14,
              lineHeight: 1.45,
              alignItems: "start",
              background: "#f5f9ff",
            }}
          >
            {draftIsArticle ? (
              <input
                ref={qtyInputRef}
                value={lineDraft.quantity}
                onChange={(e) =>
                  setLineDraft({ ...lineDraft, quantity: e.target.value })
                }
                onFocus={(e) => e.target.select()}
                onClick={(e) => e.target.select()}
                placeholder="1"
                style={{
                  ...inputStyle,
                  textAlign: "right",
                  padding: "8px 8px 8px 12px",
                }}
              />
            ) : (
              <div></div>
            )}

            {draftIsArticle ? (
              <input
                ref={unitInputRef}
                type="text"
                aria-label="Eenheid"
                title="Eenheid invullen of aanpassen (bijvoorbeeld m², st, uur)"
                value={lineDraft.unit ?? ""}
                maxLength={30}
                disabled={isLocked || popupMode === "preview"}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => setLineDraft((prev) => ({ ...prev, unit: e.target.value }))}
                placeholder="m² / st"
                style={{ ...inputStyle, background: "#fff", color: "#111", border: "1px solid #2f7dd1", padding: "8px 5px" }}
              />
            ) : <div />}

            <div>
              {renderLineTypeSelect()}

              <RichTextEditor
                externalEditorRef={lineDescRef}
                value={lineDraft.description}
                onPageBreakShortcut={() => toggleDocumentPageBreak({ type: "line", id: ln.id })}
                onChange={(value) =>
                  setLineDraft((prev) => ({ ...prev, description: value }))
                }
                disabled={isFormDisabled}
                minHeight={64}
                toolbarVisible={true}
                placeholder="Omschrijving"
              />
            </div>

            {draftIsArticle ? (
              <div>
                <input
                  ref={linePriceRef}
                  value={lineDraft.unit_price}
                  onChange={(e) => setLineDraft({ ...lineDraft, unit_price: e.target.value })}
                  onBlur={handleUnitPriceCommit}
                  onFocus={(e) => e.target.select()}
                  onClick={(e) => e.target.select()}
                  placeholder={generalSettings.offer_prices_include_vat === true ? "incl. btw" : "excl. btw"}
                  style={{ ...inputStyle, textAlign: "right", padding: "8px" }}
                />
                <label style={{ display: "block", fontSize: 11, color: "#555", marginTop: 4 }}>
                  Btw-tarief
                  <select
                    ref={lineVatRef}
                    value={lineDraft.vat_rate}
                    onChange={(e) => setLineDraft((prev) => ({ ...prev, vat_rate: e.target.value }))}
                    disabled={!form.id || isLocked}
                    style={{ ...selectStyle, padding: "5px 3px", width: "100%", marginTop: 2 }}
                  >
                    <option value="hoog">21%</option>
                    <option value="laag">9%</option>
                    <option value="0">0%</option>
                    <option value="verlegd">verlegd</option>
                  </select>
                </label>
              </div>
            ) : <div></div>}

            <div style={{ textAlign: "right", fontWeight: draftIsArticle ? 400 : 700 }}>
              {draftIsArticle
                ? euro(numberFromAny(lineDraft.quantity, 0) * numberFromAny(lineDraft.unit_price, 0))
                : ""}
            </div>

            {!invoiceTotals.hideVatColumnOnInvoice && (
              draftIsArticle ? (
                <div style={{ textAlign: "right" }}>
                  <select
                    ref={lineVatRef}
                    value={lineDraft.vat_rate}
                    onChange={(e) =>
                      setLineDraft({ ...lineDraft, vat_rate: e.target.value })
                    }
                    disabled={!form.id || isLocked}
                    style={{
                      ...selectStyle,
                      padding: "6px 6px",
                      width: 70,
                      display: "inline-block",
                    }}
                  >
                    <option value="hoog">21%</option>
                    <option value="laag">9%</option>
                    <option value="0">0%</option>
                    <option value="verlegd">verlegd</option>
                  </select>
                </div>
              ) : (
                <div></div>
              )
            )}

            <div
              data-offer-actions="1"
              style={{
                display: popupMode === "preview" ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 6,
                flexWrap: "wrap",
              }}
            >
              <button
                type="button"
                onClick={addInvoiceLine}
                title="Opslaan"
                style={{
                  border: "1px solid #cfd8e3",
                  background: "#2f7dd1",
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: 12,
                  borderRadius: 6,
                  padding: "4px 8px",
                }}
              >
                Opslaan
              </button>

              <button
                type="button"
                onClick={cancelEditInvoiceLine}
                title="Annuleren"
                style={{
                  border: "1px solid #cfd8e3",
                  background: "#f4f4f4",
                  color: "#333",
                  cursor: "pointer",
                  fontSize: 12,
                  borderRadius: 6,
                  padding: "4px 8px",
                }}
              >
                Annuleren
              </button>
            </div>
          </div>
        );
      }

      if (!isArticle) {
        const descriptionColumn = popupMode === "preview" ? "1 / -1" : "1 / -2";
        const subtotalDescriptionColumn = "1 / 4";
        const subtotalTotalsColumn = invoiceTotals.hideVatColumnOnInvoice ? "4 / 6" : "4 / 7";
        const runningTotals = isSubtotalLike ? calcOfferTotalsUntilLine(lines, idx) : null;
        const description = lineDescription(ln);
        const fixedTextStyle = fixedOfferTextStyle(description);

        return (
          <div
            key={ln.id}
            className={isSubtotalLike ? undefined : "staffiq-offer-project-row"}
            {...offerLineDragProps(ln, isEditingLine)}
            onClick={() => {
              if (canEditLine) startEditInvoiceLine(ln);
            }}
            title={canEditLine ? "Klik om deze regel te bewerken of sleep om de volgorde te wijzigen" : ""}
            style={{
              display: "grid",
              gridTemplateColumns: offerLineGridTemplate(),
              gap: 12,
              padding: isSubtotalLike ? "10px 0" : "1px 0",
               marginTop: !isSubtotalLike && followsTextLine ? "12pt" : 0,
              // Tekst en Kop uit Projectbeheer zijn doorlopende blokken zonder scheidingslijn.
              borderBottom: isSubtotalLike ? "1px solid #999" : "none",
              borderTop: String(dragOverOfferLineId || "") === String(ln.id || "") ? "3px solid #2f7dd1" : (isSubtotalLike ? "1px solid #ddd" : "none"),
              fontSize: 14,
              lineHeight: isSubtotalLike ? 1.45 : 1.15,
              alignItems: isSubtotalLike ? "start" : "center",
              cursor: canEditLine ? "pointer" : "default",
              background: String(draggingOfferLineId || "") === String(ln.id || "") ? "#eef6ff" : (isSubtotalLike ? "#fafafa" : "transparent"),
            }}
          >
            {isSubtotalLike ? (
              <>
                <div
                  style={{
                    gridColumn: subtotalDescriptionColumn,
                    whiteSpace: "pre-wrap",
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                    fontWeight: 700,
                    ...fixedTextStyle,
                  }}
                >
                  {description && isRichTextHtml(description) ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: normalizeRichTextHtml(description),
                      }}
                    />
                  ) : (
                    description || type
                  )}
                </div>

                <div
                  style={{
                    gridColumn: subtotalTotalsColumn,
                    display: "grid",
                    gridTemplateColumns: "minmax(95px, 1fr) 110px",
                    columnGap: 12,
                    rowGap: 3,
                    textAlign: "right",
                    whiteSpace: "nowrap",
                    fontSize: 14,
                  }}
                >
                  <div>Subtotaal excl. btw</div>
                  <div>{euro(runningTotals?.subtotal || 0)}</div>

                  {(runningTotals?.vatRows || []).map((row) => (
                    <React.Fragment key={`${ln.id || idx}-${row.rate}`}>
                      <div>{row.label}</div>
                      <div>{euro(row.vat)}</div>
                    </React.Fragment>
                  ))}

                  <div
                    style={{
                      borderTop: "2px solid #222",
                      paddingTop: 5,
                      fontWeight: 700,
                    }}
                  >
                    Totaal incl. btw
                  </div>
                  <div
                    style={{
                      borderTop: "2px solid #222",
                      paddingTop: 5,
                      fontWeight: 700,
                    }}
                  >
                    {euro(runningTotals?.total || 0)}
                  </div>
                </div>

                {renderOfferActions(ln)}
              </>
            ) : (
              <>
                <div
                  className="staffiq-offer-line-description"
                  style={{
                    gridColumn: descriptionColumn,
                    whiteSpace: "pre-wrap",
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                    fontWeight: isHeader ? 700 : 400,
                    ...fixedTextStyle,
                  }}
                >
                  {isRichTextHtml(description) ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: normalizeRichTextHtml(description),
                      }}
                    />
                  ) : (
                    description
                  )}
                </div>

                {renderOfferActions(ln)}
              </>
            )}
          </div>
        );
      }

      return (
        <div
          key={ln.id}
          {...offerLineDragProps(ln, isEditingLine)}
          style={{
            display: "grid",
            gridTemplateColumns: offerLineGridTemplate(),
            gap: 12,
            // Offerte-artikelen direct onder elkaar; alleen bij slepen een positielijn.
            padding: "2px 0",
            borderBottom: "none",
            borderTop: String(dragOverOfferLineId || "") === String(ln.id || "") ? "3px solid #2f7dd1" : "none",
            fontSize: 14,
            lineHeight: 1.15,
            alignItems: "start",
            cursor: canEditLine ? "pointer" : "default",
            background: String(draggingOfferLineId || "") === String(ln.id || "") ? "#eef6ff" : "transparent",
          }}
        >
          <div
            onClick={() => {
              if (canEditLine) startEditInvoiceLine(ln);
            }}
            title={canEditLine ? "Klik om deze regel te bewerken" : ""}
            style={{ textAlign: "right", cursor: canEditLine ? "pointer" : "default" }}
          >
            {qty}
          </div>

          <div
            onClick={() => { if (canEditLine) startEditInvoiceLine(ln, "unit"); }}
            title={canEditLine ? "Klik hier om Eenheid te wijzigen" : ""}
            style={{ overflowWrap: "anywhere", fontSize: 13, minHeight: 20, cursor: canEditLine ? "text" : "default" }}
          >
            {lineUnitLabel(ln)}
          </div>

          <div
            onClick={() => {
              if (canEditLine) startEditInvoiceLine(ln);
            }}
            title={canEditLine ? "Klik om deze regel te bewerken" : ""}
            style={{
              whiteSpace: "pre-wrap",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
              width: "100%",
              cursor: canEditLine ? "text" : "default",
            }}
          >
            {isRichTextHtml(lineDescription(ln)) ? (
              <div
                className="staffiq-rich-text-surface staffiq-offer-line-description"
                dangerouslySetInnerHTML={{
                  __html: normalizeRichTextHtml(lineDescription(ln)),
                }}
              />
            ) : (
              lineDescription(ln)
            )}
          </div>

          <div
            onClick={() => {
              if (canEditLine) startEditInvoiceLine(ln);
            }}
            style={{ textAlign: "right", cursor: canEditLine ? "pointer" : "default" }}
          >
            {euro(displayedUnit)}
          </div>

          <div style={{ textAlign: "right" }}>
            {euro(lineTotal)}
          </div>

          {!invoiceTotals.hideVatColumnOnInvoice && (
            <div
              onClick={() => {
                if (canEditLine) startEditInvoiceLine(ln);
              }}
              style={{ textAlign: "right", cursor: canEditLine ? "pointer" : "default" }}
            >
              {vatLabelForRate(rate).replace(" btw", "")}
            </div>
          )}

          {renderOfferActions(ln)}
        </div>
      );
    }

    function renderProjectActionButtons(position = "bottom", disabled = false) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: position === "bottom" ? 12 : 0,
            marginLeft: "auto",
          }}
        >
          <button
            type="button"
            onClick={addSelectedProjectLines}
            disabled={disabled}
            style={{
              ...buttonPrimary("#2f7dd1"),
              opacity: disabled ? 0.5 : 1,
              cursor: disabled ? "not-allowed" : "pointer",
              padding: "7px 14px",
            }}
          >
            Toevoegen
          </button>

          <button
            type="button"
            onClick={resetNewLineSelection}
            style={{
              ...buttonStyle,
              padding: "7px 14px",
            }}
          >
            Annuleren
          </button>
        </div>
      );
    }

    function renderManualLineEntry() {
      const draftIsArticle = offerLineDraftIsAmount();

      return (
        <div style={{ marginTop: 12 }}>
          {draftIsArticle && renderOfferHeader("new-offer-line-header")}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: offerLineGridTemplate(),
              gap: 12,
              alignItems: "start",
              marginTop: draftIsArticle ? 8 : 0,
            }}
          >
            {draftIsArticle ? (
              <input
                ref={qtyInputRef}
                value={lineDraft.quantity}
                onChange={(e) => setLineDraft({ ...lineDraft, quantity: e.target.value })}
                onFocus={(e) => e.target.select()}
                onClick={(e) => e.target.select()}
                placeholder="1"
                style={{ ...inputStyle, textAlign: "right", padding: "8px 8px 8px 12px" }}
              />
            ) : <div />}

            {draftIsArticle ? (
              <input
                ref={unitInputRef}
                type="text"
                aria-label="Eenheid"
                title="Eenheid invullen of aanpassen (bijvoorbeeld m², st, uur)"
                value={lineDraft.unit ?? ""}
                maxLength={30}
                disabled={isLocked || popupMode === "preview"}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => setLineDraft((prev) => ({ ...prev, unit: e.target.value }))}
                placeholder="m² / st"
                style={{ ...inputStyle, background: "#fff", color: "#111", border: "1px solid #2f7dd1", padding: "8px 5px" }}
              />
            ) : <div />}

            <div>
              {renderLineTypeSelect()}
              <RichTextEditor
                externalEditorRef={lineDescRef}
                value={lineDraft.description}
                onChange={(value) =>
                  setLineDraft((prev) => ({ ...prev, description: value }))
                }
                disabled={isFormDisabled}
                minHeight={64}
                toolbarVisible={true}
                placeholder="Omschrijving"
              />
            </div>

            {draftIsArticle ? (
              <div>
                <input
                  ref={linePriceRef}
                  value={lineDraft.unit_price}
                  onChange={(e) => setLineDraft({ ...lineDraft, unit_price: e.target.value })}
                  onBlur={handleUnitPriceCommit}
                  onFocus={(e) => e.target.select()}
                  onClick={(e) => e.target.select()}
                  placeholder={generalSettings.offer_prices_include_vat === true ? "incl. btw" : "excl. btw"}
                  style={{ ...inputStyle, textAlign: "right", padding: "8px" }}
                />
                <label style={{ display: "block", fontSize: 11, color: "#555", marginTop: 4 }}>
                  Btw-tarief
                  <select
                    ref={lineVatRef}
                    value={lineDraft.vat_rate}
                    onChange={(e) => setLineDraft((prev) => ({ ...prev, vat_rate: e.target.value }))}
                    disabled={!form.id || isLocked}
                    style={{ ...selectStyle, padding: "5px 3px", width: "100%", marginTop: 2 }}
                  >
                    <option value="hoog">21%</option>
                    <option value="laag">9%</option>
                    <option value="0">0%</option>
                    <option value="verlegd">verlegd</option>
                  </select>
                </label>
              </div>
            ) : <div />}

            <div style={{ textAlign: "right", fontSize: 14, fontWeight: 600, paddingTop: 10 }}>
              {draftIsArticle
                ? euro(numberFromAny(lineDraft.quantity, 0) * numberFromAny(lineDraft.unit_price, 0))
                : ""}
            </div>

            {!invoiceTotals.hideVatColumnOnInvoice && (
              draftIsArticle ? (
                <div style={{ textAlign: "right" }}>
                  <select
                    ref={lineVatRef}
                    value={lineDraft.vat_rate}
                    onChange={(e) => setLineDraft({ ...lineDraft, vat_rate: e.target.value })}
                    disabled={!form.id || isLocked}
                    style={{ ...selectStyle, padding: "6px", width: 70, display: "inline-block" }}
                  >
                    <option value="hoog">21%</option>
                    <option value="laag">9%</option>
                    <option value="0">0%</option>
                    <option value="verlegd">verlegd</option>
                  </select>
                </div>
              ) : <div />
            )}

            <div
              style={{
                display: "flex",
                gap: 5,
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "nowrap",
                minHeight: 24,
              }}
            >
              <button
                type="button"
                title="Toevoegen"
                aria-label="Toevoegen"
                onClick={addInvoiceLine}
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: 1,
                  opacity: 0.9,
                }}
              >
                ✅
              </button>
              <button
                type="button"
                title="Annuleren"
                aria-label="Annuleren"
                onClick={resetNewLineSelection}
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: 1,
                  opacity: 0.9,
                }}
              >
                ❌
              </button>
            </div>
          </div>
        </div>
      );
    }

    function projectOfferText(item = {}) {
      const value = String(item.offer_text ?? item.offerte_text ?? item.offertetekst ?? item.offerText ?? "");
      return value.trim() ? value : "";
    }

    function projectInternalText(item = {}) {
      const value = String(item.internal_text ?? item.interne_text ?? item.interne_tekst ?? item.internalText ?? "");
      return value.trim() ? value : "";
    }

    function renderProjectSelectionTexts(project) {
      const offerText = projectOfferText(project);
      const internalText = projectInternalText(project);

      if (!showProjectOfferText && !showProjectInternalText) return null;
      if (!offerText && !internalText) return null;

      return (
        <div
          style={{
            gridColumn: "3 / -1",
            marginTop: 5,
            padding: "8px 10px",
            borderLeft: "3px solid #b9cbe0",
            background: "#f8fbff",
            borderRadius: 4,
            fontSize: 12,
            lineHeight: 1.45,
            color: "#333",
          }}
        >
          {showProjectOfferText && offerText && (
            <div style={{ marginBottom: showProjectInternalText && internalText ? 7 : 0 }}>
              <b>Offertetekst:</b>
              <div
                style={{ whiteSpace: "normal", marginTop: 2 }}
                dangerouslySetInnerHTML={{ __html: normalizeRichTextHtml(offerText) }}
              />
            </div>
          )}

          {showProjectInternalText && internalText && (
            <div>
              <b>Interne tekst:</b>
              <div
                style={{ whiteSpace: "normal", marginTop: 2 }}
                dangerouslySetInnerHTML={{ __html: normalizeRichTextHtml(internalText) }}
              />
            </div>
          )}
        </div>
      );
    }

    function projectHasChildren(projectId) {
      return projectItems.some(
        (item) => String(item.parent_id || "") === String(projectId || "")
      );
    }

    function toggleProjectExpanded(projectId) {
      const id = String(projectId || "");
      if (!id) return;

      setExpandedProjectIds((prev) => {
        const next = new Set(prev);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        return next;
      });
    }

    function projectHasVisibleAncestorPath(project) {
      let parentId = project?.parent_id ? String(project.parent_id) : "";
      const guard = new Set();

      while (parentId) {
        if (guard.has(parentId)) return false;
        guard.add(parentId);

        if (!expandedProjectIds.has(parentId)) return false;

        const parent = projectItems.find(
          (item) => String(item.id) === parentId
        );
        if (!parent) break;

        parentId = parent.parent_id ? String(parent.parent_id) : "";
      }

      return true;
    }

    function renderProjectLineSelection() {
      const query = norm(projectSearch);
      const sortedProjects = sortedProjectItems(projectItems);

      const visibleProjects = sortedProjects.filter((p) => {
        const matchesSearch =
          !query ||
          norm([
            p.full_code,
            p.code,
            p.name,
            p.full_name,
            projectOfferText(p),
            projectInternalText(p),
          ].filter(Boolean).join(" ")).includes(query);

        if (!matchesSearch) return false;

        // vOFF-118: tijdens zoeken ALLE niveaus tonen, ook als de boom is ingeklapt.
        // Zonder zoektekst blijft de normale boomstructuur gelden.
        if (query) return true;

        if (!p.parent_id) return true;

        return projectHasVisibleAncestorPath(p);
      });

      const selectedSet = new Set((selectedProjectIds || []).map(String));
      const excludedSet = new Set((excludedProjectIds || []).map(String));
      const resolvedSet = new Set(resolvedSelectedProjectItems().map((p) => String(p.id)));
      const addDisabled = projectItemsLoading || resolvedSet.size === 0;

      return (
        <div style={{ marginTop: 12, border: "1px solid #d9e2ec", borderRadius: 8, padding: 12, background: "#fafcff" }}>
          {projectItemsLoading && <div style={{ marginBottom: 8, fontSize: 13 }}>Actuele projectonderdelen ophalen...</div>}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <input
              value={projectSearch}
              onChange={(e) => setProjectSearch(e.target.value)}
              placeholder="Zoek..."
              autoFocus
              style={{ ...inputStyle, background: "#fff", width: 280, maxWidth: "100%" }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "10px 0", flexWrap: "wrap" }}>
            <b style={{ fontSize: 13 }}>Onderliggende onderdelen</b>
            <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13 }}>
              <input
                type="radio"
                name="include-child-projects"
                checked={!includeChildProjects}
                onChange={() => {
                  setIncludeChildProjects(false);
                  setExcludedProjectIds([]);
                }}
              />
              Nee
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13 }}>
              <input
                type="radio"
                name="include-child-projects"
                checked={includeChildProjects}
                onChange={() => {
                  setIncludeChildProjects(true);
                  setExcludedProjectIds([]);
                }}
              />
              Ja
            </label>

            <b style={{ fontSize: 13, marginLeft: 12 }}>Tonen</b>
            <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13 }}>
              <input
                type="checkbox"
                checked={showProjectOfferText}
                onChange={(e) => setShowProjectOfferText(e.target.checked)}
              />
              Offertetekst
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13 }}>
              <input
                type="checkbox"
                checked={showProjectInternalText}
                onChange={(e) => setShowProjectInternalText(e.target.checked)}
              />
              Interne tekst
            </label>

            <span style={{ marginLeft: "auto", fontSize: 12, color: "#666" }}>
              {resolvedSet.size} geselecteerd
            </span>
          </div>

          <div style={{ maxHeight: 380, overflowY: "auto", border: "1px solid #e1e6eb", borderRadius: 6, background: "#fff" }}>
            {visibleProjects.length === 0 ? (
              <div style={{ padding: 12, color: "#777" }}>Geen projectonderdelen gevonden.</div>
            ) : visibleProjects.map((p) => {
              const id = String(p.id);
              const explicit = selectedSet.has(id);
              const excluded = excludedSet.has(id);
              const automatic = includeChildProjects && resolvedSet.has(id) && !explicit && !excluded;
              const checked = resolvedSet.has(id);

              return (
                <label
                  key={p.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "24px 24px 1fr",
                    gap: 6,
                    padding: "8px 10px",
                    borderBottom: "1px solid #f0f0f0",
                    cursor: "pointer",
                    background: automatic ? "#eef6ff" : "#fff",
                    paddingLeft:
                      10 + Math.max(0, Number(p.level || 1) - 1) * 18,
                  }}
                >
                  {projectHasChildren(p.id) ? (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleProjectExpanded(p.id);
                      }}
                      title={
                        expandedProjectIds.has(id)
                          ? "Onderliggende onderdelen inklappen"
                          : "Onderliggende onderdelen uitklappen"
                      }
                      aria-label={
                        expandedProjectIds.has(id)
                          ? "Projectonderdeel inklappen"
                          : "Projectonderdeel uitklappen"
                      }
                      style={{
                        width: 22,
                        height: 22,
                        padding: 0,
                        border: "none",
                        background: "transparent",
                        color: "#1f4e79",
                        cursor: "pointer",
                        fontSize: 14,
                        lineHeight: "22px",
                        textAlign: "center",
                      }}
                    >
                      {expandedProjectIds.has(id) ? "▼" : "▶"}
                    </button>
                  ) : (
                    <span
                      aria-hidden="true"
                      style={{ display: "inline-block", width: 22, height: 22 }}
                    />
                  )}

                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => handleProjectCheckboxToggle(id, {
                      isExplicit: explicit,
                      isAutomatic: automatic,
                    })}
                  />

                  <span>
                    <b>{safeTrim(p.full_code || p.code)}</b>
                    {safeTrim(p.name) ? ` ${safeTrim(p.name)}` : ""}
                    {automatic && <span style={{ marginLeft: 6, fontSize: 11, color: "#1f4e79" }}>automatisch</span>}
                  </span>

                  {renderProjectSelectionTexts(p)}
                </label>
              );
            })}
          </div>

          {renderProjectActionButtons("bottom", addDisabled)}
        </div>
      );
    }

    function renderNewOfferLineBlock() {
      if (isLocked || popupMode === "preview" || editingLineId) return null;

      return (
        <div style={{ marginTop: 18 }}>
          {!newLineMode && (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button type="button" onClick={openManualLineEntry} style={{ ...buttonStyle, padding: "8px 14px", fontWeight: 700 }}>
                Handmatig toevoegen
              </button>
              <button type="button" onClick={openProjectLineSelection} style={{ ...buttonStyle, padding: "8px 14px", fontWeight: 700 }}>
                Projectonderdelen toevoegen
              </button>
            </div>
          )}

          {newLineMode === "manual" && renderManualLineEntry()}
          {newLineMode === "project" && renderProjectLineSelection()}
        </div>
      );
    }


    function renderDocumentBlockByKey(key) {
      const def = documentBlockDefinitions.find(([k]) => k === key);
      if (!def) return null;
      const label = def[1];
      const visibilityKey = def[2];
      if (visibilityKey && effectiveDocumentTexts[visibilityKey] === false) return null;
      const value = key === "document_salutation" && !richTextPlainText(effectiveDocumentTexts[key] || "")
        ? "{aanhef}"
        : effectiveDocumentTexts[key] || "";
      const extraStyle = key === "document_salutation" ? { marginBottom: "12pt" } : key === "document_conditions_text" ? { marginTop: 5 } : {};
      if (popupMode === "preview") return value ? renderTemplateBlock(value, extraStyle) : null;
      return renderEditableDocumentText(key, value, label, extraStyle);
    }

    function renderOrderedDocumentItems(items) {
      const rendered = [];
      let articleHeaderShown = false;
      (items || []).forEach((item, pos) => {
        if (item.type === "block") {
          const block = renderDocumentBlockByKey(item.key);
          rendered.push(<React.Fragment key={`doc-block-${item.key}`}>{block}</React.Fragment>);
          if (block && item.page_break_after === true) rendered.push(renderPageBreakMarker(item));
          return;
        }
        const ln = (lines || []).find((x) => String(x.id) === String(item.id));
        if (!ln) return;
        const currentIsArticle = lineTypeOf(ln) === "Artikel";
        if (currentIsArticle && !articleHeaderShown) {
          // Een voorafgaand tekstblok heeft al 12pt onderruimte; geen extra 8px toevoegen.
          const previousItem = (items || [])[pos - 1];
          const previousBlock = previousItem?.type === "block" && renderDocumentBlockByKey(previousItem.key);
          const previousLine = previousItem?.type === "line"
            ? (lines || []).find((x) => String(x.id) === String(previousItem.id)) : null;
          // Projecttekst heeft geen eigen ondermarge: geef de eerste artikelkop dezelfde 12pt blokafstand.
          const followsProjectText = previousLine && lineTypeOf(previousLine) !== "Artikel";
          rendered.push(renderOfferHeader(`doc-line-header-${item.id}-${pos}`, followsProjectText ? "12pt" : (previousBlock ? 0 : 8)));
          articleHeaderShown = true;
        }
        const precedingItem = (items || [])[pos - 1];
         const precedingLine = precedingItem?.type === "line"
           ? (lines || []).find((x) => String(x.id) === String(precedingItem.id)) : null;
         const followsTextLine = !currentIsArticle && precedingLine && lineTypeOf(precedingLine) !== "Artikel" && precedingItem.page_break_after !== true;
         rendered.push(renderOfferLine(ln, (lines || []).findIndex((x) => String(x.id) === String(ln.id)), followsTextLine));
        if (item.page_break_after === true) rendered.push(renderPageBreakMarker(item));
      });
      return rendered;
    }

    function splitDocumentOrderAroundTotals() {
      const order = normalizedDocumentOrder();
      const lastLineIndex = order.reduce((last, item, idx) => item.type === "line" ? idx : last, -1);
      if (lastLineIndex >= 0) return { beforeTotals: order.slice(0, lastLineIndex + 1), afterTotals: order.slice(lastLineIndex + 1) };
      let splitAt = order.findIndex((item) => item.type === "block" && !preTotalBlockKeys.has(String(item.key || "")));
      if (splitAt < 0) splitAt = order.length;
      return { beforeTotals: order.slice(0, splitAt), afterTotals: order.slice(splitAt) };
    }

    function renderOfferLinesBlock() {
      const rendered = [];
      let articleHeaderShown = false;

      (lines || []).forEach((ln, idx) => {
        const currentIsArticle = lineTypeOf(ln) === "Artikel";

        if (currentIsArticle && !articleHeaderShown) {
          rendered.push(renderOfferHeader(`offer-line-header-${idx}`));
          articleHeaderShown = true;
        }

        rendered.push(renderOfferLine(ln, idx));
      });

      return (
        <>
          <div style={{ marginTop: 8 }}>
            {(lines || []).length === 0 ? (
              <div style={{ padding: "14px 0", color: "#777", fontSize: 14 }}>
                (nog geen offerteregels)
              </div>
            ) : (
              rendered
            )}

            {renderNewOfferLineBlock()}

            {lineError && (
              <div style={{ marginTop: 10, color: "crimson", fontSize: 13 }}>
                {lineError}
              </div>
            )}
          </div>
        </>
      );
    }

    // ---------- RENDER ----------
    return (
  <>
        <div>
<div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "1fr"
                : `minmax(0, 1fr) minmax(${RIGHT_WIDTH}px, ${RIGHT_WIDTH}px)`,
              columnGap: GAP,
              rowGap: isMobile ? 22 : 0,
              alignItems: "start",
              minWidth: 0,
            }}
          >
            {/* LINKS */}
            <div style={{ minWidth: 0 }}>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 0,
    marginBottom: 10,
  }}
>
  <h1 style={{ margin: 0 }}>
    Opdrachten <span style={{ fontSize: 16 }}>(Offertes)</span>{" "}
    <span style={{ fontSize: 12, opacity: 0.5 }}>{VERSION}</span>
  </h1>

  <HelpButton
    topic="offertes-opdrachten"
    title="Help over Opdrachten (Offertes)"
  />
</div>

<>
                {!isMobile ? (
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      alignItems: "center",
                      flexWrap: "nowrap",
                    }}
                  >
                    <input
                      ref={searchRef}
                      value={q}
                      onChange={(e) => {
                        setQ(e.target.value);
                        setMode("search");
                      }}
                      placeholder="Zoek…"
                      style={searchInputStyle}
                      onFocus={() => setMode("search")}
                    />

                    <div
                      title={`Aantal regels in het grid: ${gridCount}`}
                      style={{
                        minWidth: 52,
                        height: 32,
                        padding: "0 10px",
                        border: "1px solid #d9d9d9",
                        borderRadius: 4,
                        background: "#f7fafc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#1f4e79",
                        boxSizing: "border-box",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {gridCount}
                    </div>

                    <button
                      onMouseDown={(e) => e.preventDefault()}
                      onTouchStart={(e) => e.preventDefault()}
                      onClick={startSpeakSmart}
                      disabled={!voice.supported || voice.listening}
                      style={!voice.supported || voice.listening ? buttonDisabledStyle : buttonStyle}
                      title="1x klikken = 1 commando of invul-tekst dicteren"
                    >
                      {voice.listening ? "🎤 Luistert…" : "🎤 Spreek"}
                    </button>

<button
  onClick={newItem}
  disabled={isReadonly}
  style={isReadonly ? buttonDisabledStyle : buttonStyle}
>
  ✚ Nieuw
</button>

<button onClick={vernieuwList} style={buttonStyle}>
  🔄 Vernieuw
</button>

<button
  onClick={() => openAiPopup("page")}
  style={buttonStyle}
>
  ✨ AI
</button>
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "minmax(0, 1fr) 58px",
                        gap: 6,
                        marginBottom: 8,
                        alignItems: "center",
                      }}
                    >
                      <input
                        ref={searchRef}
                        value={q}
                        onChange={(e) => {
                          setQ(e.target.value);
                          setMode("search");
                        }}
                        placeholder="Zoek…"
                        style={{
                          ...searchInputStyle,
                          width: "100%",
                          minWidth: 0,
                        }}
                        onFocus={() => setMode("search")}
                      />

                      <div
                        title={`Aantal regels in het grid: ${gridCount}`}
                        style={{
                          height: 34,
                          minHeight: 34,
                          padding: "0 8px",
                          border: "1px solid #d9d9d9",
                          borderRadius: 4,
                          background: "#f7fafc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#1f4e79",
                          boxSizing: "border-box",
                          whiteSpace: "nowrap",
                          lineHeight: "1",
                        }}
                      >
                        {gridCount}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                        gap: 6,
                      }}
                    >
                      <button
                        onMouseDown={(e) => e.preventDefault()}
                        onTouchStart={(e) => e.preventDefault()}
                        onClick={startSpeakSmart}
                        disabled={!voice.supported || voice.listening}
                        style={{
                          ...(!voice.supported || voice.listening ? buttonDisabledStyle : buttonStyle),
                          padding: "10px 8px",
                          fontSize: 13,
                        }}
                        title="1x klikken = 1 commando of invul-tekst dicteren"
                      >
                        {voice.listening ? "🎤..." : "🎤 Spreek"}
                      </button>

                      <button
                        onClick={newItem}
                        disabled={isReadonly}
                        style={{
                          ...(isReadonly
                            ? { ...buttonStyle, opacity: 0.5, cursor: "not-allowed" }
                            : buttonStyle),
                          padding: "10px 8px",
                          fontSize: 13,
                        }}
                      >
                        ✚ Nieuw
                      </button>

                      <button
                        onClick={() => openAiPopup("page")}
                        style={{
                          ...buttonStyle,
                          padding: "10px 8px",
                          fontSize: 13,
                        }}
                      >
                        ✨ AI
                      </button>

                      <button
                        onClick={vernieuwList}
                        style={{
                          ...buttonStyle,
                          padding: "10px 8px",
                          fontSize: 13,
                        }}
                      >
                        🔄 Vernieuw
                      </button>
                    </div>
                  </>
                )}
              </>

              <div style={{ marginTop: 10 }}>
                {loading && <div>Laden…</div>}
                {error && <div style={{ color: "crimson" }}>{error}</div>}
                {flash && <div style={{ marginBottom: 8, color: "green" }}>{flash}</div>}
                {saveError && <div style={{ marginBottom: 8, color: "crimson" }}>{saveError}</div>}
                {payError && <div style={{ marginBottom: 8, color: "crimson" }}>{payError}</div>}
                {lastApprovalInfo?.approval_url && (
                  <div style={{ marginBottom: 8, color: "#1f4e79", lineHeight: 1.45 }}>
                    Akkoordlink gemaakt.
                    <br />
                    Verzonden via: {approvalChannelLabel(lastApprovalInfo.channel)}
                    <br />
                    Verzonden door: {lastApprovalInfo.sent_by_name || "StaffIQ"}{lastApprovalInfo.sent_by_email ? ` (${lastApprovalInfo.sent_by_email})` : ""}
                    <br />
                    Ontvangen door: {lastApprovalInfo.sent_to_name || "-"}{lastApprovalInfo.sent_to ? ` (${lastApprovalInfo.sent_to})` : ""}
                    {lastApprovalInfo.email_to && (
                      <>
                        <br />
                        E-mail verstuurd naar: {lastApprovalInfo.email_to}
                      </>
                    )}
                    {lastApprovalInfo.email_accepted && (
                      <>
                        <br />
                        Geaccepteerd door mailserver: {lastApprovalInfo.email_accepted}
                      </>
                    )}
                    {lastApprovalInfo.email_rejected && (
                      <>
                        <br />
                        <span style={{ color: "#9b1c1c", fontWeight: 700 }}>
                          Niet geaccepteerd: {lastApprovalInfo.email_rejected}
                        </span>
                      </>
                    )}
                    {lastApprovalInfo.popup_blocked && (
                      <>
                        <br />
                        <span style={{ color: "#9b1c1c", fontWeight: 700 }}>
                          WhatsApp werd door de browser geblokkeerd.
                        </span>
                      </>
                    )}
                    <br />
                    <button
                      type="button"
                      onClick={() => openApprovalUrl(lastApprovalInfo.approval_url)}
                      style={{ border: "none", background: "transparent", color: "#1f4e79", textDecoration: "underline", cursor: "pointer", padding: 0 }}
                    >
                      Open akkoordpagina
                    </button>
                    {lastApprovalInfo?.whatsapp_url && lastApprovalInfo.channel !== "email" && (
                      <>
                        <br />
                        <button
                          type="button"
                          onClick={() => openWhatsAppSmart(lastApprovalInfo.whatsapp_url)}
                          style={{ border: "none", background: "transparent", color: "#1f4e79", textDecoration: "underline", cursor: "pointer", padding: 0 }}
                        >
                          Open WhatsApp opnieuw
                        </button>
                      </>
                    )}
                  </div>
                )}
                {voice.error && !hideVoiceError && <div style={{ color: "crimson" }}>Spraakfout: {voice.error}</div>}
              </div>

              {!loading && !error && (
                <div style={{ marginTop: 8, minWidth: 0 }}>
                  <div
                    ref={midScrollRef}
                    style={{
                      overflowX: "auto",
                      overflowY: "auto",

                      maxHeight: `calc(100vh - ${MID_BOTTOM_OFFSET}px)`,
                      border: "1px solid #f0f0f0",
                      borderRadius: 6,
                      background: "#fff",
                    }}
                  >
                    <div style={{ minWidth: TABLE_MIN_WIDTH }}>
                      <table style={tableStyle}>
<colgroup>
  <col style={{ width: colWidths.zoeknaam }} />
  <col style={{ width: colWidths.status }} />
  <col style={{ width: colWidths.contact }} />
  <col style={{ width: colWidths.invnr }} />
  <col style={{ width: colWidths.invdt }} />
  <col style={{ width: colWidths.totaal }} />
  <col style={{ width: colWidths.tel }} />
  <col style={{ width: colWidths.mob }} />
  <col style={{ width: colWidths.email }} />
  <col style={{ width: colWidths.city }} />
  <col style={{ width: colWidths.country }} />
  <col style={{ width: colWidths.companyCode }} />
</colgroup>

                        <thead>
<tr>
  <th style={thClickable} onClick={() => setSort({ key: "org", dir: sort.key === "org" && sort.dir === "asc" ? "desc" : "asc" })}>
    Relatie
  </th>
  <th style={thClickable} onClick={() => setSort({ key: "status", dir: sort.key === "status" && sort.dir === "asc" ? "desc" : "asc" })}>
    Status
  </th>
  <th style={thClickable} onClick={() => setSort({ key: "contact", dir: sort.key === "contact" && sort.dir === "asc" ? "desc" : "asc" })}>
    Contactpersoon
  </th>
  <th style={thClickable} onClick={() => setSort({ key: "invoice_number", dir: sort.key === "invoice_number" && sort.dir === "asc" ? "desc" : "asc" })}>
    Referentie
  </th>
  <th style={thClickable} onClick={() => setSort({ key: "invoice_date", dir: sort.key === "invoice_date" && sort.dir === "asc" ? "desc" : "asc" })}>
    Datum
  </th>
  <th
    style={{ ...thClickable, textAlign: "right" }}
    onClick={() =>
      setSort({
        key: "totaal",
        dir: sort.key === "totaal" && sort.dir === "asc" ? "desc" : "asc",
      })
    }
  >
    Totaal
  </th>

  <th style={thBase}>Telefoon</th>
  <th style={thBase}>Mobiel</th>
  <th style={thBase}>E-mail</th>
  <th style={thClickable} onClick={() => setSort({ key: "city", dir: sort.key === "city" && sort.dir === "asc" ? "desc" : "asc" })}>
    Plaats
  </th>
  <th style={thClickable} onClick={() => setSort({ key: "country", dir: sort.key === "country" && sort.dir === "asc" ? "desc" : "asc" })}>
    Land
  </th>
  <th style={thClickable} onClick={() => setSort({ key: "company_code", dir: sort.key === "company_code" && sort.dir === "asc" ? "desc" : "asc" })}>
    Bedrijfscode
  </th>
</tr>
<tr>
                            <th style={filterThStyle}>
                              <select value={zoeknaamFilter} onChange={(e) => setZoeknaamFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {zoeknaamOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {statusOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={contactFilter} onChange={(e) => setContactFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {contactOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={invoiceNrFilter} onChange={(e) => setInvoiceNrFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {invoiceNrOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={invoiceDateFilter} onChange={(e) => setInvoiceDateFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {invoiceDateOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {formatNlDate(x)}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select
                                value={totaalFilter}
                                onChange={(e) => setTotaalFilter(e.target.value)}
                                style={selectStyle}
                              >
                                <option value="">(alle)</option>
                                {totaalOptions.map((x) => (
                                  <option key={x} value={x}>
                                    € {formatMoney(x)}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={telFilter} onChange={(e) => setTelFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {telOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={mobFilter} onChange={(e) => setMobFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {mobOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={emailFilter} onChange={(e) => setEmailFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {emailOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={cityFilter} onChange={(e) => setCityFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {cityOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={countryFilter} onChange={(e) => setCountryFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {countryOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>

                            <th style={filterThStyle}>
                              <select value={companyCodeFilter} onChange={(e) => setCompanyCodeFilter(e.target.value)} style={selectStyle}>
                                <option value="">(alle)</option>
                                {companyCodeOptions.map((x) => (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                ))}
                              </select>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {sortedItems.map((it, idx) => {
                            const isCursor = idx === listIndex;
                            const isSelected = String(selectedId || "") === String(it.id || "");

                            let bg = "transparent";
                            if (isSelected) bg = rowBgSelected;
                            else if (isCursor) bg = rowBgCursor;

                            const orgName = safeTrim(it.organisation_name || "-") || "-";
                            const contactName = safeTrim(pickContactNameFromRow(it) || "-") || "-";
                            const invNr = offerReferenceValue(it) || "-";
                            const invDt = isoDate(it.invoice_date) || "-";
                            const totaal = Number(it.total || 0);
                            const tel = safeTrim(it.org_phone || "-") || "-";
                            const mob = safeTrim(it.org_mobile || "-") || "-";
                            const email = safeTrim(it.org_email || "-") || "-";
                            const city = safeTrim(it.org_city || "-") || "-";
                            const ctry = safeTrim(it.org_country || "-") || "-";
                            const companyCodeName = safeTrim(pickCompanyCodeName(it));
                            const st = statusLabel(it.status);

                            const paidText = it.id === selectedId ? paidLabel : "-";

                            return (
<tr
  key={it.id}
  ref={(el) => (rowRefs.current[idx] = el)}
  onClick={() => loadItemFromRow(it)}
  style={{
    cursor: "pointer",
    background:
      String(selectedId) === String(it.id)
        ? "#eef6ff"
        : listIndex === idx
        ? "#f5faff"
        : "transparent",
  }}
>
  <td style={tdStyle}>{safeTrim(pickOrgSearchNameFromRow(it))}</td>
  <td style={tdStyle}>{statusLabel(it.status)}</td>
  <td style={tdStyle}>{safeTrim(pickContactNameFromRow(it))}</td>
  <td style={tdStyle}>{offerReferenceValue(it)}</td>
  <td style={tdStyle}>{formatNlDate(it.invoice_date)}</td>
  <td style={{ ...tdStyle, textAlign: "right" }}>{euro(it.total)}</td>
  <td style={tdStyle} title={safeTrim(it.org_phone || "")}>
    {safeTrim(it.org_phone || "") ? (
      <button
        type="button"
        onClick={(e) => handlePhoneGridClick(e, safeTrim(it.org_phone || ""))}
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          margin: 0,
          color: "#1f4e79",
          textDecoration: "underline",
          cursor: "pointer",
          font: "inherit",
        }}
        title={`Bellen: ${safeTrim(it.org_phone || "")}`}
      >
        {safeTrim(it.org_phone || "")}
      </button>
    ) : (
      "-"
    )}
  </td>

  <td style={tdStyle} title={safeTrim(it.org_mobile || "")}>
    {safeTrim(it.org_mobile || "") ? (
      <button
        type="button"
        onClick={(e) => handleMobileGridClick(e, safeTrim(it.org_mobile || ""))}
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          margin: 0,
          color: "#1f4e79",
          textDecoration: "underline",
          cursor: "pointer",
          font: "inherit",
        }}
        title={`Bellen / SMS / WhatsApp: ${safeTrim(it.org_mobile || "")}`}
      >
        {safeTrim(it.org_mobile || "")}
      </button>
    ) : (
      "-"
    )}
  </td>

  <td style={tdStyle} title={safeTrim(it.org_email || "")}>
    {safeTrim(it.org_email || "") ? (
      <button
        type="button"
        onClick={(e) => handleEmailGridClick(e, safeTrim(it.org_email || ""))}
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          margin: 0,
          color: "#1f4e79",
          textDecoration: "underline",
          cursor: "pointer",
          font: "inherit",
        }}
        title={`E-mailen: ${safeTrim(it.org_email || "")}`}
      >
        {safeTrim(it.org_email || "")}
      </button>
    ) : (
      "-"
    )}
  </td>
  <td style={tdStyle}>{safeTrim(it.org_city || "")}</td>
  <td style={tdStyle}>{safeTrim(it.org_country || "")}</td>
  <td style={tdStyle} title={companyCodeName}>{companyCodeName || "-"}</td>
</tr>
                            );
                          })}

                          {sortedItems.length === 0 && (
                            <tr>
                              <td colSpan={12} style={{ padding: 12, opacity: 0.7 }}>
                                Geen resultaten (filters te streng?)
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>

{/* RECHTS */}
<div
  ref={rightScrollRef}
  style={{
    width: isMobile ? "100%" : 320,
    minWidth: isMobile ? 0 : 320,
    maxWidth: isMobile ? "100%" : 320,
    position: isMobile ? "relative" : "sticky",
    top: isMobile ? "auto" : 0,
    alignSelf: "start",
    maxHeight: isMobile ? "none" : "calc(100vh - 40px)",
    overflowY: isMobile ? "visible" : "auto",
    overflowX: "hidden",
    background: "white",
    border: "10px solid #0b4f7a",
    borderRadius: 10,
    padding: 10,
    boxSizing: "border-box",
    marginTop: isMobile ? 6 : 0,
    paddingTop: isMobile ? 6 : 10,
  }}
>

              <div
                style={{
                  background: "white",
                  borderRadius: 10,
                  padding: 12,
                  boxSizing: "border-box",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  overflowX: "hidden",
                }}
              >
<h3 style={{ margin: "0 0 10px 0" }}>
  Opdracht (Offerte)
</h3>

<div style={{ display: "grid", gap: 8, width: "100%", minWidth: 0 }}>

<label style={{ fontSize: 13, color: "#333" }}>Relatie</label>
<select
  ref={orgRef}
  value={form.organisation_id}
  onChange={(e) => {
    const v = e.target.value;
    setForm((p) => ({ ...p, organisation_id: v, contact_id: "" }));
    setOrgDetail(null);
    if (v) loadOrgDetail(v);
  }}
  style={selectStyle}
  disabled={isFormLocked || isFormDisabled}
  title={isLocked ? "Read-only (gefactureerd)" : ""}
>
  <option value="">(kies)</option>
  {sortedOrgs.map((o) => (
    <option key={o.id} value={String(o.id)}>
      {pickOrgSearchName(o)}
    </option>
  ))}
</select>

<label
  style={{
    fontSize: 13,
    color: "#333",
    opacity: selectedRelationIsPrivate ? 0.55 : 1,
  }}
>
  Contactpersoon
</label>
<select
  ref={contactRef}
  value={selectedRelationIsPrivate ? "" : form.contact_id}
  onChange={(e) => setForm((p) => ({ ...p, contact_id: e.target.value }))}
  style={{
    ...selectStyle,
    opacity: selectedRelationIsPrivate ? 0.55 : 1,
    cursor: selectedRelationIsPrivate ? "not-allowed" : "pointer",
  }}
  disabled={isFormLocked || isFormDisabled || selectedRelationIsPrivate}
  title={
    selectedRelationIsPrivate
      ? "Niet van toepassing bij particulier"
      : isLocked
        ? "Read-only (gefactureerd)"
        : ""
  }
>
  <option value="">
    {selectedRelationIsPrivate
      ? "(niet van toepassing bij particulier)"
      : "(geen)"}
  </option>
  {!selectedRelationIsPrivate &&
    contacts
      .filter((c) => c.active !== false)
      .map((c) => (
        <option key={c.id} value={String(c.id)}>
          {pickContactFullName(c)}
        </option>
      ))}
</select>

<label style={{ fontSize: 13, color: "#333" }}>Bedrijfscode</label>
<input
  value={pickCompanyCodeNameFromOrganisation(activeOrg) || ""}
  readOnly
  disabled
  style={{
    ...inputStyle,
    background: "#f7f7f7",
    color: "#555",
  }}
/>

<label style={{ fontSize: 13, color: "#333" }}>Sjabloon</label>
<select
  value={form.template_id || ""}
  onChange={(e) => applyTemplateToDocumentTexts(e.target.value)}
  style={selectStyle}
  disabled={isFormLocked || isFormDisabled}
>
  <option value="">(geen sjabloon)</option>
  {selectableOfferTemplates.map((tpl) => (
    <option key={tpl.id} value={String(tpl.id)}>
      {tpl.name} ({templateTypeLabel(tpl.template_type)})
    </option>
  ))}
</select>

<label style={{ fontSize: 13, color: "#333" }}>Referentie</label>
<input
  ref={invNumRef}
  value={form.reference || ""}
  onChange={(e) => setForm((p) => ({ ...p, reference: e.target.value }))}
  style={inputStyle}
  disabled={isFormLocked || isFormDisabled}
  placeholder="(vrij in te vullen)"
  title=""
/>

<label style={{ fontSize: 13, color: "#333" }}>Offertedatum</label>
<input
  ref={invDateRef}
  type="date"
  value={form.invoice_date || ""}
  onChange={(e) => setForm((p) => ({ ...p, invoice_date: e.target.value }))}
  style={dateInputStyle}
  disabled={isFormLocked || isFormDisabled}
/>
<label style={{ fontSize: 13, color: "#333" }}>Orderdatum</label>
<input
  type="date"
  value={form.order_date || ""}
  onChange={(e) => setForm((p) => ({ ...p, order_date: e.target.value }))}
  style={dateInputStyle}
  disabled={isFormLocked || isFormDisabled}
  title="Wordt bij omzetting naar Opdracht automatisch gevuld als dit veld leeg is. Je kunt de datum ook handmatig invullen of corrigeren."
/>

<label style={{ fontSize: 13, color: "#333" }}>Geplande leverdatum</label>
<input
  type="date"
  value={form.planned_delivery_date || ""}
  onChange={(e) => setForm((p) => ({ ...p, planned_delivery_date: e.target.value }))}
  style={dateInputStyle}
  disabled={isFormLocked || isFormDisabled}
/>

<div style={{ display: "grid", gap: 8 }}>

<button
  onClick={openOfferPopupEdit}
  disabled={isFormLocked}
  style={
    isFormLocked
      ? {
          ...buttonPrimary("#2f7dd1"),
          width: "100%",
          boxSizing: "border-box",
          opacity: 0.5,
          cursor: "not-allowed",
        }
      : {
          ...buttonPrimary("#2f7dd1"),
          width: "100%",
          boxSizing: "border-box",
        }
  }
  title={!formHasId() ? "Sla op en open opdracht" : "Open complete opdracht in popup"}
>
  Opdracht (Offerte)
</button>
</div>

<hr style={{ margin: "10px 0" }} />

<div style={{ fontWeight: 600, marginBottom: 6 }}>Totalen</div>

<div
  style={{
    border: "1px solid #e5e5e5",
    borderRadius: 8,
    padding: 10,
    fontSize: 12,
    display: "grid",
    gap: 6,
  }}
>
</div>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Subtotaal</span>
                      <b>{euro(invoiceTotals.subtotal)}</b>
                    </div>

                    {invoiceTotals.vatRows.map((row) => (
                      <div
                        key={row.rate}
                        style={{ display: "flex", justifyContent: "space-between" }}
                      >
                        <span>{row.label}</span>
                        <span>{euro(row.vat)}</span>
                      </div>
                    ))}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderTop: "1px solid #ddd",
                        paddingTop: 6,
                        marginTop: 2,
                        fontSize: 13,
                      }}
                    >
                      <span><b>Totaal</b></span>
                      <b>{euro(invoiceTotals.total)}</b>
                    </div>

                    {invoiceTotals.allVerlegd && (
                      <div style={{ color: "#555", marginTop: 4 }}>Btw verlegd</div>
                    )}

                    {gPercentage > 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderTop: "1px solid #eee",
                            paddingTop: 6,
                            marginTop: 4,
                          }}
                        >
                          <span>G-rekening ({gPercentage}%)</span>
                          <b>{euro(gAmount)}</b>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>IBAN ({100 - gPercentage}%)</span>
                          <b>{euro(ibanAmount)}</b>
                        </div>
                      </>
                    )}
                  </div>

                  <hr style={{ margin: "14px 0 10px 0" }} />

                  <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                    <label style={{ fontSize: 13, color: "#333" }}>Opmerking</label>

                    <input
                      ref={payNotesRef}
                      value={form.notes || ""}
                      onChange={(e) => setForm({ ...form, notes: e.target.value })}
                      placeholder="(optioneel)"
                      style={{
                        ...inputStyle,
                        marginTop: 6
                      }}
                      disabled={!form.id}
                    />

                  </div>
                </div>

                <hr style={{ margin: "10px 0" }} />

<label style={{ fontSize: 13, color: "#333" }}>Status</label>
<select
  ref={statusRef}
  value={normalizeDbStatus(form.status || "OFFERTE")}
  disabled={!isAdmin}
  onChange={(e) =>
    setForm((prev) => ({ ...prev, status: e.target.value }))
  }
>
{statusSelectOptions.map((opt) => (
  <option key={opt.value} value={opt.value}>
    {opt.label}
  </option>
))}
</select>

                <div style={{ fontSize: 12, color: "#666" }}>
                  <div>

                  </div>
                </div>

                <hr style={{ margin: "10px 0" }} />

<div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 12 }}>
  <div style={{ display: "flex", gap: 6, minWidth: 0 }}>
<button
  onClick={openOfferPopupPreview}
  disabled={
    isFormLocked ||
    normalizeDbStatus(form.status || "OFFERTE") !== "OFFERTE"
  }
  style={{
    ...buttonPrimary("#6c757d"),
    flex: 1,
    ...(isFormLocked ||
    normalizeDbStatus(form.status || "OFFERTE") !== "OFFERTE"
      ? { opacity: 0.5, cursor: "not-allowed" }
      : {}),
  }}
>
  Voortgang offerte
</button>

<button
      onClick={finalizeInvoice}
      disabled={
        isFormLocked ||
        isReadonly ||
        !formHasId() ||
        normalizeDbStatus(form.status || "OFFERTE") !== "OFFERTE"
      }
      style={{
        ...buttonPrimary("#28a745"),
        flex: 1,
        ...(isFormLocked ||
        isReadonly ||
        !formHasId() ||
        normalizeDbStatus(form.status || "OFFERTE") !== "OFFERTE"
          ? { opacity: 0.5, cursor: "not-allowed" }
          : {}),
      }}
    >
      Offerte goedgekeurd
    </button>

  </div>

  <div style={{ display: "flex", gap: 6, minWidth: 0 }}>
<button
  onClick={openOfferPopupPreview}
  disabled={
    isFormLocked ||
    normalizeDbStatus(form.status || "OFFERTE") === "OFFERTE"
  }
  style={{
    ...buttonPrimary("#6c757d"),
    flex: 1,
    ...(isFormLocked ||
    normalizeDbStatus(form.status || "OFFERTE") === "OFFERTE"
      ? { opacity: 0.5, cursor: "not-allowed" }
      : {}),
  }}
>
  Voortgang opdracht
</button>

<button
  onClick={async () => {
    if (isFormLocked || isReadonly) return;

    try {
      setSaveError(null);
      setFlash("");

      if (!formHasId()) {
        setSaveError("Sla eerst de opdracht op.");
        return;
      }

      const ok = window.confirm("Opdracht omzetten naar factuur?");
      if (!ok) return;

      // vOFF-149: controle VOOR status FACTUUR wordt opgeslagen.
      // Anders kan een oudere lege projectomschrijving een definitieve UBL blokkeren.
      const preflightOfferDetail = await tryFetchJson([`/api/offers/${encodeURIComponent(form.id)}`]);
      const preflightOfferLines =
        Array.isArray(preflightOfferDetail?.lines) ? preflightOfferDetail.lines :
        Array.isArray(preflightOfferDetail?.items) ? preflightOfferDetail.items :
        Array.isArray(preflightOfferDetail?.offer_lines) ? preflightOfferDetail.offer_lines :
        null;
      if (!preflightOfferLines) {
        setSaveError("De opdrachtregels konden niet gecontroleerd worden. Er is niets omgezet.");
        return;
      }
      const invalidLine = preflightOfferLines.findIndex(
        (ln) => isAmountLine(ln) && !hasVisibleOfferDescription(lineDescription(ln))
      );
      if (invalidLine >= 0) {
        setSaveError(`Artikelregel ${invalidLine + 1} heeft geen omschrijving. Corrigeer die vóór het omzetten naar een factuur.`);
        return;
      }

      // 1. Status naar FACTUUR zetten
      const approvedOffer = await tryFetchJson(
        [`/api/offers/${encodeURIComponent(form.id)}`],
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            organisation_id: form.organisation_id ? Number(form.organisation_id) : null,
            contact_id: form.contact_id ? Number(form.contact_id) : null,
            invoice_date: form.invoice_date || null,
            due_date: form.due_date || null,
            order_date: form.order_date || null,
            planned_delivery_date: form.planned_delivery_date || null,
            invoice_number: form.invoice_number || null,
            reference: safeTrim(form.reference || ""),
            status: "FACTUUR",
            delivery_status: form.delivery_status || "NOT_DELIVERED",
            series_code: form.series_code || null,
            notes: form.notes || "",

      document_subject: effectiveDocumentTexts.document_subject || "",
      ...documentVisibilityPayload(),
      document_salutation: effectiveDocumentTexts.document_salutation || "",
      document_intro_text: effectiveDocumentTexts.document_intro_text || "",
      document_body_text: effectiveDocumentTexts.document_body_text || "",
      document_conditions_text: effectiveDocumentTexts.document_conditions_text || "",
      document_payment_text: effectiveDocumentTexts.document_payment_text || "",
      document_planning_text: effectiveDocumentTexts.document_planning_text || "",
      document_remark_text: effectiveDocumentTexts.document_remark_text || "",
      document_warranty_text: effectiveDocumentTexts.document_warranty_text || "",
      document_closing_text: effectiveDocumentTexts.document_closing_text || "",
      document_show_agreement_block: effectiveDocumentTexts.document_show_agreement_block === true,
      document_agreement_text: effectiveDocumentTexts.document_agreement_text || "",
      document_texts_initialized: true,
            subtotal: Number(form.subtotal || 0),
            vat_total: Number(form.vat_total || 0),
            total: Number(form.total || 0),
          }),
        }
      );

      // 2. OFFERTE REGELS OPHALEN
      const offerDetail = preflightOfferDetail;

      const offerLines =
        Array.isArray(offerDetail?.lines) ? offerDetail.lines :
        Array.isArray(offerDetail?.items) ? offerDetail.items :
        Array.isArray(offerDetail?.offer_lines) ? offerDetail.offer_lines :
        Array.isArray(lines) ? lines :
        [];

      // vOFF-148: de gewone offer_lines-volgorde kan afwijken van de
      // gesleepte documentvolgorde. Neem bij het factureren dezelfde volgorde
      // over als in het offerte-/opdrachtdocument, zonder sjabloonblokken.
      const returnedOrder = offerDetail?.document_order ?? offerDetail?.offer?.document_order;
      const storedOrder = Array.isArray(returnedOrder)
        ? returnedOrder
        : (Array.isArray(form.document_order) ? form.document_order : []);
      const byOfferLineId = new Map(offerLines.map((ln) => [String(ln.id), ln]));
      const usedLineIds = new Set();
      const orderedOfferLines = [];
      storedOrder.forEach((entry) => {
        if (entry?.type !== "line") return;
        const id = String(entry.id ?? "");
        const line = byOfferLineId.get(id);
        if (!line || usedLineIds.has(id)) return;
        usedLineIds.add(id);
        orderedOfferLines.push(line);
      });
      offerLines.forEach((ln) => {
        const id = String(ln.id ?? "");
        if (usedLineIds.has(id)) return;
        usedLineIds.add(id);
        orderedOfferLines.push(ln);
      });

      // De bestaande server ondersteunt items inclusief sort_order direct bij
      // het maken van een factuur. Dit bewaart alle regels in een transactie,
      // ook wanneer Tekst voor of tussen de Artikelen staat.
      const invoiceItems = orderedOfferLines.map((ln, index) => {
        const isArticle = isAmountLine(ln);
        const qty = isArticle ? lineQty(ln) : 0;
        const price = isArticle ? lineUnitPrice(ln) : 0;
        const rate = isArticle ? lineVatRate(ln) : "0";
        const percent = isArticle ? vatPercentForRate(rate) : 0;
        return {
          line_type: isArticle ? "item" : "text",
          description: ln.description || "",
          qty,
          unit_price: price,
          line_total: qty * price,
          vat_rate: percent,
          vat_category: rate === "verlegd" ? "verlegd" : String(percent),
          sort_order: index + 1,
        };
      });

      // 3. NIEUWE FACTUUR AANMAKEN
      const resolvedOrganisationId =
        approvedOffer?.organisation_id ??
        (form.organisation_id ? Number(form.organisation_id) : null);

      const resolvedContactId =
        approvedOffer?.contact_id ??
        (form.contact_id ? Number(form.contact_id) : null);

      const invoicePayload = {
        organisation_id: resolvedOrganisationId,
        contact_id: resolvedContactId,
        source_offer_id: Number(form.id),
        items: invoiceItems,
        invoice_date: todayLocalIso(),
        due_date: "",
        invoice_number: "",
        status: "DRAFT",
        series_code: form.series_code || null,
        notes: form.notes || "",

      document_subject: effectiveDocumentTexts.document_subject || "",
      ...documentVisibilityPayload(),
      document_salutation: effectiveDocumentTexts.document_salutation || "",
      document_intro_text: effectiveDocumentTexts.document_intro_text || "",
      document_body_text: effectiveDocumentTexts.document_body_text || "",
      document_conditions_text: effectiveDocumentTexts.document_conditions_text || "",
      document_payment_text: effectiveDocumentTexts.document_payment_text || "",
      document_planning_text: effectiveDocumentTexts.document_planning_text || "",
      document_remark_text: effectiveDocumentTexts.document_remark_text || "",
      document_warranty_text: effectiveDocumentTexts.document_warranty_text || "",
      document_closing_text: effectiveDocumentTexts.document_closing_text || "",
      document_show_agreement_block: effectiveDocumentTexts.document_show_agreement_block === true,
      document_agreement_text: effectiveDocumentTexts.document_agreement_text || "",
      document_texts_initialized: true,
      };

      const createdInvoice = await tryFetchJson(
        ["/api/invoices"],
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(invoicePayload),
        }
      );

      const newInvoiceId = createdInvoice?.id;
      if (!newInvoiceId) {
        throw new Error("Geen factuur-id ontvangen.");
      }

      // 4. REGELS EN VOLGORDE ZIJN AL ATOMAIR OPGESLAGEN BIJ AANMAKEN.
      // Geen losse POST-verzoeken: die negeerden sort_order bij de omzetting.

setSilentDocumentPreview(true);
setPopupMode("preview");
setShowLinesPopup(true);

await saveOfferDocumentFromPreview(form.id, "order");

setShowLinesPopup(false);
setSilentDocumentPreview(false);

setTimeout(() => {
  setShowLinesPopup(false);
}, 50);

// 5. UI UPDATEN
      setForm((prev) => ({
        ...prev,
        ...approvedOffer,
        status: "FACTUUR",
      }));

      setItems((prev) =>
        prev.map((it) =>
          String(it.id) === String(form.id)
            ? { ...it, ...approvedOffer, status: "FACTUUR" }
            : it
        )
      );

      setFlash("Opdracht → Factuur + conceptfactuur gemaakt ✅");
      setTimeout(() => setFlash(""), 2000);

      alert("Conceptfactuur is aangemaakt inclusief regels.");

    } catch (e) {
      setSaveError(e?.message || String(e));
    }
  }}
  disabled={
    isFormLocked ||
    isReadonly ||
    !formHasId() ||
    normalizeDbStatus(form.status || "OFFERTE") !== "OPDRACHT"
  }
  style={
    isFormLocked ||
    isReadonly ||
    !formHasId() ||
    normalizeDbStatus(form.status || "OFFERTE") !== "OPDRACHT"
      ? { ...buttonPrimary("#28a745"), opacity: 0.5, cursor: "not-allowed" }
      : buttonPrimary("#28a745")
  }
>
  Opdracht goedgekeurd
</button>

  </div>

{orderSettings.use_work_orders === true &&
  ["OPDRACHT", "FACTUUR"].includes(normalizeDbStatus(form.status || "OFFERTE")) && (
    <div style={{ display: "grid", gap: 8 }}>
      <label style={{ fontSize: 13, color: "#333" }}>Oplevering</label>

      <select
        value={form.delivery_status || "NOT_DELIVERED"}
        disabled={isReadonly || !formHasId()}
        onChange={(e) => saveDeliveryStatus(e.target.value)}
        style={selectStyle}
      >
        <option value="NOT_DELIVERED">Niet opgeleverd</option>
        <option value="DELIVERED">Opgeleverd</option>
      </select>

      <button
        type="button"
        onClick={() =>
          navigate(`/werkbon-oplevering/${encodeURIComponent(form.id)}`)
        }
        disabled={!formHasId()}
        style={{
          ...buttonPrimary("#6f42c1"),
          width: "100%",
          ...(!formHasId()
            ? { opacity: 0.5, cursor: "not-allowed" }
            : {}),
        }}
      >
        Werkbon / Oplevering
      </button>
    </div>
  )}

  <div style={{ display: "flex", gap: 6, minWidth: 0 }}>
    <button
      onClick={saveItem}
      disabled={isFormLocked || isReadonly}
      style={{
        ...buttonPrimary("#2f7dd1"),
        flex: 1,
        ...(isFormLocked || isReadonly ? { opacity: 0.5, cursor: "not-allowed" } : {}),
      }}
    >
      Opslaan
    </button>

    <button
      onClick={deleteItem}
      disabled={isFormLocked || !deleteEnabled || isLocked || isReadonly}
      style={{
        ...buttonPrimary("#d64545"),
        flex: 1,
        ...(isFormLocked || !deleteEnabled || isLocked || isReadonly
          ? { opacity: 0.5, cursor: "not-allowed" }
          : {}),
      }}
    >
      Verwijderen
    </button>
  </div>

  <div style={{ marginTop: 10, opacity: 0.7, fontSize: 12 }}>
    Offerte-id: {formHasId() ? String(form.id) : "(nieuw)"}{" "}
    {isLocked ? "— read-only" : ""}
  </div>
</div>
            </div>
          </div>
        </div>

{showLinesPopup && (
<div
  ref={offerPopupScrollRef}
  onDragOver={allowDocumentDrop}
  style={{
    position: "fixed",
    inset: 0,
    background: silentDocumentPreview ? "transparent" : "rgba(0,0,0,0.35)",
    zIndex: 99999,
    overflowY: "auto",
    overflowX: "auto",
    padding: "20px",
    opacity: silentDocumentPreview ? 0 : 1,
    pointerEvents: silentDocumentPreview ? "none" : "auto",
  }}
>
<div
  ref={popupPrintRef}
  style={{
    position: "relative",
    width: 1120,
    minWidth: 1120,
    minHeight: showLetterheadOnEditor ? 1584 : undefined,
    margin: "0 auto",
    backgroundColor: "#fff",
    backgroundImage: showLetterheadOnEditor
      ? `url("${letterheadBackgroundDataUrl}")`
      : "none",
    backgroundSize: showLetterheadOnEditor ? "1120px 1584px" : "auto",
    backgroundPosition: "top center",
    backgroundRepeat: "no-repeat",
    border: showLetterheadOnEditor ? "1px solid #777" : "none",
    borderRadius: showLetterheadOnEditor ? 0 : 8,
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    padding: showLetterheadOnEditor ? "0 50px 220px 50px" : "40px 50px 40px 50px",
    boxSizing: "border-box",
    fontFamily: "Calibri, Carlito, Arial, sans-serif",
    fontSize: "11pt",
    lineHeight: 1.15,
  }}
>

<style>{STAFFIQ_RICH_TEXT_TOP_CSS}</style>

{/* KNOPPEN BOVEN */}
              <div
                className="offer-top-actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 8,
                  marginBottom: showLetterheadOnEditor ? 0 : 18,
                  paddingRight: showLetterheadOnEditor ? 0 : 4,
                  flexWrap: "wrap",
                  ...(showLetterheadOnEditor
                    ? {
                        height: 44,
                        alignItems: "center",
                        background: "rgba(255,255,255,0.94)",
                        padding: "6px 8px",
                        borderRadius: 7,
                      }
                    : {}),
                }}
              >
                <button
                  onClick={() => openAiPopup("popup")}
                  style={buttonPrimary("#6f42c1")}
                >
                  ✨ AI
                </button>

                {popupMode !== "preview" ? (
                  <button
                    type="button"
                    onClick={showLiveOfferPreview}
                    style={buttonPrimary("#6c757d")}
                    title="Bekijk de offerte/opdracht zoals deze wordt afgedrukt"
                  >
                    👁 Voorbeeld
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={returnToOfferEdit}
                    style={buttonPrimary("#2f7dd1")}
                    title="Terug naar bewerken"
                  >
                    ✏️ Bewerken
                  </button>
                )}

                {popupMode === "preview" && (
                  <>
                    <button
                      onClick={printOfferPopup}
                      style={buttonPrimary("#6c757d")}
                    >
                      Printen
                    </button>

                    <button
                      onClick={sendOfferEmail}
                      disabled={sendingEmail || !formHasId() || !currentInvoiceEmail}
                      style={
                        sendingEmail || !formHasId() || !currentInvoiceEmail
                          ? { ...buttonPrimary("#198754"), opacity: 0.5, cursor: "not-allowed" }
                          : buttonPrimary("#198754")
                      }
                    >
                      {sendingEmail ? "Bezig..." : "E-mailen"}
                    </button>

                    <button
                      onClick={sendOfferForApproval}
                      disabled={approvalButtonDisabled}
                      style={
                        approvalButtonDisabled
                          ? { ...buttonPrimary("#0d6efd"), opacity: 0.5, cursor: "not-allowed" }
                          : buttonPrimary("#0d6efd")
                      }
                      title={approvalButtonTitle}
                    >
                      {sendingApproval ? "Bezig..." : "Ter akkoord"}
                    </button>
                  </>
                )}

                {popupMode !== "preview" && (
                  <button type="button" onClick={handleSaveWithoutCloseClick} style={buttonPrimary("#2f7dd1")}>Opslaan</button>
                )}
                <button
                  type="button"
                  onClick={handleSaveCloseClick}
                  style={buttonPrimary("#2f7dd1")}
                >
                  {popupMode === "preview" ? "Sluiten" : "Opslaan/Sluiten"}
                </button>

                {popupMode !== "preview" && (
                  <button
                    onClick={annuleerOfferPopup}
                    style={buttonStyle}
                  >
                    Annuleren
                  </button>
                )}
              </div>

              {/* HEADER */}
              <div
                className="offer-document-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginTop: showLetterheadOnEditor ? 190 : 0,
                }}
              >

                {/* LOGO + KLANT */}


                <div>
                  {!useOwnLetterhead ? (
                    effectiveOfferSettings?.logo_url ? (
                      <img
                        src={effectiveOfferSettings.logo_url}
                        alt="logo"
                        style={{ height: 92, marginBottom: 34, objectFit: "contain" }}
                      />
                    ) : (
                      <div style={{ height: 92, marginBottom: 34 }} />
                    )
                  ) : null}

                  <div className="staffiq-offer-fixed-text" style={{ fontFamily: "Calibri, Carlito, Arial, sans-serif", lineHeight: 1.15, fontSize: "11pt" }}>
                    <div style={{ fontWeight: 600, marginBottom: 2 }}>
                      {recipientName || ""}
                    </div>

                    {selectedContact?.attention ? (
                      <div>{selectedContact.attention}</div>
                    ) : null}

                    {recipientAddressLines.map((line, idx) => (
                      <div key={idx}>{line}</div>
                    ))}
                    {letterheadSettings?.show_recipient_phone === true && recipientPhone ? (
                      <div>{recipientPhone}</div>
                    ) : null}
                    {letterheadSettings?.show_recipient_email === true && recipientEmail ? (
                      <div>{recipientEmail}</div>
                    ) : null}
                  </div>
                </div>

{/* BEDRIJF */}
                {!useOwnLetterhead ? (
                <div className="staffiq-offer-fixed-text" style={{ textAlign: "right", fontFamily: "Calibri, Carlito, Arial, sans-serif", lineHeight: 1.15, fontSize: "11pt" }}>
                  {effectiveOfferSettings?.offer_company_name ? (
                    <>
                      <strong>{effectiveOfferSettings.offer_company_name}</strong><br />
                    </>
                  ) : null}

                  {effectiveOfferSettings?.offer_contact_person ? <>{effectiveOfferSettings.offer_contact_person}<br /></> : null}

                  {effectiveOfferSettings?.offer_company_address_1 ? <>{effectiveOfferSettings.offer_company_address_1}<br /></> : null}
                  {effectiveOfferSettings?.offer_company_address_2 ? <>{effectiveOfferSettings.offer_company_address_2}<br /></> : null}

                  {effectiveOfferSettings?.offer_company_postcode || effectiveOfferSettings?.offer_company_city ? (
                    <>{[effectiveOfferSettings.offer_company_postcode, effectiveOfferSettings.offer_company_city].filter(Boolean).join(" ")}<br /></>
                  ) : null}

                  {effectiveOfferSettings?.offer_company_country ? <>{effectiveOfferSettings.offer_company_country}<br /></> : null}

                  {effectiveOfferSettings?.offer_company_email || effectiveOfferSettings?.offer_company_phone ? <><br /></> : null}

                  {effectiveOfferSettings?.offer_company_email ? <>{effectiveOfferSettings.offer_company_email}<br /></> : null}
                  {effectiveOfferSettings?.offer_company_phone ? <>{effectiveOfferSettings.offer_company_phone}<br /></> : null}

                  {effectiveOfferSettings?.offer_company_kvk || effectiveOfferSettings?.offer_company_vat || effectiveOfferSettings?.offer_company_iban || effectiveOfferSettings?.offer_company_g_iban ? <><br /></> : null}

                  {effectiveOfferSettings?.offer_company_kvk ? <>KvK: {effectiveOfferSettings.offer_company_kvk}<br /></> : null}
                  {effectiveOfferSettings?.offer_company_vat ? <>Btw: {effectiveOfferSettings.offer_company_vat}<br /></> : null}
                  {effectiveOfferSettings?.offer_company_iban ? <>Bank: {effectiveOfferSettings.offer_company_iban}{effectiveOfferSettings?.offer_company_g_iban ? <br /> : null}</> : null}
                  {effectiveOfferSettings?.offer_company_g_iban ? <>G-rekening: {effectiveOfferSettings.offer_company_g_iban}</> : null}
                </div>
                ) : null}

              </div>

{/* TITEL + KENMERK */}
<div style={{ marginTop: 32, marginBottom: 18 }}>
  {renderEditableSubject()}

  {form.reference_code ? (
    <div style={{ fontSize: "11pt" }}>
      <span style={{ display: "inline-block", width: 110 }}>Kenmerk:</span>
      {form.reference_code}
    </div>
  ) : null}

  {invoiceTotals.allVerlegd && orgVatNumber ? (
    <div style={{ fontSize: "11pt", marginTop: 4 }}>
      <span style={{ display: "inline-block", width: 110 }}>Btw-id:</span>
      {orgVatNumber}
    </div>
  ) : null}
</div>

{/* DATUMBLOK */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 260px",
                  gap: 20,
                  marginTop: -18,
                  marginBottom: 20,
                }}
              >
                <div />

                <div
                  className="staffiq-offer-date-text"
                  style={{
                    fontFamily: "Calibri, Carlito, Arial, sans-serif",
                    fontSize: "11pt",
                    lineHeight: 1.15,
                    textAlign: "right",
                    position: "relative",
                    top: -8,
                  }}
                >
                  <div>
                    <span style={{ display: "inline-block", width: 100, textAlign: "left" }}>
                      Datum:
                    </span>
                    {formatNlDate(form.invoice_date) || "-"}
                  </div>
                  <div>

                  </div>
                </div>
</div>

{popupMode !== "preview" && (
  <div
    className="offer-edit-label"
    style={{
      marginBottom: 12,
      fontSize: 12,
      color: "#5d6b78",
    }}
  >
    Klik in een tekstblok. Alleen bij dat blok verschijnt de opmaakregel.
  </div>
)}

{(() => {
  const { beforeTotals } = splitDocumentOrderAroundTotals();
  return (
    <>
      {renderOrderedDocumentItems(beforeTotals)}
      {renderNewOfferLineBlock()}
      {lineError && (
        <div style={{ marginTop: 10, color: "crimson", fontSize: 13 }}>
          {lineError}
        </div>
      )}
    </>
  );
})()}

<div className="offer-total-footer-block">

<div className="offer-total-footer-block">
  {/* TOTALEN */}
  <div className="offer-totals-block" style={{ marginTop: 3 }}>
    <div
      style={{
        display: "grid",

gridTemplateColumns: offerLineGridTemplate(),
        columnGap: 12,
        rowGap: 1,
        fontFamily: "Calibri, Carlito, Arial, sans-serif",
        fontSize: "11pt",
        lineHeight: 1.15,
        alignItems: "center",
      }}
    >
      <div></div>
      <div></div>
      <div></div>
      <div style={{ textAlign: "right" }}>Subtotaal</div>
      <div style={{ textAlign: "right" }}>{euro(invoiceTotals.subtotal)}</div>
      {!invoiceTotals.hideVatColumnOnInvoice && <div></div>}
      {popupMode !== "preview" && <div></div>}

      {invoiceTotals.vatRows.map((row) => (
        <React.Fragment key={row.rate}>
          <div></div>
          <div></div>
          <div></div>
          <div style={{ textAlign: "right" }}>{row.label}</div>
          <div style={{ textAlign: "right" }}>{euro(row.vat)}</div>
          {!invoiceTotals.hideVatColumnOnInvoice && <div></div>}
          {popupMode !== "preview" && <div></div>}
        </React.Fragment>
      ))}

      <div></div>
      <div></div>
      <div></div>
      <div
        style={{
          borderTop: "2px solid #222",
          paddingTop: 8,
          textAlign: "right",
          fontWeight: 700,
        }}
      >
        Totaal
      </div>
      <div
        style={{
          borderTop: "2px solid #222",
          paddingTop: 8,
          textAlign: "right",
          fontWeight: 700,
        }}
      >
        {euro(invoiceTotals.total)}
      </div>
      {!invoiceTotals.hideVatColumnOnInvoice && <div></div>}
      {popupMode !== "preview" && <div></div>}
    </div>
  </div>

{(() => {
  const { afterTotals } = splitDocumentOrderAroundTotals();
  return <>{renderOrderedDocumentItems(afterTotals)}</>;
})()}

{popupMode === "preview" ? (
  effectiveDocumentTexts.document_show_agreement_block === true ? (
    <div className="staffiq-offer-agreement" style={{ marginTop: 28, border: "1px solid #777", padding: 14, width: "60%", minHeight: 120, fontFamily: "Calibri, Carlito, Arial, sans-serif", fontSize: "11pt", lineHeight: 1.8, whiteSpace: "pre-wrap", ...fixedOfferTextStyle(effectiveDocumentTexts.document_agreement_text) }}>
      <div style={{ fontWeight: 700, marginBottom: 8, fontFamily: "Calibri, Carlito, Arial, sans-serif" }}>Voor akkoord:</div>
      <div dangerouslySetInnerHTML={{ __html: normalizeRichTextHtml(effectiveDocumentTexts.document_agreement_text || "Naam:________________________________________\nDatum:_______________________________________") }} />
    </div>
  ) : null
) : effectiveDocumentTexts.document_show_agreement_block === true ? (
  <div style={{ marginTop: 18, padding: 10, border: "1px solid #d9d9d9", borderRadius: 6, background: "#fff", width: "60%", boxSizing: "border-box" }}>
    <div style={{ fontWeight: 700, marginBottom: 6 }}>Akkoordtekst</div>
    <div style={{ marginTop: 8 }}>
      <div style={{ fontWeight: 700, marginBottom: 6 }}>Voor akkoord:</div>
      <RichTextEditor value={effectiveDocumentTexts.document_agreement_text || "Naam:________________________________________\nDatum:_______________________________________"} minHeight={100} placeholder="Akkoordtekst" toolbarVisible={activeDocumentEditorKey === "document_agreement_text"} onActivate={() => setActiveDocumentEditorKey("document_agreement_text")} onChange={(nextValue) => { documentTextDraftRef.current.document_agreement_text = nextValue; updateDocumentText("document_agreement_text", nextValue); }} />
    </div>
  </div>
) : null}

{/* VOETREGEL */}
  {!useOwnLetterhead && safeTrim(effectiveOfferSettings?.offer_footer_text) ? (
    <div
      className="offer-footer-block"
      style={{
        marginTop: 18,
        borderTop: "none",
        paddingTop: 0,
        fontSize: 12,
        color: "#555",
        whiteSpace: "pre-wrap",
        width: "68%",
        maxWidth: "68%",
        ...fixedOfferTextStyle(effectiveOfferSettings?.offer_footer_text),
      }}
    >
      {String(effectiveOfferSettings?.offer_footer_text || "")}
    </div>
  ) : null}

{/* KNOPPEN ONDER */}
  <div
    className="offer-bottom-actions"
    style={{
      display: "flex",
      justifyContent: "flex-end",
      gap: 8,
      marginTop: 28,
      paddingRight: 4,
      flexWrap: "wrap",
    }}
  >
    <button
      onClick={() => openAiPopup("popup")}
      style={buttonPrimary("#6f42c1")}
    >
      ✨ AI
    </button>

{popupMode !== "preview" ? (
  <button
    type="button"
    onClick={showLiveOfferPreview}
    style={buttonPrimary("#6c757d")}
    title="Bekijk de offerte/opdracht zoals deze wordt afgedrukt"
  >
    👁 Voorbeeld
  </button>
) : (
  <button
    type="button"
    onClick={returnToOfferEdit}
    style={buttonPrimary("#2f7dd1")}
    title="Terug naar bewerken"
  >
    ✏️ Bewerken
  </button>
)}

{popupMode === "preview" && (
      <>
        <button
          onClick={printOfferPopup}
          style={buttonPrimary("#6c757d")}
        >
          Printen
        </button>

        <button
          onClick={sendOfferEmail}
          disabled={sendingEmail || !formHasId() || !currentInvoiceEmail}
          style={
            sendingEmail || !formHasId() || !currentInvoiceEmail
              ? { ...buttonPrimary("#198754"), opacity: 0.5, cursor: "not-allowed" }
              : buttonPrimary("#198754")
          }
        >
          {sendingEmail ? "Bezig..." : "E-mailen"}
        </button>

        <button
          onClick={sendOfferForApproval}
          disabled={approvalButtonDisabled}
          style={
            approvalButtonDisabled
              ? { ...buttonPrimary("#0d6efd"), opacity: 0.5, cursor: "not-allowed" }
              : buttonPrimary("#0d6efd")
          }
          title={approvalButtonTitle}
        >
          {sendingApproval ? "Bezig..." : "Ter akkoord"}
        </button>
      </>
    )}

{popupMode !== "preview" && (
  <button type="button" onClick={handleSaveWithoutCloseClick} style={buttonPrimary("#2f7dd1")}>Opslaan</button>
)}
<button
  type="button"
  onClick={handleSaveCloseClick}
  style={buttonPrimary("#2f7dd1")}
>
  {popupMode === "preview" ? "Sluiten" : "Opslaan/Sluiten"}
</button>

{popupMode !== "preview" && (
  <button
    onClick={annuleerOfferPopup}
    style={buttonStyle}
  >
    Annuleren
  </button>
)}
  </div>
</div>

</div>

</div>
</div>
)}

{(letterheadPdfPreviewBusy || letterheadPdfPreviewUrl || letterheadPdfPreviewError) && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 100005,
      background: "rgba(0,0,0,0.55)",
      padding: 14,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      gap: 10,
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        background: "#fff",
        padding: "8px 10px",
        borderRadius: 8,
        boxShadow: "0 5px 18px rgba(0,0,0,0.25)",
      }}
    >
      <button
        type="button"
        onClick={closeLetterheadPdfPreview}
        disabled={letterheadPdfPreviewBusy}
        style={buttonPrimary("#2f7dd1")}
      >
        ✏️ Bewerken
      </button>
      <button
        type="button"
        onClick={printLetterheadPdfPreview}
        disabled={letterheadPdfPreviewBusy || !letterheadPdfPreviewUrl}
        style={
          letterheadPdfPreviewBusy || !letterheadPdfPreviewUrl
            ? { ...buttonPrimary("#6c757d"), opacity: 0.5, cursor: "not-allowed" }
            : buttonPrimary("#6c757d")
        }
      >
        Printen
      </button>
      <button
        type="button"
        onClick={sendOfferEmail}
        disabled={letterheadPdfPreviewBusy || sendingEmail || !formHasId() || !currentInvoiceEmail}
        style={
          letterheadPdfPreviewBusy || sendingEmail || !formHasId() || !currentInvoiceEmail
            ? { ...buttonPrimary("#198754"), opacity: 0.5, cursor: "not-allowed" }
            : buttonPrimary("#198754")
        }
      >
        {sendingEmail ? "Bezig..." : "E-mailen"}
      </button>
      <button
        type="button"
        onClick={sendOfferForApproval}
        disabled={letterheadPdfPreviewBusy || approvalButtonDisabled}
        style={
          letterheadPdfPreviewBusy || approvalButtonDisabled
            ? { ...buttonPrimary("#0d6efd"), opacity: 0.5, cursor: "not-allowed" }
            : buttonPrimary("#0d6efd")
        }
        title={approvalButtonTitle}
      >
        {sendingApproval ? "Bezig..." : "Ter akkoord"}
      </button>
      <button
        type="button"
        onClick={closeLetterheadPdfPreview}
        disabled={letterheadPdfPreviewBusy}
        style={buttonPrimary("#2f7dd1")}
      >
        Sluiten
      </button>
    </div>

    <div
      style={{
        flex: 1,
        minHeight: 0,
        width: "min(1120px, 100%)",
        margin: "0 auto",
        background: "#707070",
        borderRadius: 6,
        overflow: "hidden",
        boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
      }}
    >
      {letterheadPdfPreviewBusy ? (
        <div style={{ color: "white", padding: 24, fontSize: 16 }}>
          PDF-voorbeeld wordt opgebouwd…
        </div>
      ) : letterheadPdfPreviewError ? (
        <div style={{ color: "#b00020", background: "white", margin: 20, padding: 16, borderRadius: 6 }}>
          {letterheadPdfPreviewError}
        </div>
      ) : (
        <iframe
          ref={letterheadPdfPreviewFrameRef}
          title="PDF voorbeeld offerte/opdracht"
          src={letterheadPdfPreviewUrl}
          style={{
            width: "100%",
            height: "100%",
            minHeight: "calc(100vh - 95px)",
            border: 0,
            background: "#707070",
          }}
        />
      )}
    </div>
  </div>
)}

{aiOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.35)",
      zIndex: 100000,
      padding: isMobile ? 10 : 24,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        width: isMobile ? "100%" : 900,
        height: isMobile ? "92vh" : "82vh",
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 20px 70px rgba(0,0,0,0.30)",
        padding: 18,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          marginBottom: 12,
        }}
      >
<h2 style={{ margin: 0 }}>
  {aiSource === "popup" ? "AI Opdracht (Offerte)" : "AI Opdrachten (Offertes)"}
</h2>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button onClick={printAiDocument} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Printen
          </button>
          <button
            onClick={startAiSpeak}
            disabled={!voice.supported || voice.listening || aiBusy}
            style={!voice.supported || voice.listening || aiBusy ? buttonDisabledStyle : buttonStyle}
          >
            {voice.listening ? "🎤 Luistert…" : "🎤 Spreek"}
          </button>
          <button onClick={closeAiPopup} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Sluiten
          </button>
        </div>
      </div>

      <div style={{ marginBottom: 10, fontWeight: 700 }}>Kies een actie:</div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr 1fr",
          gap: 8,
          marginBottom: 14,
        }}
      >
        <button onClick={runAiOrganisationData} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
          Relatie gegevens
        </button>

        {aiSource === "popup" ? (
          <button onClick={runAiOfferCheck} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Opdracht (Offerte) controleren
          </button>
        ) : (
          <button onClick={runAiContactData} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Contactpersoon gegevens
          </button>
        )}

        <button onClick={runAiDossierOverview} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
          Dossier overzicht
        </button>

        <button onClick={runAiChat} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
          Chat met AI
        </button>
      </div>

      <div style={{ marginBottom: 8, fontWeight: 700 }}>AI venster</div>

      <textarea
        ref={aiTextRef}
        value={aiText}
        onChange={(e) => setAiText(e.target.value)}
        placeholder="Klik op een AI-keuze, of typ hier je vraag voor Chat met AI."
        style={{
          width: "100%",
          flex: 1,
          minHeight: 0,
          padding: 12,
          border: "1px solid #ccc",
          borderRadius: 8,
          fontFamily: "inherit",
          fontSize: 15,
          lineHeight: 1.45,
          boxSizing: "border-box",
          resize: "none",
          whiteSpace: "pre-wrap",
          overflowY: "auto",
        }}
      />
    </div>
  </div>
)}
</>
);
}